import { Component } from "react";
import { v4 as uuidv4 } from 'uuid';
import SourcesPanel from "./SourcePanelNoteBook";
import { withRouter, Link } from 'react-router-dom';
import { imsLoader, GenAiDOCIcon, GenAiPDFIcon, GenAiPPTIcon, JJ_IMedical_icon } from '../../assets/index';
import SummaryPanel from "./SummaryPanel";
import ApiServices from "../../utils/apiServices";
import { Authentication } from "../../utils/authenticationUtilityServices";
import axios from "axios";
import { clone, uniq } from 'underscore';
import moment from "moment";
import DOMPurify from "dompurify";
import { LocationOrigin, getCurrentDate, WordsMaxLength, DocmentTypeForProtocolNo } from '../../utils/utilityServices';
import NoteBookUser from "./NoteBookUser";
import { GenAI2DocTypes } from '../../utils/documentTypeUtilityServices';
import GenAIAuthoringDisplayString from "../GenAIAnswering2.0/GenAIAuthoringDisplayString";
import trackingService from "../../services/trackingService";
import { error, isEmptyObject } from "jquery";
import NoteBookProjectService from "../../services/NoteBookProjectSevice";
import { UserData } from "../../auth/Authorization";
import { Modal } from "react-bootstrap";
import { createRef } from "react";
import NoteBookPromptTemplates from "../PopUp/NoteBookPromptTemplates";
import AlertMessagePopUpModal from "../GenAIPopUp/AlertMessagePopUpModal";
import NoteBookSlider from "./NoteBookSlider";
import ExpandContentModalNoteBook from "./PopUpGenAINoteBook/ExpandContentModalNoteBook";
import { NoteBookConfigurePopUp } from "./PopUpGenAINoteBook/NoteBookConfigurePopUp";
import GenAIAuthoringDisplayStringMultiCommand from "../GenAIAnswering2.0/GenAIAuthoringDisplayStringMultiCommand";
import ChatSkeleton from "./PopUpGenAINoteBook/BubbleLoader";


let _locationOrigin = LocationOrigin;
//_locationOrigin = 'https://predev-ims.jnj.com'
var guid = uuidv4();
var _threadGuid = uuidv4();
const services = new ApiServices();
const ShowWordCountForCommandType = ['Translate', 'CreateTable'];
let _timeoutTime = (1000 * (300));
const summarizeResult = 'SummarizeResult';
const userQuestion = 'UserQuestion';
const sanitize = DOMPurify.sanitize;
const ReactNone = 'None';
let aps = new NoteBookProjectService();

class NoteBookAuthoringIndex extends Component {
    constructor(props) {
        super(props);
        this.messagesEnd = createRef();
        this.state = {
            customWidth: props.customWidth,
            customHeight: props.customHeight,
            //sessionID: props.sessionID ? props.sessionID : guid,
            //attachedFiles: (props.location.state.attachedFiles )? props.attachedFiles : [],
            selectedNotebookName: (props.location.state && props.location.state.noteBookName) ? props.location.state.noteBookName : 'Untitled NoteBook',
            selectedAttachedFiles: props.location.state?.attachedFiles ? props.location.state.attachedFiles : (props.attachedFiles) ? props.attachedFiles : [],
            sessionID: (props.location.state && props.location.state.sessionID) ? props.location.state.sessionID : (props.match.params && props.match.params.id) ? props.match.params.id : (props.sessionID) ? props.sessionID : guid,
            question: props.location.state ? props.location.state.newQuestion : null,
            attachedFiles: [],//props.location.state?.attachedFiles ? props.location.state.attachedFiles : (props.attachedFiles) ? props.attachedFiles : [],
            threadID: (props.location.state && props.location.state.threadID) ? props.location.state.threadID : _threadGuid,
            //selectedFilters: props.location.state ? props.location.state.selectedFilters : [],
            //path: props.location.state ? props.location.state.path : '/genAIAnswering',
            //showDisclaimerPopup: _showDisclaimerPopup,
            collapsed: false,
            chatHistory: [],
            commandText: '',
            commandType: (props.location.state?.isFromAuthoringSideBar) ? 'UserInstructions' : 'QnA',
            citationText: '',
            isCitationProcessing: false,
            selectedAttachedFileguid: (props.location.state?.attachedFiles && props.location.state?.attachedFiles?.length > 0) ? props.location.state.attachedFiles[0].guid : (props.attachedFiles && props.attachedFiles?.length > 0) ? props.attachedFiles[0].guid : '',
            selectedPageNo: 1,
            expandCommand: false,
            savingCommandText: '',
            showCommandList: false,
            isUserCommand: true,
            isTemplateCommand: false,
            isFromGlobalFeaturesMenu: false,
            chatConversation: [],
            isProcessing: false,
            spinnerMessage: '',
            isGraph: false,
            selectedGraph: '',
            allFileContent: {
            },
            openEditor: true,
            orignalText: '',
            summarizeText: '',
            firstCall: true,
            previousOrignalText: '',
            isConfirm: false,
            isClearAllFields: true,
            alertMessageModelColor: "",
            alertMessageContent: "",
            alertMessageShowModal: false,
            isChangePage: false,
            isShowPrompt: false,
            isUserPromptTemplate: false,
            isSystemPromptTemplate: false,
            isCreatePromptTemplate: false,
            createUserPromptTemplates: [],
            isFileContainsImage: false,
            isMultiQuestionProcessing: false,
            selectedNotebook: null,
            isNewNotebook: false,
            savingSummarizeText: '',
            savingCommandType: 'QnA',
            savingOrignalText: '',
            savingCommandText: '',
            savingReference: '',
            expandNotes: false,
            notesText: "",
            expandAllFields: false,
            successMessage: "",
            showSuccess: false,
            expandSource: false,
            uploadFilePlaceHolder: "Upload Documents",
            showPreview: false,
            previewURL: false,
            newAttachedFiles: [],
            newThreadID: "",
            removedAttachedFileIndex: -1,
            sliderValue: 14,
            allDocContent: '',
            combined_summary: "",
            height: window.innerHeight,
            selectedProjectType: (props.location.state && props.location.state.selectedProjectType) ? props.location.state.selectedProjectType : {},
            prompts: [],
            isFirstQuestion: true,
            savedSummary: [],
            savedNotes: [],
            expandSourceText: false,
            isExistingProject: (props.match.params && props.match.params.id) ? true : false,
            editText: '',
            editQuestion: '',
            isQuestionBoxHeightChanged: false,
            disableSubmit: false,
            //(props.location.state?.attachedFiles && props.location.state?.attachedFiles?.length > 0) ? props.location.state.attachedFiles[0].guid : (props.attachedFiles && props.attachedFiles?.length > 0) ? props.attachedFiles[0].guid : ''
            selectedFileSource: [],
            selectedFileGuidSource: [],
            isConfigure: false,
            configActiveTab: 0,
            configResponseLength: 'Default',
            configConversationa: '',
            leftIsProcessing: false,
            leftSpinnerMessage: '',
            middleIsProcessing: false,
            middleSpinnerMessage: '',
            rightIsProcessing: false,
            rightSpinnerMessage: '',
            isProcessingNew: false,
            isChatConversationSpinner: false,
            citationTextId: '',
            isSorcePanelSelectAll: false,
        }
    }
    componentDidMount = async () => {
        if (this.props.match.params && this.props.match.params.id && this.state.isExistingProject) {
            //await this.getProjectName(this.props.match.params.id)
            localStorage.setItem("isSelectAll", "true")
            this.setState({
                leftIsProcessing: true, leftSpinnerMessage: '',
                middleIsProcessing: true, middleSpinnerMessage: 'Please wait while getting the things ready',
                rightIsProcessing: true, rightSpinnerMessage: ''
            })
            await this.getAuthoringProjectDataBySessionId(this.props.match.params.id)
            await this.fetchConfigDataFromDb(this.props.match.params.id);
            this.setState({ middleIsProcessing: false, middleSpinnerMessage: '' })
            await this.getAllFileFromS3();
            await this.fetchSourceTextFromDb(this.props.match.params.id);
            this.setState({ leftIsProcessing: false, leftSpinnerMessage: '' })
            await this.fetchSummary(this.props.match.params.id);
            await this.getAllNoteBookNotes(this.props.match.params.id);
            this.setState({ rightIsProcessing: false, rightSpinnerMessage: '',/*selectedFileSource: this.state.attachedFiles*/ })

        } else if (this.props.location.state && this.props.location.state.sessionID) {
            let data = this.props.location.state;
            this.props.history.replace({
                pathname: `/Authoring-AI-Search/${this.props.location.state.sessionID}`,
                state: data,
            })
            if (this.props.location.state.selectedProjectType.project_type_name && this.props.location.state.selectedProjectType.project_type_name === "Plain Language Summary Poster") {
                localStorage.setItem("isSelectAll", "true")
            }
            this.setState({ leftIsProcessing: true, middleIsProcessing: true })
            await this.getAllFileFromS3();
            await this.fetchSourceTextFromDb(this.props.location.state.sessionID);
            this.setState({ leftIsProcessing: false })
            await this.fetchConfigDataFromDb(this.props.location.state.sessionID);
            this.setState({ middleIsProcessing: false })
        }
        if (this.props.location.state && this.props.location.state.selectedProjectType) {
            await this.getAllPrompts(this.props.location.state.selectedProjectType)
            if (this.state.attachedFiles && this.state.attachedFiles.length > 0) {
                await this.handleFullText(this.state.attachedFiles)
            }//else obtain from S3 bucket
            let prompts = (this.props.location.state.prompts) ? this.props.location.state.prompts : [];
            if (this.props.location.state.selectedProjectType.project_type_name && this.props.location.state.selectedProjectType.project_type_name === "Plain Language Summary Poster" && !this.state.isExistingProject) {
                let query = prompts?.map(x => {
                    let finalAns = "";
                    if (x.readingLevel) {
                        finalAns += `Answer this question about the study as if you were a medical writer explaining to an ${x.readingLevel}th grader`
                    }
                    finalAns += ` "${x.prompt}" Use simple language`
                    if (x.wordLimit) {
                        finalAns += ` and less than ${x.wordLimit} words\r\n*|*\r\n`
                    }
                    return finalAns;
                })
                // localStorage.setItem("isSelectAll", "true")
                this.setState({
                    commandText: query.join(''),
                    selectedFileSource: this.state.attachedFiles,
                    commandType: 'QnA'
                }, async () => {
                    await this.onSubmitClick();
                })
            }
        }

    }
    getProjectName = async (sessionID) => {
        let services = new ApiServices()
        if (sessionID) {
            let res = await services.getGenAINoteBooKDataSessionId(UserData.sub, sessionID)
            if (res) {
                this.setState({ selectedNotebookName: res[0].notebook_name })
            }
        }
    }
    async getAuthoringProjectDataBySessionId(sessionID) {
        this.setState({ isProcessing: true })
        if (UserData && UserData.sub) {
            let response = await aps.getNoteBookProjectDataBySessionId(UserData.sub, sessionID)
            if (response && response.data.length > 0) {
                let _chatConversation = this.state.chatConversation;
                let { chatHistory } = this.state;
                let _question = "", _attachedFiles = [], _threadID = '', _isMultiFileThread = false,
                    _threadAttachedFiles = [], _projectName = "", _projectType = {}, _prompts = [];
                let threadGuid = uuidv4();
                response.data.map((threadItem, threadIndex) => {
                    _threadAttachedFiles = [];
                    let source = threadItem._source;
                    let _chatHistoryThreadID = '';
                    if (threadIndex === 0) {
                        _question = source.notebookinfo.question;
                        if (source.notebookinfo.projectName) {
                            _projectName = source.notebookinfo.projectName;
                        }
                        if (source.notebookinfo.projectType) {
                            _projectType = source.notebookinfo.projectType;
                        }

                    }
                    if (threadIndex === (response.data.length - 1)) {
                        if (source.notebookinfo.attachedFiles) {
                            _attachedFiles = source.notebookinfo.attachedFiles;
                        }
                        if (source.notebookinfo.thread_id && _attachedFiles.length === 0) {
                            _threadID = source.notebookinfo.thread_id;
                        } else {
                            _threadID = threadGuid;
                        }
                        _isMultiFileThread = _attachedFiles.length > 0;
                    }
                    if (source.notebookinfo.attachedFiles && source.notebookinfo.attachedFiles.length > 0) {
                        _threadAttachedFiles = clone(source.notebookinfo.attachedFiles);
                    }
                    if (source.notebookinfo.thread_id) {
                        _chatHistoryThreadID = source.notebookinfo.thread_id;
                    }
                    if (source.notebookinfo.output_answer) {
                        chatHistory.push({ question: source.notebookinfo.question, answer: source.notebookinfo.output_answer, threadID: _chatHistoryThreadID ? _chatHistoryThreadID : sessionID });
                    } else {
                        chatHistory.push({ question: source.notebookinfo.question, answer: "", threadID: _chatHistoryThreadID ? _chatHistoryThreadID : sessionID });
                    }
                    _prompts.push({
                        prompt: source.notebookinfo.question,
                        wordLimit: source.notebookinfo.wordLimit ? source.notebookinfo.wordLimit : '',
                        readingLevel: source.notebookinfo.readingLevel ? source.notebookinfo.readingLevel : ''
                    })
                    if (source.notebookinfo.commandType === 'Summarize' || source.notebookinfo.commandType === 'UserInstructions' || source.notebookinfo.commandType === "source_text_QnA" || source.notebookinfo.commandType === 'CreateTable') {
                        //question push//
                        _chatConversation.push({
                            from: userQuestion,
                            message: source.notebookinfo.question,
                            messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`,
                            messageTime: {},
                            documentInfo: {},
                            commandType: source.notebookinfo.commandType,
                            IsSucceed: true,
                            isFromOriginalText: true
                        })
                        //answer push//
                        _chatConversation.push({
                            _commandType: source.notebookinfo.commandType,
                            from: summarizeResult,
                            message: source.notebookinfo.summarizeText,
                            messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`,
                            messageTime: {},
                            documentInfo: {},
                            commandText: source.notebookinfo.commandType === 'UserInstructions' ? source.notebookinfo.commandText : source.notebookinfo.question,
                            orignalText: source.notebookinfo.question,
                            IsSucceed: true,
                            isFromOriginalText: true
                        })
                    } else {
                        //question push//
                        _chatConversation.push({
                            from: "UserQuestion",
                            _commandType: "QnA",
                            IsSucceed: true,
                            message: source.notebookinfo.question,
                            messageTimeInText: `${moment().format("hh:mm a")}`, messageTime: { moment },
                            messageTime: {},
                            eventid: source.eventinfo.eventid,
                            isMultiFiles: source.notebookinfo.attachedFiles.length > 0,
                            threadID: _chatHistoryThreadID ? _chatHistoryThreadID : sessionID,
                            lastCreatedDatehour: source.notebookinfo.lastcreateddatehour ? source.notebookinfo.lastcreateddatehour : source.eventinfo.createddatehour,
                            threadAttachedFiles: _threadAttachedFiles,
                            isGetAnyAns: source.notebookinfo.isGetAnyAns,
                            isSuccess: source.notebookinfo.isSuccess,
                            isFromOriginalText: false

                        })
                        //response push//
                        _chatConversation.push({
                            IsSucceed: true,
                            Question: source.notebookinfo.question,
                            OutputAnswer: source.notebookinfo.output_answer,
                            messageTimeInText: `${moment().format("hh:mm a")}`, messageTime: { moment },
                            questionType: source.notebookinfo.question_type,
                            eventid: source.eventinfo.eventid,
                            isMultiFiles: source.notebookinfo.attachedFiles.length > 0,
                            DisplayStringMultiFiles: source.notebookinfo.display_string_multi_files ? source.notebookinfo.display_string_multi_files : [],
                            SourcesMultiFiles: source.notebookinfo.sources_multi_files_list ? source.notebookinfo.sources_multi_files_list : [],
                            combinedSummaryMultiFiles: source.notebookinfo.combined_summary_multi_files
                                ? source.notebookinfo.combined_summary_multi_files : source.notebookinfo.combined_summary_multi_files_list
                                    ? source.notebookinfo.combined_summary_multi_files_list : "",
                            threadID: _chatHistoryThreadID ? _chatHistoryThreadID : sessionID,
                            Reaction: source.notebookinfo.answer_reaction ? source.notebookinfo.answer_reaction : ReactNone,
                            Feedback: source.notebookinfo.answer_feedback ? source.notebookinfo.answer_feedback : '',
                            isGetAnyAns: source.notebookinfo.isGetAnyAns,
                            isSuccess: source.notebookinfo.isSuccess,
                            lastCreatedDatehour: source.notebookinfo.lastcreateddatehour ? source.notebookinfo.lastcreateddatehour : source.eventinfo.createddatehour,
                            threadAttachedFiles: _threadAttachedFiles,
                            finalPrompt: source.notebookinfo.finalPrompt ? source.notebookinfo.finalPrompt : '',
                            wordLimit: source.notebookinfo.wordLimit ? source.notebookinfo.wordLimit : '',
                            readingLevel: source.notebookinfo.readingLevel ? source.notebookinfo.readingLevel : '',
                            _commandType: source.notebookinfo.commandType ? source.notebookinfo.commandType : 'QnA',
                            summarizeText: source.notebookinfo.summarizeText ? source.notebookinfo.summarizeText : ''
                        })
                    }
                })
                /*if (_isMultiFileThread && !this.state.isRedirectOnGenAISearch) {
                    let response = await ts.deleteIndexBySessionId(sessionID);
                }*/

                this.setState({
                    chatConversation: _chatConversation,
                    isProcessing: false,
                    newQuestion: '',
                    chatHistory: chatHistory,
                    isFirstQuestion: false,
                    question: _question,
                    //attachedFiles: _attachedFiles,
                    threadID: _threadID ? _threadID : sessionID,
                    isMultiFileThread: _isMultiFileThread,
                    isRedirectOnGenAISearch: false,
                    //selectedNotebookName: _projectName,
                    selectedProjectType: _projectType,
                    //prompts: _prompts,
                }, async () => {
                    await this.getAllPrompts(_projectType)
                    //sthis.scrollToBottom();
                    //this.updateAuthoringProjectDatehour();
                })

            }
            else if (this.props.location.state && this.props.location.state.sessionID && this.props.location.state.newQuestion) {
                let { attachedFiles, prompts } = this.state;
                if (attachedFiles.length > 0 && prompts.length > 0) {
                    this.processMultiPrompts(prompts);
                }
            }
        }
    }
    updateSelectAll = async (val) => {
        this.setState({ isSorcePanelSelectAll: val })
    }

    fetchSourceTextFromDb = async (sessionId) => {
        let { attachedFiles, selectedFileSource, isSorcePanelSelectAll } = this.state
        this.setState({ isProcessing: true })
        try {
            let resSourceText = await services.getGenAINootBookSourceText(sessionId);
            if (resSourceText.length > 0) {
                this.setState({ isProcessing: false });
                resSourceText.forEach((x, index) => {
                    if (x.source_text) {
                        this.handleAddToSource(x.source_text, x.id, x.name);
                    }
                });
            } else {
                let fil_Source = isSorcePanelSelectAll ? attachedFiles : selectedFileSource;
                this.setState({ selectedFileSource: fil_Source })
            }
        } catch (error) {
            console.log(error)
        } finally {
            this.setState({ isProcessing: false })
        }
    }
    fetchConfigDataFromDb = async (sessionId) => {
        try {
            let res = await services.getConfigData(sessionId, UserData.sub)
            if (res[0]) {
                this.setState({
                    configActiveTab: (res[0].config_tab) ? res[0].config_tab : 0,
                    configConversationa: (res[0].config_conversation) ? res[0].config_conversation : '',
                    configResponseLength: (res[0].config_response_length) ? res[0].config_response_length : 'Default',
                })
            }
        } catch (error) {
            console.log(error)
        }
    }
    updateSourceTextOfDb = async (text, id, notebookName) => {
        let { selectedFileSource } = this.state
        this.setState({ isProcessingNew: true, spinnerMessage: 'Please wait while we set things up for you...' })
        try {
            let res = await services.updateGenAINoteBookSourceText(text, id, notebookName);
            if (res) {
                this.setState({ isProcessingNew: false, spinnerMessage: '' })
            }
        } catch (error) {
            console.log(error)
        } finally {
            let filterattachedFiles = this.state.attachedFiles.filter(x => !x.name.toLowerCase().endsWith('.txt'))
            this.setState({ attachedFiles: filterattachedFiles });
            this.setState({ leftIsProcessing: true })
            await this.fetchSourceTextFromDb(this.state.sessionID);
            if (selectedFileSource.length > 0) {
                let new_selected_source = this.state.selectedFileSource
                let filterselected = this.state.selectedFileSource.filter(x => x.id === id)[0];
                if (filterselected) {
                    filterselected.fullText = text;
                    let indexfilter = this.state.selectedFileSource.map((x, index) => {
                        if (x.id === id) {
                            return index
                        }
                    })
                    new_selected_source[indexfilter] = filterselected;
                    this.setState({ selectedFileSource: new_selected_source })
                }
            }
            this.setState({ leftIsProcessing: false, isProcessingNew: false, spinnerMessage: '' })
        }
    }
    insertSourceTextToDb = async (source_text) => {
        let { sessionID, attachedFiles } = this.state
        this.setState({ isProcessingNew: true })

        let notebookName = `${moment().format("YYYYMMDDhhmmss")}.txt`
        try {
            let res = await services.postGenAINootBookSourceText(sessionID, source_text, notebookName);
            if (res) {
                //this.setState({ isProcessing: false });
                let filterattachedFiles = this.state.attachedFiles.filter(x => !x.name.toLowerCase().endsWith('.txt'))
                this.setState({ attachedFiles: filterattachedFiles, isProcessingNew: false, spinnerMessage: '' })
                this.setState({ leftIsProcessing: true })
                await this.fetchSourceTextFromDb(sessionID);
            }
        } catch (err) {
            console.log(error)
        } finally {
            this.setState({ leftIsProcessing: false })
        }
    }
    handleConfigSave = async (activeTab, conver, responseLength) => {
        let { sessionID } = this.state
        this.setState({ isProcessingNew: true, spinnerMessage: 'Saving configuration,please wait..' })
        this.setState({
            configActiveTab: activeTab,
            configConversationa: conver,
            configResponseLength: responseLength
        })
        await services.updateGenAINoteBook(activeTab, conver, responseLength, sessionID, UserData.sub).then((res) => {
            this.setState({ isProcessingNew: false, spinnerMessage: '' })
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            this.setState({ isConfigure: false })
        })
    }
    fetchSummary = async (sessionID) => {
        this.setState({ isProcessing: true })
        let resSummary = await services.getAllNoteBookGenAISummary(sessionID);
        this.setState({ savedSummary: resSummary, isProcessing: false })
    }
    updateSummary = async (id, summary) => {
        const { sessionID } = this.state
        this.setState({ isProcessingNew: true, spinnerMessage: '' })
        await services.updateNoteBookGenAISummary(id, summary)
        this.setState({ isProcessingNew: false, spinnerMessage: '' })
        this.successAlertMessage('Summary updated successfully')
        this.setState({ rightIsProcessing: true })
        await this.fetchSummary(sessionID);
        this.setState({ rightIsProcessing: false })
    }
    deleteSummary = async (id) => {
        const { sessionID } = this.state;
        this.setState({ isProcessingNew: true, spinnerMessage: '' })
        await services.deleteNoteBookGenAISummary(id);
        this.setState({ isProcessingNew: false, spinnerMessage: '' })
        this.successAlertMessage('Summary deleted successfully');
        this.setState({ isProcessingNew: false, spinnerMessage: '' })
        this.setState({ rightIsProcessing: true })
        await this.fetchSummary(sessionID);
        this.setState({ rightIsProcessing: false })
    }
    getAllFileFromS3 = async () => {
        let { sessionID, attachedFiles } = this.state;
        let _attachedFiles = [];
        var URL = `${_locationOrigin}/api/NotebookService/S3File/GetAllFileKey/${sessionID}`
        if (window.location.origin === 'https://predev-ims.jnj.com') {
            URL = `${window.location.origin}/api/NotebookService/S3File/GetAllFileKey/${sessionID}`
        }
        const _headers = {
            'Content-Type': 'application/json'
        }
        if (await Authentication.isAccessTokenAvailable()) {
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }
        await axios.get(URL, {
            headers: _headers
        }).then(async (res) => {
            let response = res.data;
            if (response.AllFileKey) {
                _attachedFiles = await Promise.all(response.AllFileKey.map(async (val) => {
                    if (val.FileKey) {
                        return await this.getFileFromS3(val)
                    }
                })
                )
            }
        }).catch((error) => {
            console.log(error);
            this.errorAlertMessage('Something went wrong while fetching the files.')
        }).finally(() => {
            this.setState({ attachedFiles: _attachedFiles, selectedAttachedFileguid: _attachedFiles.length > 0 ? _attachedFiles[0].guid : '' })
            if (_attachedFiles.length > 0) {
                this.handleFullText(_attachedFiles)
            }
        })
    }
    getFileFromS3 = async (val) => {
        let { attachedFiles } = this.state
        let file_key = val.FileKey;
        let file_name = val.FileName;
        let file_newName = val.NewFilename;
        let file_s3 = '';
        //https://predev-ims.jnj.com/api/NotebookService/S3File/GetFile?fileName=08023069-3d25-45d7-98e7-6bfecc4df040/Erleada2%201%20(4).pdf

        let API_ENDPOINT = `${_locationOrigin}/api/NotebookService/S3File/GetFile?fileName=${file_key}`;
        if (window.location.origin === 'https://predev-ims.jnj.com') {
            URL = `${window.location.origin}/api/NotebookService/S3File/GetFile?fileName=${encodeURIComponent(file_key)}`
        }
        //API_ENDPOINT = `https://localhost:44306/api/NotebookService/S3File/GetStaticFile`
        const _headers = {
            'Content-Type': 'application/json'
        }
        if (await Authentication.isAccessTokenAvailable()) {
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }
        await axios.get(API_ENDPOINT, {
            headers: _headers,
            responseType: "blob"
        }).then((res) => {
            const fileName = file_name;
            const data = new Blob([res.data], { type: 'application/pdf' });
            var newFile = new File([data], fileName, { type: 'application/pdf' });
            newFile.guid = val.FileGuid;
            newFile.newFileName = file_newName;
            file_s3 = newFile
        }).catch((error) => {
            console.log(error);
            // isUploadSuccessfully = false;
            this.errorAlertMessage(`${error}.Please try again later`)
            file_s3 = ''
        }).finally(() => {

        });
        return file_s3
    }
    getCleanText = (summary) => {
        let cleanText = summary.replace(/<[^>]*>/g, '');
        return cleanText
    }
    handleAddToSource = async (summary, id, name) => {
        let { attachedFiles, isSorcePanelSelectAll, selectedFileSource } = this.state
        this.setState({ isProcessing: true });
        let nameSummary = this.getCleanText(summary)
        let new_attachedFile = attachedFiles.concat({
            name: (name) ? `${name}` : `${nameSummary.slice(0, 10)}.txt`,
            fullText: summary,
            id
        })
        let fil_Source = isSorcePanelSelectAll ? new_attachedFile : selectedFileSource;
        this.setState({
            attachedFiles: new_attachedFile, isProcessing: false,
            selectedFileSource: fil_Source
        })
    }
    getAllNoteBookNotes = async (sessionID) => {
        let res = await services.getAllNoteBookNotes(sessionID);
        if (res) {
            this.setState({ savedNotes: res })
        }
    }
    handeAddToNotes = async (summary) => {
        let { sessionID } = this.state;
        this.setState({ isProcessingNew: true, spinnerMessage: '' })
        let res = await services.insertNoteBookNotes(sessionID, summary);
        if (res) {
            this.successAlertMessage('Notes saved successfully.')
            this.setState({ isProcessingNew: false, spinnerMessage: '' }, async () => {
                this.setState({ rightIsProcessing: true, rightSpinnerMessage: '' })
                await this.getAllNoteBookNotes(sessionID)
                this.setState({ rightIsProcessing: false, rightSpinnerMessage: '' })
            })
        }
    }
    handleAddToSummary = async (summary, question) => {
        let { sessionID } = this.state
        try {
            if (sessionID) {
                this.setState({ isProcessingNew: true, spinnerMessage: '' })
                let res = await services.postAllNoteBookGenAISummary(sessionID, summary, question);
                if (res) {
                    await this.fetchSummary(sessionID);
                    this.setState({ isProcessingNew: false })
                    this.successAlertMessage('Summary Saved Successfully.')
                } else {
                    this.setState({ isProcessingNew: false })
                    this.errorAlertMessage('Something went wrong.Try again later.')
                }
            }
        } catch (error) {
            console.log(error)
        }

    }
    handleUpdateNotes = async (id, summary) => {
        let { sessionID } = this.state;
        this.setState({ isProcessingNew: true, spinnerMessage: '' })
        let res = await services.updateNoteBookNotes(id, summary);
        if (res) {
            this.setState({ isProcessingNew: false, spinnerMessage: '' }, async () => {
                this.setState({ rightIsProcessing: true, rightSpinnerMessage: '' })
                await this.getAllNoteBookNotes(sessionID)
                this.setState({ rightIsProcessing: false, rightSpinnerMessage: '' })

            })
        }
    }
    handleDeleteNotes = async (id) => {
        let { sessionID } = this.state
        this.setState({ isProcessingNew: true, spinnerMessage: '' })
        let res = await services.deleteNoteBookNotes(id);
        if (res) {
            this.setState({ isProcessingNew: false, spinnerMessage: '' }, async () => {
                this.setState({ rightIsProcessing: true, rightSpinnerMessage: '' })
                this.getAllNoteBookNotes(sessionID)
                this.setState({ rightIsProcessing: false, rightSpinnerMessage: '' })
            })
        }
    }
    handleAddToPromptTemplateText = (promptTemplate) => {
        this.setState({ commandText: promptTemplate, isShowPrompt: false })
    }
    handleCloseCommandList = () => {
        this.setState({
            isShowPrompt: false,
            isUserPromptTemplate: false,
            isSystemPromptTemplate: false,
            isCreatePromptTemplate: false
        })
    }
    successAlertMessage = (message) => {
        this.setState({
            alertMessageContent: message,
            alertMessageModelColor: "#00c12c",
            alertMessageShowModal: true
        })
    }
    errorAlertMessage = (message) => {
        this.setState({
            alertMessageContent: message,
            alertMessageModelColor: "#de1327",
            alertMessageShowModal: true
        })
    }
    closeAlertMessage = () => {
        let { isClickOnSelectNotebook } = this.state;
        this.setState({
            alertMessageContent: "",
            alertMessageModelColor: "",
            alertMessageShowModal: false,
            showPreview: false
        })
    }
    handleAddTemplatePrompts = (newPrompt) => {
        this.setState({ commandText: newPrompt })
    }
    indextrackingData = async (eventid, questionType, question, userQuestion, outputAnswer, attachedFiles, sourcesMultiFiles, displayStringMultiFiles, combinedSummaryMultiFiles, lastCreatedDatehour, isMultiQuestion, finalPrompt, wordLimit, readingLevel, isGetAnyAns, isSuccess, commandType, summarizeText, commandText) => {
        let { sessionID, threadID, selectedNotebookName, selectedProjectType } = this.state;
        let notebookinfo = {
            session_id: sessionID,
            thread_id: threadID,
            question_type: questionType,
            question: question,
            userQuestion: userQuestion ? userQuestion : question,
            output_answer: outputAnswer,
            isGetAnyAns: isGetAnyAns,
            isSuccess: isSuccess,
            attachedFiles: attachedFiles,
            sources_multi_files_list: sourcesMultiFiles,
            display_string_multi_files: displayStringMultiFiles,
            combined_summary_multi_files_list: combinedSummaryMultiFiles,
            answer_reaction: ReactNone,
            answer_feedback: '',
            lastcreateddatehour: lastCreatedDatehour,
            projectName: selectedNotebookName,
            projectType: selectedProjectType,
            finalPrompt: finalPrompt,
            wordLimit: wordLimit,
            readingLevel: readingLevel,
            commandType,
            summarizeText,
            commandText,

        }
        let temp = await aps.indextrackingData("Conducted Question at NoteBook", eventid, notebookinfo);
        this.indexDataQnA({ ...notebookinfo, "eventid": eventid, "isMultiQuestion": isMultiQuestion });
        setTimeout(async () => {
            if (questionType === "FollowUpQuestion") {
                await this.updateNoteBookProjectDatehour(attachedFiles.length > 0);
            }
        }, 600);
    }
    updateNoteBookProjectData = async (newEventid, eventid, questionType, question, userQuestion, outputAnswer, attachedFiles, sourcesMultiFiles, displayStringMultiFiles, combinedSummaryMultiFiles, lastCreatedDatehour, isMultiQuestion, finalPrompt, wordLimit, readingLevel, isGetAnyAns, isSuccess, commandType, summarizeText) => {
        let { sessionID, threadID, projectName, projectType } = this.state;
        let notebookinfo = {
            session_id: sessionID,
            thread_id: threadID,
            question_type: questionType,
            question: question,
            userQuestion: userQuestion ? userQuestion : question,
            output_answer: outputAnswer,
            isGetAnyAns: isGetAnyAns,
            isSuccess: isSuccess,
            attachedFiles: attachedFiles,
            sources_multi_files_list: sourcesMultiFiles,
            display_string_multi_files: displayStringMultiFiles,
            combined_summary_multi_files_list: combinedSummaryMultiFiles,
            answer_reaction: ReactNone,
            answer_feedback: '',
            lastcreateddatehour: lastCreatedDatehour,
            projectName: projectName,
            projectType: projectType,
            finalPrompt: finalPrompt,
            wordLimit: wordLimit,
            readingLevel: readingLevel,
            commandType,

        }
        let temp = await aps.updateNoteBookProjectData(eventid, newEventid, notebookinfo);
        this.indexDataQnA({ ...notebookinfo, "eventid": newEventid });
        if (questionType === "FollowUpQuestion") {
            setTimeout(async () => {
                await this.updateNoteBookProjectDatehour(false);
            }, 500);
        }
    }
    updateNoteBookProjectDatehour = async (isMultiQuestion) => {
        let { sessionID } = this.state;
        if (!isMultiQuestion) {
            let temp = await aps.updateNoteBookProjectDatehour(UserData.sub, sessionID);
        }
    }
    indexDataQnA = (notebookinfo) => {
        const ts = new trackingService();
        ts.indexTrackingData(localStorage.getItem('userdisplayName'),
            localStorage.getItem('wwid'),
            localStorage.getItem('username'),
            localStorage.getItem('function'),
            localStorage.getItem('region'),
            localStorage.getItem('userproducts'),
            localStorage.getItem('doctypepref'),
            localStorage.getItem('sid'),
            localStorage.getItem('deviceType'),
            localStorage.getItem('deviceOS'),
            localStorage.getItem('browserName'),
            localStorage.getItem('browserVersion'),
            localStorage.getItem('jnjDepartment'),
            localStorage.getItem('companyname'),
            "Conducted Question at NoteBook",
            '',
            window.location.href, '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
            {}, {}, {}, {}, {}, notebookinfo);
    }
    indexData = (orignaltext, summarizetext, commandtext, commandtype, previousSummarizeText, sessionid, requestTokenCount, responseTokenCount, multiCommands, answersList) => {
        let { sessionID, threadID, projectName, projectType } = this.state;
        let notebookinfo = {
            "orignaltext": orignaltext,
            "summarizetext": summarizetext,
            "commandtext": commandtext,
            "commandtype": commandtype,
            "session_id": sessionid,
            "previousSummarizeText": previousSummarizeText,
            "requestTokenCount": requestTokenCount,
            "responseTokenCount": responseTokenCount,
            "multiCommands": multiCommands,
            "answersList": answersList,
            projectName: projectName,
            projectType: projectType,
            thread_id: threadID,
        }
        const ts = new trackingService();
        ts.indexTrackingData(localStorage.getItem('userdisplayName'),
            localStorage.getItem('wwid'),
            localStorage.getItem('username'),
            localStorage.getItem('function'),
            localStorage.getItem('region'),
            localStorage.getItem('userproducts'),
            localStorage.getItem('doctypepref'),
            localStorage.getItem('sid'),
            localStorage.getItem('deviceType'),
            localStorage.getItem('deviceOS'),
            localStorage.getItem('browserName'),
            localStorage.getItem('browserVersion'),
            localStorage.getItem('jnjDepartment'),
            localStorage.getItem('companyname'),
            `Conducted Question at NoteBook`,
            '',
            window.location.href, '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
            {}, {}, {}, {}, {}, notebookinfo);
    }
    indexDataOnSave = (orignaltext, summarizetext, commandtype, notebooklistId, notebooklistName, referencetext, notesText, tableSummarizedHtml, item) => {
        if (!isEmptyObject(item)) {
            let { orderedBy, orderedFor } = item;
            if (!orderedBy) orderedBy = '';
            if (!orderedFor) orderedFor = '';
            let docVersion = '', docNumber = ''
            if (item.domain === 'RIMdocs' || item.domain === 'RIMdocs_LL') {
                docVersion = item.r_version_label;
                docNumber = item.jj_number;
            }
            else if (item.domain === 'SKM') {
                docNumber = item.domain;
            }
            else if (item.domain === 'CTGov') {
                docNumber = item.docID;
            }
            else {
                docVersion = item.majorVersionNumber;
                docNumber = item.documentNumber;
            }
            let url = '';
            if (item.domain === 'RIMdocs' || item.domain === 'RIMdocs_LL' || item.domain === 'CTGov') {
                url = `/DocURL?ID=${item.docID}&cs=${item.domain}&orderedBy=${orderedBy}&orderedFor=${orderedFor}`
            }
            else if (item.domain === 'SKM' || item.domain === "MIAs") {
                url = `/DocURL?ID=${item.docID}&cs=${item.domain}&connID=${item.connID}&csID=${item.csID}&fileType=${item.fileExtension}&fileName=${item.docTitle}&orderedBy=${orderedBy}&orderedFor=${orderedFor}`
            }
            else {
                url = `/DocURL?ID=${item.docID}&cs=${item.domain}&connID=${item.connID}&csID=${item.csID}&fileType=${item.fileExtension}&docVer=${item.majorVersionNumber}&fileName=${item.docTitle}&orderedBy=${orderedBy}&orderedFor=${orderedFor}`
                if (item.a_status === "Approved Needs Review" || item.status === "Approved Needs Review") {
                    url = url + `&docState=anr`
                }
            }
            if (item.enclosureDocID) {
                url += `&enclosureID=${item.enclosureDocID}`
            }
            let newUrl = window.origin + url;
            let notebookinfo = {
                "orignaltext": orignaltext,
                "summarizetext": summarizetext,
                "commandtype": commandtype,
                "notebooklistId": notebooklistId,
                "notebooklistName": notebooklistName,
                "referencetext": referencetext,
                "notesText": notesText,
                "tableSummarizedHtml": tableSummarizedHtml
            }
            const ts = new trackingService();
            ts.indexTrackingData(localStorage.getItem('userdisplayName'),
                localStorage.getItem('wwid'),
                localStorage.getItem('username'),
                localStorage.getItem('function'),
                localStorage.getItem('region'),
                localStorage.getItem('userproducts'),
                localStorage.getItem('doctypepref'),
                localStorage.getItem('sid'),
                localStorage.getItem('deviceType'),
                localStorage.getItem('deviceOS'),
                localStorage.getItem('browserName'),
                localStorage.getItem('browserVersion'),
                localStorage.getItem('jnjDepartment'),
                localStorage.getItem('companyname'),
                `Save Notebook`,
                '',
                window.location.href, '', '', item.docTitle, docVersion, docNumber, item.searchID, newUrl, item.tempJNJDrugs, item.docType, 'Save Notebook', '', '', item.domain, '', '', item.createdDate, orderedBy, orderedFor,
                {}, {}, {}, {}, {}, notebookinfo);
        } else {
            let notebookinfo = {
                "orignaltext": orignaltext,
                "summarizetext": summarizetext,
                "commandtype": commandtype,
                "notebooklistId": notebooklistId,
                "notebooklistName": notebooklistName,
                "referencetext": referencetext,
                "notesText": notesText,
                "tableSummarizedHtml": tableSummarizedHtml
            }
            const ts = new trackingService();
            ts.indexTrackingData(localStorage.getItem('userdisplayName'),
                localStorage.getItem('wwid'),
                localStorage.getItem('username'),
                localStorage.getItem('function'),
                localStorage.getItem('region'),
                localStorage.getItem('userproducts'),
                localStorage.getItem('doctypepref'),
                localStorage.getItem('sid'),
                localStorage.getItem('deviceType'),
                localStorage.getItem('deviceOS'),
                localStorage.getItem('browserName'),
                localStorage.getItem('browserVersion'),
                localStorage.getItem('jnjDepartment'),
                localStorage.getItem('companyname'),
                `Save Notebook`,
                '',
                window.location.href, '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '',
                {}, {}, {}, {}, {}, notebookinfo);
        }

    }
    handleCommandText = (e) => {
        this.setState({ commandText: e.target.value })
    }
    getAllPrompts = async (selectedProject) => {
        //let selected_id = selectOption.filter(val => val.project_type_name === selectedProject)[0].id;
        let selected_id = selectedProject.id;
        if (selected_id) {
            await services.getAllPrompt(selected_id).then((res) => {
                this.setState({
                    prompts: res,
                })
            }).catch((error) => {
                console.log(error)
            }).finally(() => {

            })
        }
    }
    handleChangeCommandType = (e) => {
        this.setState({ commandType: e.target.value })
    }
    handleSetSelectedAttachedFiles = (val, attachedFiles) => {
        let { selectedFileSource, selectedFileGuidSource } = this.state
        if (!Array.isArray(attachedFiles)) {
            if (val === 'add') {
                let new_selected = [...selectedFileSource, attachedFiles]
                this.setState({ selectedFileSource: new_selected })
            } else if (val === 'remove') {
                let new_deselected = []
                if (attachedFiles.name.toLowerCase().endsWith('.txt')) {
                    new_deselected = selectedFileSource.filter(val => val.id !== attachedFiles.id)
                } else {
                    new_deselected = selectedFileSource.filter(val => val.guid !== attachedFiles.guid)
                }
                this.setState({ selectedFileSource: new_deselected })
            }
        } else {
            if (val === 'add') {
                this.setState({ selectedFileSource: attachedFiles })
            } else if (val === 'remove') {
                this.setState({ selectedFileSource: [] })
            }
        }
    }
    handleFullText = async (attachedFiles_new) => {
        let { allFileContent } = this.state;

        // if (attachedFiles.filter(val => val.guid === selectedAttachedFileguid)[0].newFileName?.toLowerCase().endsWith('.png') ||
        //     attachedFiles.filter(val => val.guid === selectedAttachedFileguid)[0].newFileName?.toLowerCase().endsWith('.jpg') ||
        //     attachedFiles.filter(val => val.guid === selectedAttachedFileguid)[0].newFileName?.toLowerCase().endsWith('.gif') ||
        //     attachedFiles.filter(val => val.guid === selectedAttachedFileguid)[0].newFileName?.toLowerCase().endsWith('.jpeg')) {
        //     this.setState({ isFileContainsImage: true })
        // }
        for (let val of attachedFiles_new) {
            if (!val.name.toLowerCase().endsWith('.txt')) {
                this.setState({ isProcessing: true, spinnerMessage: "Please wait..." })
                let _singleFile = val;
                let resp = [];
                let API_ENDPOINT = `${LocationOrigin}${process.env.REACT_APP_IMS_API_PREFIX}PreviewService/Content?fileType=Document`;
                //API_ENDPOINT = "https://localhost:44376/api/PreviewService/Content?fileType=Document";
                const formData = new FormData();
                formData.append('form_filed_name', _singleFile)
                const _headers = {
                    'content-type': 'multipart/form-data'
                }
                if (await Authentication.isAccessTokenAvailable()) {
                    const token = await Authentication.getAccessToken();
                    _headers.Authorization = `Bearer ${token}`;
                }
                await axios.post(API_ENDPOINT, formData, {
                    headers: _headers
                }).then((response) => {
                    resp = response.data;
                    allFileContent[val.guid] = resp.PagesContent
                    this.setState({ allFileContent: allFileContent })
                }).catch((error) => {
                    console.log(error);
                    this.errorAlertMessage("Something went wrong. So we couldn't get full document content.");
                }).finally(() => {
                    this.setState({ isProcessing: false, spinnerMessage: "" })
                })
            }
        }
    }
    onSubmitClick = async (e) => {
        let { commandText, commandType, selectedFileSource } = this.state;
        if (selectedFileSource.length !== 0) {

            let isImageUpload = selectedFileSource.some(x =>
                x.name.toLowerCase().endsWith('.gif')
                || x.name.toLowerCase().endsWith('.jpeg')
                || x.name.toLowerCase().endsWith('.jpg')
                || x.name.toLowerCase().endsWith('.png'))
            if (!isImageUpload) {
                if (commandType === 'UserInstructions' && !commandText) {
                    this.errorAlertMessage("User Command Required, Please enter a command.");
                } else if (commandType === 'UserInstructions' && commandText) {
                    let _newQuestion = commandText.trim().replace(/\r\n/g, '\n').replace(/\n\n/g, '\n');
                    let _splitQuery = _newQuestion.trim().split(/\n\*\|\*\n/g).filter(x => x).map(y => y.trim());
                    if (_splitQuery.length > 10) {
                        this.errorAlertMessage("You have exceeded 10 questions. Please remove questions before continuing.");
                    } else {
                        this.setState({
                            isProcessing: true
                        })
                        for (let ele of selectedFileSource) {
                            //let ele = selectedFileSource[i]
                            if (ele.name.toLowerCase().endsWith('.txt')) {
                                await this.onSummeryClick(ele)
                            } else {
                                await this.onSummeryClick(ele)
                            }
                        }
                    }
                } else if (commandType === 'QnA' && !commandText) {
                    this.errorAlertMessage("User Command Required, Please enter a command.");
                } else if (commandType === 'QnA' && commandText) {
                    let _newQuestion = commandText.trim().replace(/\r\n/g, '\n').replace(/\n\n/g, '\n');
                    let _splitQuery = _newQuestion.trim().split(/\n\*\|\*\n/g).filter(x => x).map(y => y.trim());
                    if (_splitQuery.length > 10) {
                        this.errorAlertMessage("You have exceeded 10 questions. Please remove questions before continuing.");
                    } else if (commandType === 'QnA') {
                        let isProcess = false
                        for (let ele of this.state.selectedFileSource) {
                            if (ele.name.toLowerCase().endsWith('.txt')) {
                                await this.onSourceTextQnAClick(ele)
                            } else if (!isProcess) {
                                await this.processMultiQuestions();
                                isProcess = true
                            }
                        }
                    }
                    else {
                        await this.processMultiQuestions();
                    }
                }
                else if (commandType === 'Summarize') {
                    for (let ele of selectedFileSource) {
                        if (ele.name.toLowerCase().endsWith('.txt')) {
                            await this.onSummeryClick(ele)
                        } else {
                            await this.onSummeryClick(ele)
                        }
                    }
                }
                else if (commandType === 'CreateTable' || commandType === 'CreateGraph') {
                    let { selectedFileSource } = this.state;
                    let onlyTxtFiles = selectedFileSource.every((val) => val.name.toLowerCase().endsWith('.txt'));
                    if (onlyTxtFiles) {
                        for (let val of selectedFileSource) {
                            await this.onSummeryClick(val);
                        }
                    } else {
                        this.errorAlertMessage('Please select only text file to proceed.')
                    }
                }
                else if (commandType === 'Multi-Doc Summary' && !commandText) {
                    this.errorAlertMessage("User Command Required, Please enter a command.");
                }
                else if (commandType === 'Multi-Doc Summary' && commandText) {
                    let _newQuestion = commandText.trim().replace(/\r\n/g, '\n').replace(/\n\n/g, '\n');
                    let _splitQuery = _newQuestion.trim().split(/\n\*\|\*\n/g).filter(x => x).map(y => y.trim());
                    if (_splitQuery.length > 10) {
                        this.errorAlertMessage("You have exceeded 10 questions. Please remove questions before continuing.");
                    } else {
                        await this.processMultiQuestions();
                    }
                }
            } else if (commandType === 'CreateTable' && isImageUpload) {
                await this.processCreateTableForContainsImage();
            } else {
                this.errorAlertMessage('Please select Create Table command type to proceed.')
            }
        } else {
            this.errorAlertMessage('Please select at least one file to proceed.')
        }
    }
    onSummeryClick = async (val) => {
        let { commandText, chatConversation, commandType, sessionID,
            summarizeText, isConfirm, isClearAllFields, previousOrignalText, configConversationa, configResponseLength, configActiveTab, allFileContent, attachedFiles
        } = this.state;
        let _lastCreatedDatehour = getCurrentDate();
        let isFirstQuestion = chatConversation.length === 0;
        let _attachedFiles = attachedFiles.map(x => { return { name: x.name } })
        var eventid = uuidv4();
        let isFullFileContent = false;
        let orignalText = (val && val.fullText) ? val.fullText : '';
        let selectedAttachedFileguid = (val && val.guid) ? val.guid : '';
        let sourceText = clone(orignalText);
        let configTab = configActiveTab === 0 ? 'Default' : configActiveTab === 1 ? 'Learning Guide' : 'Custom';
        this.setState({ savingCommandText: commandText });
        if (orignalText || (allFileContent && Object.keys(allFileContent).find(x => x === selectedAttachedFileguid))) {
            let _commandType = commandType;
            let _commandText = commandText;
            let _orignalText = orignalText;
            if ((!_orignalText && _commandType === 'Summarize') || (!_orignalText && _commandType === 'UserInstructions')) {
                _orignalText = allFileContent[selectedAttachedFileguid];
                isFullFileContent = true;
            }
            let tokenLength = this.numberOfWords(_orignalText);
            if (_commandType === 'UserInstructions' && !commandText) {
                this.errorAlertMessage("User Command Required, Please enter a command.");
            }
            else if (_commandType === 'CreateTable' && tokenLength === 0) {
                this.errorAlertMessage("For Create Table Command, Please enter text in the source text box.");
            }
            else if (_commandType === 'CreateTable' && tokenLength === 0) {
                this.errorAlertMessage("For Create Table Command, Please enter text in the source text box.");
            }
            else if (_commandType === 'Translate' && !commandText) {
                this.errorAlertMessage("Please enter language to the command box.");
            } else if (!isConfirm && ShowWordCountForCommandType.includes(commandType) && tokenLength > WordsMaxLength) {
                this.showConfirmMessage(`The input text is more than ${WordsMaxLength} words. Please use a shorter text by hitting cancel button and updating the text or the text can be ${_commandType} upto max limit by clicking on OK button`);
            } else if (_commandType === 'UserInstructions' && commandText && commandText.trim() && commandText.trim().split(/\n\n/g).length > 5) {
                this.errorAlertMessage("Kindly select maximum five commands to proceed.");
            } else {
                if (_commandType === 'UserInstructions') {
                    //let commandTexts = commandText.trim().split(/\n\n/g);
                    let commandTexts = commandText.trim().replace(/\r\n/g, '\n').replace(/\n\n/g, '\n');
                    commandTexts = commandTexts.trim().split(/\n\*\|\*\n/g).filter(x => x).map(y => y.trim());
                    if (tokenLength > 7000 || commandTexts.length > 1) {
                        await this.processUserInstructions(val);
                    }
                    else {
                        this.setState({ chatConversation: chatConversation, isChatConversationSpinner: true }, () => {
                            //this.scrollToBottom();
                        });

                        _orignalText = _orignalText.replace(/[\r\n]/g, " ").trim();
                        if (ShowWordCountForCommandType.includes(commandType)) {
                            _orignalText = _orignalText.replace(/[\r\n]/g, " ").trim().split(' ').filter((x, i) => i < WordsMaxLength).join(' ')
                        }
                        let config = {}
                        var url = `${_locationOrigin}${process.env.REACT_APP_IMS_API_NLP_SUMMARIZE}summarize_api2`
                        if (window.location.origin === 'https://predev-ims.jnj.com') {
                            url = `${window.location.origin}${process.env.REACT_APP_IMS_API_NLP_SUMMARIZE}summarize_api2`
                        }
                        //url = `https://predev-ims.jnj.com${process.env.REACT_APP_IMS_API_NLP_SUMMARIZE}summarize_api2`

                        const _headers = {
                            'Content-Type': 'application/json'
                        }
                        if (await Authentication.isAccessTokenAvailable()) {
                            const token = await Authentication.getAccessToken();
                            _headers.Authorization = `Bearer ${token}`;
                        }

                        config = {
                            method: 'POST',
                            url: url,
                            headers: _headers,
                            data: {
                                "orignalText": _orignalText.replace(/[\r\n]/g, " ").trim(),
                                "commandType": commandType,
                                "commandText": '',
                                "username": localStorage.getItem('username').toLowerCase().replace(/"/g, ''),
                                "sessionID": sessionID,
                                "wwid": JSON.parse(localStorage.getItem('wwid')),
                                "previousSummarizeText": '',
                                "searchID": "",
                                "isClearAllFields": isClearAllFields,
                                "isNewOrignalText": (previousOrignalText !== orignalText.replace(/[\r\n]/g, " ").trim().trimEnd().trimStart()),
                                "multiCommands": commandTexts,
                                "fileGuid": selectedAttachedFileguid,
                                "isFullFileContent": isFullFileContent,
                                "configConversatio": configConversationa,
                                "configResponseLength": configResponseLength,
                                "option_selected": configTab
                            },
                            timeout: _timeoutTime
                        }
                        // this.scrollToBottom();
                        await axios(config).then((response) => {
                            let _summarizeText = "", requestTokenCount = 0, responseTokenCount = 0;
                            if (response.data.answersList && response.data.answersList.length > 0) {
                                if (response.data.requestTokenCount)
                                    requestTokenCount = response.data.requestTokenCount;
                                if (response.data.responseTokenCount)
                                    responseTokenCount = response.data.responseTokenCount;

                                this.setState({ lastCommandType: _commandType }, () => {

                                    commandTexts.map((citem, cindex) => {
                                        let _message = "";
                                        _message = citem ? `${citem}\n${orignalText}` : `${orignalText}`;
                                        _message = _message.trim().replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/\n/g, '<br/>')
                                        chatConversation.push({ from: userQuestion, message: _message, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, IsSucceed: true })
                                        _summarizeText = response.data.answersList[cindex] ? response.data.answersList[cindex].trim() : ""
                                        if (_commandType !== 'UserInstructions') {
                                            _summarizeText = _summarizeText.replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/\n/g, '<br/>')
                                        }

                                        if (_summarizeText === "Answer not found in the document" && sourceText) {
                                            _summarizeText = "Answer not found in the source text";
                                        }
                                        let finalSummery = JSON.parse(JSON.stringify(_summarizeText))
                                        chatConversation.push({ from: summarizeResult, message: finalSummery, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, commandText: citem, orignalText: orignalText, IsSucceed: true })
                                        this.indextrackingData(clone(eventid), (isFirstQuestion && cindex === 0) ? "MainQuestion" : "FollowUpQuestion", _orignalText.replace(/[\r\n]/g, " ").trim(), "", '', _attachedFiles, [], [], _summarizeText, _lastCreatedDatehour, false, true, `0`, `0`, true, true, _commandType, _summarizeText, citem);
                                    })

                                })
                                //this.indexData(_orignalText.replace(/[\r\n]/g, " ").trim(), "", commandText, commandType, summarizeText, sessionID, requestTokenCount, responseTokenCount, commandTexts, response.data.answersList);
                                //this.indexData(sourceItem, _orignalText.replace(/[\r\n]/g, " ").trim(), "", commandText, commandType, "", sessionID, requestTokenCount, responseTokenCount, commandTexts, response.data.answersList);
                            } else {
                                commandTexts.map((citem, cindex) => {
                                    let _message = "";
                                    _message = citem ? `${citem}\n${orignalText}` : `${orignalText}`;
                                    _message = _message.trim().replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/\n/g, '<br/>')
                                    chatConversation.push({ from: userQuestion, message: _message, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, IsSucceed: true })
                                    chatConversation.push({ from: summarizeResult, message: `We don't know the answer.<br>Kindly try after some time.`, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, commandText: citem, orignalText: orignalText, IsSucceed: false })
                                    if (_summarizeText === "Answer not found in the document" && sourceText) {
                                        _summarizeText = "Answer not found in the source text";
                                    }
                                    this.indextrackingData(clone(eventid), (isFirstQuestion && cindex === 0) ? "MainQuestion" : "FollowUpQuestion", _orignalText.replace(/[\r\n]/g, " ").trim(), "", '', _attachedFiles, [], [], "Answer not found in the document or source text.", _lastCreatedDatehour, false, "", `0`, `0`, false, true, _commandType, "Answer not found in the document or source text.", citem);
                                })

                            }
                            this.setState({
                                chatConversation: chatConversation,
                                summarizeText: _summarizeText
                            });
                        }).catch((error) => {
                            commandTexts.map((citem, cindex) => {
                                let _message = "";
                                _message = citem ? `${citem}\n${orignalText}` : `${orignalText}`;
                                _message = _message.trim().replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/\n/g, '<br/>')
                                chatConversation.push({ from: userQuestion, message: _message, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, IsSucceed: true })
                                chatConversation.push({ from: summarizeResult, message: `Service is unavailable at this time, Kindly try after some time.`, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, commandText: citem, orignalText: orignalText, IsSucceed: false })
                                this.indextrackingData(clone(eventid), (isFirstQuestion && cindex === 0) ? "MainQuestion" : "FollowUpQuestion", _orignalText.replace(/[\r\n]/g, " ").trim(), "", '', _attachedFiles, [], [], `Service is unavailable at this time, Kindly try after some time.`, _lastCreatedDatehour, false, "", `0`, `0`, false, false, _commandType, `Service is unavailable at this time, Kindly try after some time.`, citem);
                            })
                            this.setState({ chatConversation: chatConversation });
                            console.log(error)
                        }).finally(() => {
                            this.setState({
                                isChatConversationSpinner: false,
                                isMultiQuestionProcessing: false, isConfirm: false,
                                isClearAllFields: false,
                                previousOrignalText: orignalText.replace(/[\r\n]/g, " ").trim().trimEnd().trimStart(),
                                firstCall: false,
                                commandText: ""
                            }, () => {
                                this.scrollToBottom();
                            });
                        });
                    }
                }
                else {
                    let _message = "";
                    _message = commandText ? `${commandText}\n${_orignalText}` : `${_orignalText}`;
                    _message = _message.trim().replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/\n/g, '<br/>')
                    chatConversation.push({ from: userQuestion, message: _message, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, IsSucceed: true, isFromOriginalText: true })
                    this.setState({ chatConversation: chatConversation, isChatConversationSpinner: true }, () => {
                        this.scrollToBottom();
                    });

                    _orignalText = _orignalText.replace(/[\r\n]/g, " ").trim();
                    let commandTexts = (_commandType === 'UserInstructions') ? commandText.trim().split(/\n\n/g) : [];

                    if (ShowWordCountForCommandType.includes(commandType)) {
                        _orignalText = _orignalText.replace(/[\r\n]/g, " ").trim().split(' ').filter((x, i) => i < WordsMaxLength).join(' ')
                    }
                    let config = {}

                    var url = `${_locationOrigin}${process.env.REACT_APP_IMS_API_NLP_SUMMARIZE}summarize_api2`
                    if (window.location.origin === 'https://predev-ims.jnj.com') {
                        url = `${window.location.origin}${process.env.REACT_APP_IMS_API_NLP_SUMMARIZE}summarize_api2`
                    }

                    const _headers = {
                        'Content-Type': 'application/json'
                    }
                    if (await Authentication.isAccessTokenAvailable()) {
                        const token = await Authentication.getAccessToken();
                        _headers.Authorization = `Bearer ${token}`;
                    }

                    config = {
                        method: 'POST',
                        url: url,
                        headers: _headers,
                        data: {
                            "orignalText": _orignalText.replace(/[\r\n]/g, " ").trim(),
                            "commandType": commandType,
                            "commandText": commandText,
                            "username": localStorage.getItem('username').toLowerCase().replace(/"/g, ''),
                            "sessionID": sessionID,
                            "wwid": JSON.parse(localStorage.getItem('wwid')),
                            "previousSummarizeText": summarizeText.replace(/[\r\n]/g, " ").trim(),
                            "searchID": "",
                            "isClearAllFields": isClearAllFields,
                            "isNewOrignalText": (previousOrignalText !== _orignalText.replace(/[\r\n]/g, " ").trim().trimEnd().trimStart()),
                            "multiCommands": commandTexts,
                            "fileGuid": selectedAttachedFileguid,
                            "isFullFileContent": isFullFileContent,
                            "configConversatio": configConversationa,
                            "configResponseLength": configResponseLength,
                            "option_selected": configTab
                        },
                        timeout: _timeoutTime
                    }

                    // this.scrollToBottom();
                    await axios(config).then((response) => {
                        let _summarizeText = "", requestTokenCount = 0, responseTokenCount = 0;
                        if (_commandType === "CreateTable") {
                            if (response.data.summarizeTable && response.data.summarizeTable.length > 0) {
                                this.setState({ lastCommandType: _commandType }, () => {
                                    let summarizeTables = response.data.summarizeTable;
                                    if (response.data.requestTokenCount)
                                        requestTokenCount = response.data.requestTokenCount;
                                    if (response.data.responseTokenCount)
                                        responseTokenCount = response.data.responseTokenCount;

                                    if (summarizeTables.length === 1) {
                                        _summarizeText = summarizeTables[0];
                                        chatConversation.push({ _commandType: _commandType, from: summarizeResult, message: summarizeTables[0], messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, commandText: _commandText, orignalText: _orignalText, IsSucceed: true });
                                        this.indextrackingData(clone(eventid), isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", _orignalText.replace(/[\r\n]/g, " ").trim(), "", '', _attachedFiles, [], [], _summarizeText, _lastCreatedDatehour, false, true, ``, ``, true, true, _commandType, _summarizeText, _commandText)
                                        // this.indextrackingData(clone(eventid), isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", _orignalText.replace(/[\r\n]/g, " ").trim(), "", '', _attachedFiles, [], [], _summarizeText, _lastCreatedDatehour, false, true, ``, ``, true, true, _commandType, _summarizeText, _commandText);
                                        //this.indexData(_orignalText.replace(/[\r\n]/g, " ").trim(), _summarizeText, commandText, commandType, summarizeText, sessionID, requestTokenCount, responseTokenCount, [], []);
                                    }
                                })
                            } else {
                                chatConversation.push({ _commandType: _commandType, from: summarizeResult, message: `We don't know the answer.<br>Kindly try after some time.`, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, commandText: _commandText, orignalText: _orignalText, IsSucceed: false })
                                this.indextrackingData(clone(eventid), isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", _orignalText.replace(/[\r\n]/g, " ").trim(), "", '', _attachedFiles, [], [], `We don't know the answer.<br>Kindly try after some time.`, _lastCreatedDatehour, false, true, ``, ``, false, true, _commandType, `We don't know the answer.<br>Kindly try after some time.`, _commandText);
                            }
                        } else if (_commandType === 'Summarize') {
                            if (response.data.summarizeText) {
                                _summarizeText = response.data.summarizeText ? response.data.summarizeText.trim() : ""
                                if (response.data.requestTokenCount)
                                    requestTokenCount = response.data.requestTokenCount;
                                if (response.data.responseTokenCount)
                                    responseTokenCount = response.data.responseTokenCount;

                                this.setState({ lastCommandType: _commandType }, () => {
                                    if (_commandType !== 'Summarize') {
                                        _summarizeText = _summarizeText.replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/\n/g, '<br/>')
                                    }

                                    chatConversation.push({ _commandType: _commandType, from: summarizeResult, message: _summarizeText, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, commandText: _commandText, orignalText: _orignalText, IsSucceed: true, isFromOriginalText: true })
                                })
                                //this.indexData(_orignalText.replace(/[\r\n]/g, " ").trim(), _summarizeText, commandText, commandType, summarizeText, sessionID, requestTokenCount, responseTokenCount, [], []);
                                //this.indextrackingData(clone(eventid), (isFirstQuestion && questionIndex === 0) ? "MainQuestion" : "FollowUpQuestion", questionItem, response.rephrased_question, response.output_answer, _attachedFiles, response.sources_multi, response.display_string_multi, response.combined_summary, _lastCreatedDatehour, query.length > 1, singleQuery, `150`, `5`, true, true, commandType, '');
                                this.indextrackingData(clone(eventid), isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", _orignalText.replace(/[\r\n]/g, " ").trim(), "", '', _attachedFiles, [], [], _summarizeText, _lastCreatedDatehour, false, true, ``, ``, true, true, _commandType, _summarizeText, _commandText);
                            } else {
                                chatConversation.push({ _commandType: _commandType, from: summarizeResult, message: `We don't know the answer.<br>Kindly try after some time.`, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, commandText: _commandText, orignalText: _orignalText, IsSucceed: false, isFromOriginalText: true })
                                this.indextrackingData(clone(eventid), isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", _orignalText.replace(/[\r\n]/g, " ").trim(), "", '', _attachedFiles, [], [], `We don't know the answer.<br>Kindly try after some time.`, _lastCreatedDatehour, false, true, ``, ``, true, true, _commandType, `We don't know the answer.<br>Kindly try after some time.`, _commandText);
                            }
                        }
                        else {
                            if (response.data.answersList.length > 0) {
                                for (let i = 0; i < response.data.answersList.length; i++) {
                                    _summarizeText = response.data.answersList[i].trim();
                                }
                                if (response.data.requestTokenCount)
                                    requestTokenCount = response.data.requestTokenCount;
                                if (response.data.responseTokenCount)
                                    responseTokenCount = response.data.responseTokenCount;

                                this.setState({ lastCommandType: _commandType }, () => {
                                    _summarizeText = _summarizeText.replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/\n/g, '<br/>')
                                    chatConversation.push({ _commandType: _commandType, from: summarizeResult, message: _summarizeText, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, commandText: _commandText, orignalText: _orignalText, IsSucceed: true, isFromOriginalText: true })
                                    this.indextrackingData(clone(eventid), isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", _orignalText.replace(/[\r\n]/g, " ").trim(), "", '', _attachedFiles, [], [], _summarizeText, _lastCreatedDatehour, false, true, ``, ``, true, true, _commandType, _summarizeText, _commandText);
                                })
                                //this.indexData(_orignalText.replace(/[\r\n]/g, " ").trim(), _summarizeText, commandText, commandType, summarizeText, sessionID, requestTokenCount, responseTokenCount, [], []);
                            } else {
                                chatConversation.push({ _commandType: _commandType, from: summarizeResult, message: `We don't know the answer.<br>Kindly try after some time.`, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, commandText: _commandText, orignalText: _orignalText, IsSucceed: false, isFromOriginalText: true })
                                this.indextrackingData(clone(eventid), isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", _orignalText.replace(/[\r\n]/g, " ").trim(), "", '', _attachedFiles, [], [], `We don't know the answer.<br>Kindly try after some time.`, _lastCreatedDatehour, false, true, ``, ``, false, true, _commandType, `We don't know the answer.<br>Kindly try after some time.`, _commandText);
                            }
                        }
                        this.setState({
                            chatConversation: chatConversation,
                            summarizeText: (_commandType === "Summarize" || _commandType === "UserInstructions" || _commandType === "Translate" || _commandType === "QnA" || _commandType === "Multi-Doc Summary") ? (response.data.summarizeText ? response.data.summarizeText.trim() : "") : _summarizeText
                        });
                    }).catch((error) => {
                        chatConversation.push({ _commandType: _commandType, from: summarizeResult, message: `Service is unavailable at this time, Kindly try after some time.`, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, commandText: _commandText, orignalText: _orignalText, IsSucceed: false, isFromOriginalText: true })
                        this.indextrackingData(clone(eventid), isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", _orignalText.replace(/[\r\n]/g, " ").trim(), "", '', _attachedFiles, [], [], `Service is unavailable at this time, Kindly try after some time.`, _lastCreatedDatehour, false, true, ``, ``, false, false, _commandType, `Service is unavailable at this time, Kindly try after some time.`, _commandText);
                        this.setState({ chatConversation: chatConversation });
                        console.log(error)
                    }).finally(() => {
                        this.setState({
                            isChatConversationSpinner: false,
                            isConfirm: false, isClearAllFields: false,
                            previousOrignalText: _orignalText.replace(/[\r\n]/g, " ").trim().trimEnd().trimStart(),
                            firstCall: false,
                            commandText: ""
                        }, () => {
                            this.scrollToBottom();
                        });
                    });
                }
            }
        }
    }
    onSourceTextQnAClick = async (ele) => {
        let { commandText, chatConversation, sessionID, commandType, configActiveTab,
            summarizeText, configConversationa, configResponseLength, isClearAllFields, previousOrignalText, firstCall, selectedAttachedFileguid, allFileContent, attachedFiles
        } = this.state;
        let _lastCreatedDatehour = getCurrentDate();
        let isFirstQuestion = chatConversation.length === 0;
        let _attachedFiles = attachedFiles.map(x => { return { name: x.name } })
        var eventid = uuidv4();
        let isFullFileContent = false;
        let _orignalText = ele.fullText
        let sourceText = clone(_orignalText);
        let _message = "";
        let _commandType = 'source_text_QnA';
        let _commandText = commandText;
        let configTab = configActiveTab === 0 ? 'Default' : configActiveTab === 1 ? 'Learning Guide' : 'Custom';


        _message = commandText ? `${commandText}\n${_orignalText}` : `${_orignalText}`;
        _message = _message.trim().replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/\n/g, '<br/>')
        chatConversation.push({ from: userQuestion, message: _message, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, IsSucceed: true, isFromOriginalText: true })
        this.setState({ chatConversation: chatConversation, isChatConversationSpinner: true }, () => {
            this.scrollToBottom();
        });

        _orignalText = _orignalText.replace(/[\r\n]/g, " ").trim();
        let commandTexts = (_commandType === 'UserInstructions') ? commandText.trim().split(/\n\n/g) : [];

        if (ShowWordCountForCommandType.includes(_commandType)) {
            _orignalText = _orignalText.replace(/[\r\n]/g, " ").trim().split(' ').filter((x, i) => i < WordsMaxLength).join(' ')
        }
        let config = {}

        var url = `${_locationOrigin}${process.env.REACT_APP_IMS_API_NLP_SUMMARIZE}summarize_api2`
        if (window.location.origin === 'https://predev-ims.jnj.com') {
            url = `${window.location.origin}${process.env.REACT_APP_IMS_API_NLP_SUMMARIZE}summarize_api2`
        }

        const _headers = {
            'Content-Type': 'application/json'
        }
        if (await Authentication.isAccessTokenAvailable()) {
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }

        config = {
            method: 'POST',
            url: url,
            headers: _headers,
            data: {
                "orignalText": _orignalText.replace(/[\r\n]/g, " ").trim(),
                "commandType": "source_text_QnA",
                "commandText": commandText,
                "username": localStorage.getItem('username').toLowerCase().replace(/"/g, ''),
                "sessionID": sessionID,
                "wwid": JSON.parse(localStorage.getItem('wwid')),
                "previousSummarizeText": summarizeText.replace(/[\r\n]/g, " ").trim(),
                "searchID": "",
                "isClearAllFields": isClearAllFields,
                "isNewOrignalText": (previousOrignalText !== _orignalText.replace(/[\r\n]/g, " ").trim().trimEnd().trimStart()),
                "multiCommands": commandTexts,
                "fileGuid": selectedAttachedFileguid,
                "isFullFileContent": isFullFileContent,
                "configConversatio": configConversationa,
                "configResponseLength": configResponseLength,
                "option_selected": configTab
            },
            timeout: _timeoutTime
        }

        // this.scrollToBottom();
        await axios(config).then((response) => {
            let _summarizeText = "", requestTokenCount = 0, responseTokenCount = 0;
            if (response.data.summarizeText) {
                _summarizeText = response.data.summarizeText ? response.data.summarizeText.trim() : ""
                if (response.data.requestTokenCount)
                    requestTokenCount = response.data.requestTokenCount;
                if (response.data.responseTokenCount)
                    responseTokenCount = response.data.responseTokenCount;

                this.setState({ lastCommandType: _commandType }, () => {
                    /*if (_commandType !== 'Summarize') {
                        _summarizeText = _summarizeText.replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/\n/g, '<br/>')
                    }*/

                    chatConversation.push({ _commandType: _commandType, from: summarizeResult, message: _summarizeText, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, commandText: _commandText, orignalText: _orignalText, IsSucceed: true, isFromOriginalText: true })
                })
                //this.indexData(_orignalText.replace(/[\r\n]/g, " ").trim(), _summarizeText, commandText, commandType, summarizeText, sessionID, requestTokenCount, responseTokenCount, [], []);
                //this.indextrackingData(clone(eventid), (isFirstQuestion && questionIndex === 0) ? "MainQuestion" : "FollowUpQuestion", questionItem, response.rephrased_question, response.output_answer, _attachedFiles, response.sources_multi, response.display_string_multi, response.combined_summary, _lastCreatedDatehour, query.length > 1, singleQuery, `150`, `5`, true, true, commandType, '');
                this.indextrackingData(clone(eventid), isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", _orignalText.replace(/[\r\n]/g, " ").trim(), "", '', _attachedFiles, [], [], _summarizeText, _lastCreatedDatehour, false, true, ``, ``, true, true, _commandType, _summarizeText, _commandText);
            } else {
                chatConversation.push({ _commandType: _commandType, from: summarizeResult, message: `We don't know the answer.<br>Kindly try after some time.`, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, commandText: _commandText, orignalText: _orignalText, IsSucceed: false, isFromOriginalText: true })
                this.indextrackingData(clone(eventid), isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", _orignalText.replace(/[\r\n]/g, " ").trim(), "", '', _attachedFiles, [], [], `We don't know the answer.<br>Kindly try after some time.`, _lastCreatedDatehour, false, true, ``, ``, true, true, _commandType, `We don't know the answer.<br>Kindly try after some time.`, _commandText);
            }

            this.setState({
                chatConversation: chatConversation,
                summarizeText: (_commandType === "Summarize" || _commandType === "UserInstructions" || _commandType === "Translate" || _commandType === "QnA" || _commandType === "Multi-Doc Summary") ? (response.data.summarizeText ? response.data.summarizeText.trim() : "") : _summarizeText
            });
        }).catch((error) => {
            chatConversation.push({ _commandType: _commandType, from: summarizeResult, message: `Service is unavailable at this time, Kindly try after some time.`, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, commandText: _commandText, orignalText: _orignalText, IsSucceed: false, isFromOriginalText: true })
            this.indextrackingData(clone(eventid), isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", _orignalText.replace(/[\r\n]/g, " ").trim(), "", '', _attachedFiles, [], [], `Service is unavailable at this time, Kindly try after some time.`, _lastCreatedDatehour, false, true, ``, ``, false, false, _commandType, `Service is unavailable at this time, Kindly try after some time.`, _commandText);
            this.setState({ chatConversation: chatConversation });
            console.log(error)
        }).finally(() => {
            this.setState({
                isChatConversationSpinner: false, isConfirm: false, isClearAllFields: false,
                previousOrignalText: _orignalText.replace(/[\r\n]/g, " ").trim().trimEnd().trimStart(), firstCall: false,
                commandText: ""
            }, () => {
                this.scrollToBottom();
            });
        });
    }
    processCreateTableForContainsImage = async () => {
        let { sessionID, chatHistory, selectedAttachedFileguid, previousOrignalText, orignalText, commandText, isClearAllFields, isFirstQuestion, attachedFiles, threadID, selectedFilters, renderfilters, isMultiFileThread, commandType, summarizeText } = this.state;
        let _chatConversation = this.state.chatConversation;
        let _lastCreatedDatehour = getCurrentDate();
        let _commandType = commandType;
        let _commandText = commandText;
        let _orignalText = orignalText;
        let url = '';
        let _chatHistory = [];
        this.setState({ isChatConversationSpinner: true, spinnerMessage: "Please wait..." })
        let _threadAttachedFiles = clone(attachedFiles.map(x => { return { name: x.name } }));
        url = `${_locationOrigin}${process.env.REACT_APP_IMS_API_MULTI_ANSWERS}multi_answers`
        if (window.location.origin === 'https://predev-ims.jnj.com') {
            url = `${window.location.origin}${process.env.REACT_APP_IMS_API_MULTI_ANSWERS}multi_answers`
        }
        let userAccessGroup = JSON.parse(localStorage.getItem('accessgroup'))
        // this.setState({ isProcessing: true, spinnerMessage: "Please wait..." })
        _chatHistory = this.processChatHistories(_chatConversation.length);
        let _sourceSearchId = this.processSourceSearchIds(_chatConversation.length);
        var config;
        let filterStr = "";
        let selectedFilter = [];
        var eventid = uuidv4();
        let _attachedFiles = attachedFiles.map(x => { return { name: x.name } })
        let _function = localStorage.getItem('function').replace(/"/g, '');
        if (userAccessGroup.includes("AllContent") && userAccessGroup.includes("MISEHCP") && !userAccessGroup.includes("VESE")) {
            _function = `MISE;${localStorage.getItem('function').replace(/"/g, '')}`;
        }
        else if (userAccessGroup.includes("AllContent") && userAccessGroup.includes("MISEHCP") && userAccessGroup.includes("VESE")) {
            _function = `MISE;V&ESE;${localStorage.getItem('function').replace(/"/g, '')}`;
        }
        else if (userAccessGroup.includes("MISEHCP")) {
            _function = `MISE`;
        }
        else if (userAccessGroup.includes("AllContent")) {
            _function = localStorage.getItem('function').replace(/"/g, '');
        }
        Object.keys(GenAI2DocTypes).map(key => {
            selectedFilter.push(GenAI2DocTypes[key]);
        })
        filterStr = this.generateArrayString(selectedFilter);
        let query = ["Create Table From image"];

        const _headers = {
            'Content-Type': 'application/json'
        }
        if (await Authentication.isAccessTokenAvailable()) {
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }

        config = {
            method: 'POST',
            url: url,
            headers: _headers,
            data: {
                "query": query,
                "filters": filterStr,
                "function": _function,
                "doctypepref": localStorage.getItem('doctypepref').replace(/"/g, ''),
                "userproducts": localStorage.getItem('userproducts'),
                "region": localStorage.getItem('region'),
                "username": localStorage.getItem('username').toLowerCase().replace(/"/g, ''),
                "contentpreference": localStorage.getItem('contentpreference').replace(/"/g, ''),
                "source": "docTitle,documentNumber,downloadUrl,docType,searchID,year,fileName",
                "from": 0,
                "size": 7,
                "sortBy": "",
                "sortField": "",
                "defaultOperator": "or",
                "sessionID": sessionID,
                "threadID": threadID,
                "chat_history": _chatHistory,
                "sourceSearchId": _sourceSearchId,
                "isFirstQuestion": _chatConversation.length === 0,
                "IsComprehensive": false,
                "isMoreInformation": false,
            },
            timeout: _timeoutTime
        }
        await axios(config)
            .then(async (resp) => {
                let _createTextOrignalText = '';
                query.map((questionItem, questionIndex) => {
                    let response = resp.data[questionIndex];
                    let SourcesMultiFiles = response.sources_multi;
                    let DisplayStringMultiFiles = response.display_string_multi;
                    SourcesMultiFiles.map((smitem, smindex) => {
                        let filterDisplayStringMultiFiles = DisplayStringMultiFiles;
                        filterDisplayStringMultiFiles.map((dsitem, dsindex) => {
                            _createTextOrignalText = dsitem.display_ans;
                        })
                    })
                })
                let _message = "";
                _message = _commandText ? `${commandType}\n${_commandText}` : `${commandType}`;
                _message = _message.trim().replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/\n/g, '<br/>')
                _chatConversation.push({ from: userQuestion, message: _message, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, IsSucceed: true, isFromOriginalText: true })
                this.setState({ chatConversation: _chatConversation, isProcessing: true }, () => {
                    this.scrollToBottom();
                });
                _orignalText = _createTextOrignalText.replace(/[\r\n]/g, " ").trim();
                let commandTexts = (_commandType === 'UserInstructions') ? commandText.trim().split(/\n\n/g) : [];
                if (ShowWordCountForCommandType.includes(commandType)) {
                    _orignalText = _orignalText.replace(/[\r\n]/g, " ").trim().split(' ').filter((x, i) => i < WordsMaxLength).join(' ')
                }
                let config = {}

                var url = `${_locationOrigin}${process.env.REACT_APP_IMS_API_NLP_SUMMARIZE}summarize_api2`
                if (window.location.origin === 'https://predev-ims.jnj.com') {
                    url = `${window.location.origin}${process.env.REACT_APP_IMS_API_NLP_SUMMARIZE}summarize_api2`
                }

                const _headers = {
                    'Content-Type': 'application/json'
                }
                if (await Authentication.isAccessTokenAvailable()) {
                    const token = await Authentication.getAccessToken();
                    _headers.Authorization = `Bearer ${token}`;
                }

                config = {
                    method: 'POST',
                    url: url,
                    headers: _headers,
                    data: {
                        "orignalText": _orignalText.replace(/[\r\n]/g, " ").trim(),
                        "commandType": commandType,
                        "commandText": commandText,
                        "username": localStorage.getItem('username').toLowerCase().replace(/"/g, ''),
                        "sessionID": sessionID,
                        "wwid": JSON.parse(localStorage.getItem('wwid')),
                        "previousSummarizeText": summarizeText.replace(/[\r\n]/g, " ").trim(),
                        "searchID": "",
                        "isClearAllFields": isClearAllFields,
                        "isNewOrignalText": (previousOrignalText !== _orignalText.replace(/[\r\n]/g, " ").trim().trimEnd().trimStart()),
                        "multiCommands": commandTexts,
                        "fileGuid": selectedAttachedFileguid,
                        "isFullFileContent": false

                    },
                    timeout: _timeoutTime
                }

                // this.scrollToBottom();
                await axios(config).then((response) => {
                    _orignalText = _orignalText.replace(/<br\/>/g, '\n').replace(/<br>/g, '\n');
                    _orignalText = _orignalText.replace(/(<([^>]+)>)/ig, '');
                    let _summarizeText = "", requestTokenCount = 0, responseTokenCount = 0;
                    if (response.data.summarizeTable && response.data.summarizeTable.length > 0) {
                        this.setState({ lastCommandType: _commandType }, () => {
                            let summarizeTables = response.data.summarizeTable;
                            if (response.data.requestTokenCount)
                                requestTokenCount = response.data.requestTokenCount;
                            if (response.data.responseTokenCount)
                                responseTokenCount = response.data.responseTokenCount;

                            if (summarizeTables.length === 1) {
                                _summarizeText = summarizeTables[0];
                                _chatConversation.push({ _commandType: _commandType, from: summarizeResult, message: summarizeTables[0], messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, commandText: _commandText, orignalText: _orignalText, IsSucceed: true });
                                this.indexData(_orignalText.replace(/[\r\n]/g, " ").trim(), _summarizeText, commandText, commandType, summarizeText, sessionID, requestTokenCount, responseTokenCount, [], []);
                            }
                        })
                    } else {
                        _chatConversation.push({ _commandType: _commandType, from: summarizeResult, message: `We don't know the answer.<br>Kindly try after some time.`, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, commandText: _commandText, orignalText: _orignalText, IsSucceed: false })
                    }
                    this.setState({
                        chatConversation: _chatConversation,
                        summarizeText: (_commandType === "Summarize" || _commandType === "UserInstructions" || _commandType === "Translate" || _commandType === "QnA") ? (response.data.summarizeText ? response.data.summarizeText.trim() : "") : _summarizeText
                    });
                }).catch((error) => {
                    _chatConversation.push({ _commandType: _commandType, from: summarizeResult, message: `Service is unavailable at this time, Kindly try after some time.`, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, commandText: _commandText, orignalText: _orignalText, IsSucceed: false, isFromOriginalText: true })
                    this.setState({ chatConversation: _chatConversation });
                    console.log(error)
                }).finally(() => {
                    this.setState({
                        isProcessing: false, isConfirm: false, isClearAllFields: false, previousOrignalText: _orignalText.replace(/[\r\n]/g, " ").trim().trimEnd().trimStart(), firstCall: false,
                        commandText: ""
                    }, () => {
                        this.scrollToBottom();
                    });
                });
            })
            .catch(async (error) => {
                let _message = "";
                _message = _commandText ? `${commandType}\n${_commandText}` : `${commandType}`;
                _message = _message.trim().replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/\n/g, '<br/>')
                _chatConversation.push({ from: userQuestion, message: _message, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, IsSucceed: true, isFromOriginalText: true })
                _chatConversation.push({ _commandType: _commandType, from: summarizeResult, message: `Service is unavailable at this time, Kindly try after some time.`, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, commandText: _commandText, orignalText: _orignalText, IsSucceed: false, isFromOriginalText: true })
            })
            .finally(async () => {
                this.setState({
                    chatConversation: _chatConversation,
                    isChatConversationSpinner: false,
                    //commandText: '',
                    chatHistory: chatHistory,
                    isFirstQuestion: false,
                    renderfilters: renderfilters,
                    selectedFilters: selectedFilters,
                    spinnerMessage: "",
                    commandText: ""
                }, async () => {
                    this.scrollToBottom();
                })
            });
    }
    renderFileIcon = (name) => {
        if (name.toLowerCase().endsWith('.pdf')) {
            return (<><img src={GenAiPDFIcon} style={{ marginBottom: "5px" }} /></>)
        }
        else if (name.toLowerCase().endsWith('.doc') || name.toLowerCase().endsWith('.docx')) {
            return (<><img src={GenAiDOCIcon} style={{ marginBottom: "5px" }} /></>)
        }
        else if (name.toLowerCase().endsWith('.ppt') || name.toLowerCase().endsWith('.pptx')) {
            return (<><img src={GenAiPPTIcon} style={{ marginBottom: "2px" }} /></>)
        } else if (name.toLowerCase().endsWith('.jpg')
            || name.toLowerCase().endsWith('.jpeg')
            || name.toLowerCase().endsWith('.png')
            || name.toLowerCase().endsWith('.gif')) {
            return (<><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#000000" stroke-width="1" stroke-linecap="round" stroke-linejoin="miter">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                    <polygon points="22 15.5 17 10 10.59 16.99 6.5 13 2 17.5 2 22 22 22 22 15.5" stroke-width="0" fill="#059cf7" opacity="0.1"></polygon>
                    <polygon points="22 15.5 17 10 10.59 16.99 6.5 13 2 17.5 2 22 22 22 22 15.5"></polygon>
                    <rect x="2" y="2" width="20" height="20" rx="0"></rect>
                    <line x1="6.99" y1="7" x2="7" y2="7" stroke-linecap="round" stroke-width="2"></line>
                </g>
            </svg> &nbsp;</>)
        }
        else {
            return (<svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="file" class="svg-inline--fa fa-file fa-fw fa-1x " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M320 464c8.8 0 16-7.2 16-16V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320zM0 64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64z"></path></svg>)
        }
    }

    handleClickOnCitationNumber = (document_guid, pageNumbers) => {
        let { attachedFiles, sessionID } = this.state
        let isTextfile = false;
        if (sessionID && document_guid) {
            let isTextfile = attachedFiles.map(x => x.guid).filter(x => x && x === document_guid).length > 0 ? false : true
            if (!isTextfile) {
                let prviewObject = {
                    selectedSource: attachedFiles.filter(x => x.guid === document_guid),
                    selectedPageNumber: pageNumbers,
                    attachedFiles: attachedFiles,
                }
                let width = 0.99 * window.innerWidth
                let height = 1.05 * window.innerHeight
                let left = 0.05 * window.innerWidth
                let top = 0.05 * window.innerHeight
                let windowPreview = window.open(`/Authoring-AI-Preview/${sessionID}?docid=${document_guid}`, '', `width=${width},height=${height},top=${top},left=${left},toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=no,resizable=no,copyhistory=no`)
                windowPreview[`${sessionID}-${document_guid}`] = prviewObject

            } else {
                this.setState({ citationTextId: document_guid })
            }
        }
    }
    renderDisplayStringMultiFiles = (conversation) => {
        let { SourcesMultiFiles, Question, questionType, DisplayStringMultiFiles, OutputAnswer, isMultiFiles, eventid, threadAttachedFiles } = conversation;
        let { sessionID, threadID, attachedFiles, selectedAttachedFileguid } = this.state;
        if (DisplayStringMultiFiles && DisplayStringMultiFiles.length > 0) {
            return (<div className="gen-ai-answering-result-main-answer-wrapper">{
                SourcesMultiFiles.map((smitem, smindex) => {
                    let filterDisplayStringMultiFiles = DisplayStringMultiFiles.filter(x => x.source_no.includes(smindex + 1));
                    let isImageUpload = threadAttachedFiles.some(x =>
                        x.name.toLowerCase().endsWith('.gif')
                        || x.name.toLowerCase().endsWith('.jpeg')
                        || x.name.toLowerCase().endsWith('.jpg')
                        || x.name.toLowerCase().endsWith('.png'))
                    if (isImageUpload) {
                        filterDisplayStringMultiFiles = DisplayStringMultiFiles;
                    }
                    return (<>
                        {(this.state.commandType !== 'Multi-Doc Summary') && <div className="gen-ai-answering-result-main-answer-display-string-multi-files-document-title">
                            <b>
                                {this.renderFileIcon(smitem.document_title)}
                                {/* <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="file" className="svg-inline--fa fa-file " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512">
                                        <path fill="currentColor" d="M320 464c8.8 0 16-7.2 16-16V160H256c-17.7 0-32-14.3-32-32V48H64c-8.8 0-16 7.2-16 16V448c0 8.8 7.2 16 16 16H320zM0 64C0 28.7 28.7 0 64 0H229.5c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3V448c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V64z"></path></svg>*/}File: {smitem.document_title}</b>
                        </div>}
                        {
                            filterDisplayStringMultiFiles.map((dsitem, dsindex) => {
                                //dsitem.display_ans = dsitem.display_ans.replace(/<br\/>/g, '').replace(/<br>/g, '')
                                dsitem.display_ans = dsitem.display_ans.replace(/<li><br>/g, '<li>');
                                return (<GenAIAuthoringDisplayString key={`gen-ai-answering-result-main-answer${dsindex}`}
                                    displayAns={dsitem.display_ans} sourceNo={dsitem.source_no}
                                    contextIds={dsitem.context_id}
                                    pageNumber={dsitem.page_number} sources={SourcesMultiFiles}
                                    isMultiFiles={isMultiFiles} attachedFiles={attachedFiles}
                                    eventid={eventid}
                                    DisplayString={DisplayStringMultiFiles}
                                    handleClickOnCitationNumber={this.handleClickOnCitationNumber}
                                    sessionID={sessionID} Question={Question} questionType={questionType} threadID={threadID} />)
                            })
                        }
                        {(SourcesMultiFiles.length > smindex + 1) && <hr style={{ margin: "10px 00px" }}></hr>}
                    </>)
                })
            }</div>)
        } else {
            let isImageUpload = threadAttachedFiles.some(x =>
                x.name.toLowerCase().endsWith('.gif')
                || x.name.toLowerCase().endsWith('.jpeg')
                || x.name.toLowerCase().endsWith('.jpg')
                || x.name.toLowerCase().endsWith('.png'))
            if (isImageUpload) {
                return (<div className="gen-ai-answering-result-main-answer-wrapper">
                    <span dangerouslySetInnerHTML={{ __html: sanitize(`${OutputAnswer}`) }} />
                </div>)
            } else {
                if (OutputAnswer === "We don't know the answer. Can you try new questions.") {
                    OutputAnswer = `No Answer found. Please try a new question.`;
                }
                return (<div className="gen-ai-answering-result-main-answer-wrapper">
                    {OutputAnswer}
                </div>)
            }
        }
    }
    renderDisplayStringMultiFilesForMulti = (conversation) => {
        let { SourcesMultiFiles, Question, questionType, DisplayStringMultiFiles, OutputAnswer, isMultiFiles, eventid, threadAttachedFiles } = conversation;
        let { sessionID, threadID, attachedFiles, selectedAttachedFileguid } = this.state;
        if (DisplayStringMultiFiles && DisplayStringMultiFiles.length > 0) {
            return (<div className="gen-ai-answering-result-main-answer-wrapper">{
                DisplayStringMultiFiles.map((dsitem, dsindex) => {
                    //let filterDisplayStringMultiFiles = DisplayStringMultiFiles;
                    let isImageUpload = threadAttachedFiles.some(x =>
                        x.name.toLowerCase().endsWith('.gif')
                        || x.name.toLowerCase().endsWith('.jpeg')
                        || x.name.toLowerCase().endsWith('.jpg')
                        || x.name.toLowerCase().endsWith('.png'))
                    /*if (isImageUpload) {
                        filterDisplayStringMultiFiles = DisplayStringMultiFiles;
                    }*/
                    dsitem.display_ans = dsitem.display_ans.replace(/<li><br>/g, '<li>');
                    return (<>

                        {
                            //dsitem.display_ans = dsitem.display_ans.replace(/<br\/>/g, '').replace(/<br>/g, '')

                            <GenAIAuthoringDisplayStringMultiCommand key={`gen-ai-answering-result-main-answer${dsindex}`}
                                displayAns={dsitem.display_ans} sourceNo={dsitem.source_no}
                                contextIds={dsitem.context_id}
                                pageNumber={dsitem.page_number} sources={SourcesMultiFiles}
                                isMultiFiles={isMultiFiles} attachedFiles={attachedFiles}
                                eventid={eventid}
                                DisplayString={DisplayStringMultiFiles}
                                handleClickOnCitationNumber={this.handleClickOnCitationNumber}
                                sessionID={sessionID} Question={Question} questionType={questionType} threadID={threadID} />
                        }
                    </>)
                })
            }</div>)
        } else {
            let isImageUpload = threadAttachedFiles.some(x =>
                x.name.toLowerCase().endsWith('.gif')
                || x.name.toLowerCase().endsWith('.jpeg')
                || x.name.toLowerCase().endsWith('.jpg')
                || x.name.toLowerCase().endsWith('.png'))
            if (isImageUpload) {
                return (<div className="gen-ai-answering-result-main-answer-wrapper">
                    <span dangerouslySetInnerHTML={{ __html: sanitize(`${OutputAnswer}`) }} />
                </div>)
            } else {
                if (OutputAnswer === "We don't know the answer. Can you try new questions.") {
                    OutputAnswer = `No Answer found. Please try a new question.`;
                }
                return (<div className="gen-ai-answering-result-main-answer-wrapper">
                    {OutputAnswer}
                </div>)
            }
        }
    }
    renderSourcesMultiFiles = (conversation) => {
        let { chatConversation, attachedFiles, } = this.state;
        // if (conversation && conversation.SourcesMultiFiles && conversation.SourcesMultiFiles.length > 0) {
        //     let sourceGuiid = conversation.SourcesMultiFiles.map(x => x.file_guid);
        //     console.log(attachedFiles)
        //     let fil_att = attachedFiles.filter(x => !x.name.toLowerCase().endsWith('.txt'))
        //     const updated = attachedFiles.filter(x => x.name.toLowerCase().endsWith('.txt')).map(({ id,name, ...rest }) => ({
        //         guid: `${id}`,
        //         newFileName: name,
        //         ...rest
        //     }))
        //     sourceGuiid = sourceGuiid.filter((item, index, self) => { return self.indexOf(item) === index });
        //     let attachedFileNew = sourceGuiid.map((val) => {
        //         return fil_att.concat(updated).filter(x => x.guid === val)[0]
        //     })
        //     console.log(attachedFileNew)
        //     return (
        //         <div className="gen-ai-answering-result-source-main">
        //             <div className="gen-ai-answering-result-source-header">
        //                 <div className="gen-ai-answering-result-source-header-icon">
        //                     <div className="w-[24px]">
        //                         <svg aria-hidden="true" focusable="false" data-prefix="far" data-icon="list-timeline" className="svg-inline--fa fa-list-timeline fa-fw " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        //                             <path fill="currentColor" d="M219.9 112H400V80H219.9l-16 16 16 16zm-72.6-4.7c-6.2-6.2-6.2-16.4 0-22.6l43.3-43.3c6-6 14.1-9.4 22.6-9.4H416c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H213.3c-8.5 0-16.6-3.4-22.6-9.4l-43.3-43.3zM64 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm0 160a32 32 0 1 1 0-64 32 32 0 1 1 0 64zM32 416a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm187.9 16H400V400H219.9l-16 16 16 16zm-72.6-4.7c-6.2-6.2-6.2-16.4 0-22.6l43.3-43.3c6-6 14.1-9.4 22.6-9.4H416c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H213.3c-8.5 0-16.6-3.4-22.6-9.4l-43.3-43.3zM203.9 256l16 16H464V240H219.9l-16 16zm-13.3 54.6l-43.3-43.3c-6.2-6.2-6.2-16.4 0-22.6l43.3-43.3c6-6 14.1-9.4 22.6-9.4H480c17.7 0 32 14.3 32 32v64c0 17.7-14.3 32-32 32H213.3c-8.5 0-16.6-3.4-22.6-9.4z"></path>
        //                         </svg>
        //                     </div>
        //                 </div>
        //                 <div className="gen-ai-answering-result-source-header-title">Sources</div>
        //             </div>
        //             <div className="gen-ai-answering-result-source-items-wrapper">
        //                 <div className="gen-ai-answering-result-source-items" style={{ width: `${conversation.SourcesMultiFiles.length * 185}`, flexWrap: "wrap" }}>
        //                     {attachedFileNew.map((val, indi) => {
        //                         let contextSource = conversation.SourcesMultiFiles.filter(x => x.file_guid === val.guid)
        //                         let contextDisplay = conversation.DisplayStringMultiFiles.map(x => x.context_id)
        //                         //checking the Source context is present in displayContext or not
        //                         let result = []
        //                         contextDisplay = this.flattenArray(contextDisplay, result)
        //                         let isPresent = contextSource.map(x => contextDisplay.includes(x.context_id));
        //                         let finalContext = []
        //                         if (isPresent.indexOf(false) === -1) {
        //                             finalContext = contextSource
        //                         } else {
        //                             //finding the context that are not there in the display string
        //                             const nonContext = finalContext.map((val, index) => {
        //                                 if (val === false) {
        //                                     return index
        //                                 }
        //                             })
        //                             //removing those context
        //                             finalContext = contextSource.filter((x, index) => !nonContext.includes(index))
        //                         }
        //                         /*let conArray = []
        //                         let contextFilter = conversation.DisplayStringMultiFiles.map(x => x.context_id).map((arr) => {
        //                             arr.map(val => conArray.push(val))
        //                         })
        //                         let finalContext = contextSource.map((contextSource) => {
        //                             let isPresent = conArray.includes(contextSource.context_id)
        //                             if (isPresent) {
        //                                 return (contextSource.context_id)
        //                             }
        //                         })*/
        //                         if (finalContext.length > 0) {
        //                             return (
        //                                 <div className="gen-ai-answering-result-source-item" key={`gen-ai-answering-result-source-item${indi}`}>
        //                                     <div className="gen-ai-answering-result-source-item-title-wrapper gen-ai-answering-result-source-margin"
        //                                         onClick={() => this.handleClickOnCitationNumber(val.guid, [1])}>
        //                                         <span
        //                                             className="gen-ai-answering-result-source-item-title">{val.newFileName}
        //                                         </span>
        //                                     </div>
        //                                     {(finalContext.length > 0) && <div className="gen-ai-answering-result-source-item-citations">
        //                                         <div className="gen-ai-answering-result-source-item-citation-lable gen-ai-answering-result-source-item-citation-lable-custome gen-ai-answering-result-source-margin"><b>Citation:</b></div>
        //                                         <div className="gen-ai-answering-result-source-item-citation-number">
        //                                             {
        //                                                 finalContext.map((conItem, consIndex) => {

        //                                                     //let _displayStringFilter = conversation.DisplayStringMultiFiles.filter(x => x.context_id /*&& x.context_id.includes(conItem)*/);

        //                                                     //if (_displayStringFilter.length > 0) {
        //                                                     //let _displayStringSingle = _displayStringFilter[0];
        //                                                     //let displayIndex = _displayStringSingle.context_id.findIndex(x => x === conItem.context_id);
        //                                                     return (<Tippy content={<>
        //                                                         <div className="gen-ai-answering-result-source-margin">
        //                                                             {val.newFileName}
        //                                                         </div>
        //                                                         <div className="gen-ai-answering-result-source-margin">
        //                                                             Pages: {conItem.page_number}
        //                                                             {/*Pages: {conversation.SourcesMultiFiles[conItem - 1].page_number}*/}
        //                                                         </div></>}>
        //                                                         <label custom-document-title={val.newFileName} custom-pages key={`gen-ai-answering-result-main-answer-label-${consIndex}`}
        //                                                             onClick={() => {
        //                                                                 this.handleClickOnCitationNumber(conItem.file_guid, [conItem.page_number])
        //                                                             }} className="gen-ai-answering-result-main-answer-source-label">{conItem.context_id}</label>
        //                                                     </Tippy>)
        //                                                     /*} else {
        //                                                         return (<Tippy content={<>
        //                                                             <div className="gen-ai-answering-result-source-margin">
        //                                                                 {conversation.document_title}
        //                                                             </div>
        //                                                         </>}>
        //                                                             <label custom-document-title={conversation.document_title} key={`gen-ai-answering-result-main-answer-label-${consIndex}`} className="gen-ai-answering-result-main-answer-source-label"
        //                                                                 onClick={() => {
        //                                                                     this.handleClickOnCitationNumber(val.guid,
        //                                                                         [conversation.SourcesMultiFiles[conItem - 1].page_number])
        //                                                                 }}>{conItem}</label>
        //                                                         </Tippy>)
        //                                                     }*/
        //                                                 })
        //                                             }
        //                                         </div>
        //                                     </div>}
        //                                 </div>)
        //                         }
        //                     }
        //                     )}
        //                 </div>
        //             </div>
        //         </div>)
        // }
    }
    handleAddToNotebook = async (conversationIndex, conversation) => {
        let { sessionID, chatConversation } = this.state;
        let question = conversation.Question ? conversation.Question : (conversation._commandType === 'UserInstructions') ? conversation.commandText : conversation._commandType
        let summary = (conversation.message) ? conversation.message : conversation.DisplayStringMultiFiles.map(x => x.display_ans);
        summary = Array.isArray(summary) ? summary.join('') : summary

        if (sessionID && summary) {
            this.setState({ isProcessingNew: true })
            let res = await services.postAllNoteBookGenAISummary(sessionID, summary, question);
            if (res) {
                this.setState({ isProcessingNew: false, spinnerMessage: '' }, async () => {
                    await this.successAlertMessage('Summary Saved Successfully.')
                    this.setState({ rightIsProcessing: true })
                    await this.fetchSummary(sessionID);
                    this.setState({ rightIsProcessing: false })
                })
            } else {
                this.setState({ isProcessingNew: false, spinnerMessage: '' })
                this.errorAlertMessage('Something went wrong.Try again later.')
            }
        } else {
            this.errorAlertMessage('No content found.')
        }
    }
    handleOnClickSourceTextExpand = (conversationIndex, conversation, editTextVal, eventid) => {
        this.setState({
            expandSourceText: true, editText: editTextVal,
            editQuestion: {
                conversationIndex,
                conversation,
                eventid
            }
        })
    }
    handleCopyToClipBoardForNonQna = async (index) => {
        const textLayers = document.querySelector(`#authoring-ai-ans-${index}`)
        if (window.getSelection) {
            const selection = window.getSelection();
            const range = document.createRange();
            range.selectNodeContents(textLayers);
            selection.removeAllRanges();
            selection.addRange(range);
        }
        try {
            await document.execCommand('copy', true);
            setTimeout(() => {
                this.successAlertMessage('Copied to Clipboard.')
            }, 1000)
        } catch {
            this.errorAlertMessage('Something went wrong.Please try again later')
        }
        if (window.getSelection) {
            window.getSelection().removeAllRanges();
        }
        else if (document.selection) {
            document.selection.empty();
        }
    }
    handleCopyToClipBoardForQna = async (index) => {
        let _allSup = document.querySelectorAll(`#authoring-ai-ans-${index} .gen-ai-answering-result-main-answer-sup`);
        let _allFileIcon = document.querySelectorAll(`#authoring-ai-ans-${index} .gen-ai-answering-result-main-answer-display-string-multi-files-document-title > b > img`);
        if (_allSup && _allSup.length > 0) {
            for (let i = 0; i < _allSup.length; i++) {
                _allSup[i].style.visibility = "hidden"
            }
        }
        if (_allFileIcon && _allFileIcon.length > 0) {
            for (let i = 0; i < _allFileIcon.length; i++) {
                _allFileIcon[i].style.display = "none"
            }
        }
        const textLayers = document.querySelector(`#authoring-ai-ans-${index}`)
        if (window.getSelection) {
            const selection = window.getSelection();
            const range = document.createRange();
            range.selectNodeContents(textLayers);
            selection.removeAllRanges();
            selection.addRange(range);
        }
        try {
            await document.execCommand('copy', true);
            setTimeout(() => {
                this.successAlertMessage('Copied to Clipboard.')
            }, 1000)
        } catch {
            this.errorAlertMessage('Something went wrong.Please try again later')
        }
        if (window.getSelection) {
            window.getSelection().removeAllRanges();
        }
        else if (document.selection) {
            document.selection.empty();
        }
        if (_allSup && _allSup.length > 0) {
            for (let i = 0; i < _allSup.length; i++) {
                _allSup[i].style.visibility = "visible"
            }
        }
        if (_allFileIcon && _allFileIcon.length > 0) {
            for (let i = 0; i < _allFileIcon.length; i++) {
                _allFileIcon[i].style.display = "inline"
            }
        }
    }
    handleCopyToClipBoard = async (conversationIndex, conversation) => {
        let { sessionID } = this.state
        if (sessionID) {
            let summary = (conversation.message) ? conversation.message : conversation.DisplayStringMultiFiles.map(x => x.display_ans);
            summary = Array.isArray(summary) ? summary.join('') : summary
            summary = summary.replace(/<[^>]*>/g, '')
            try {
                await navigator.clipboard.writeText(summary)
                setTimeout(() => {
                    this.successAlertMessage('Copied to Clipboard.')
                }, 1000)
            } catch {
                this.errorAlertMessage('Something went wrong.Please try again later')
            }
        }
    }
    renderChatConversation = () => {
        let { chatConversation, isProcessing, isShowMore, previewURL, isChatConversationSpinner, isMultiQuestionProcessing, middleIsProcessing } = this.state;
        return (
            <>
                {(middleIsProcessing || isChatConversationSpinner) ? <><div ref={(el) => { this.messagesEnd = el; }}><ChatSkeleton /></div></> : <div className="chat-body" style={{ background: '#ffff' }}>
                    {chatConversation.map((conversation, conversationIndex) => {
                        if (conversation._commandType === "QnA" || conversation._commandType === "Multi-Doc Summary") {
                            let _result = '';
                            let _savingReference = '';
                            //let _result = conversation._commandType === 'Multi-Doc Summary' ? this.MultiResultChatConversation(conversation) : this.QnAResultChatConversation(conversation);
                            //let _savingReference = /*conversation._commandType === 'Multi-Doc Summary' ? this.MultiDocReference(conversation) :*/ this.QnAReference(conversation);
                            if (conversation.from === userQuestion) {
                                return (<>
                                    <div style={{ float: "left", clear: "both", height: "100px" }}
                                        ref={(el) => { this.messagesEnd = el; }}>
                                    </div>
                                    <NoteBookUser key={`my-message-${conversationIndex}`}
                                        conversationIndex={conversationIndex}
                                        conversation={conversation}
                                        handleOnClickSourceTextExpand={this.handleOnClickSourceTextExpand}
                                        handleRefreshQuery={this.handleRefreshQuery} />
                                </>)
                            } else {
                                return (
                                    <div className="note-book-ans-outer" key={`summery-message-${conversationIndex}`}>
                                        {/* <img alt='avatar' className="img-circle medium-image" src="https://bootdey.com/img/Content/avatar/avatar1.png" /> */}
                                        <div className="note-book-ans-body" style={{ height: 'auto' }}>
                                            <span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <path d="M4.5 22V17M4.5 7V2M2 4.5H7M2 19.5H7M13 3L11.2658 7.50886C10.9838 8.24209 10.8428 8.60871 10.6235 8.91709C10.4292 9.1904 10.1904 9.42919 9.91709 9.62353C9.60871 9.8428 9.24209 9.98381 8.50886 10.2658L4 12L8.50886 13.7342C9.24209 14.0162 9.60871 14.1572 9.91709 14.3765C10.1904 14.5708 10.4292 14.8096 10.6235 15.0829C10.8428 15.3913 10.9838 15.7579 11.2658 16.4911L13 21L14.7342 16.4911C15.0162 15.7579 15.1572 15.3913 15.3765 15.0829C15.5708 14.8096 15.8096 14.5708 16.0829 14.3765C16.3913 14.1572 16.7579 14.0162 17.4911 13.7342L22 12L17.4911 10.2658C16.7579 9.98381 16.3913 9.8428 16.0829 9.62353C15.8096 9.42919 15.5708 9.1904 15.3765 8.91709C15.1572 8.60871 15.0162 8.24209 14.7342 7.50886L13 3Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg></span>
                                            <div className="note-bookmessage-text txt-black notebook-message-text-animation" id={`authoring-ai-ans-${conversationIndex}`}>
                                                {(conversation._commandType === 'Multi-Doc Summary') ? this.renderDisplayStringMultiFilesForMulti(conversation) : this.renderDisplayStringMultiFiles(conversation)}
                                                {(conversation._commandType === 'Multi-Doc Summary' && conversation.SourcesMultiFiles) && this.renderSourcesMultiFiles(conversation)}
                                            </div>
                                        </div>
                                        <div className="note-book-ans-addtoNote note-book-footer-conc">
                                            {(conversation.IsSucceed) && <>
                                                <span title="Copy to Clipboard" className="add-to-notebook-action-text add-to-notebook-action-text-gpt" onClick={() => {
                                                    this.handleCopyToClipBoardForQna(conversationIndex)
                                                    //  this.handleCopyToClipBoard(conversationIndex, conversation)
                                                }}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                        <path d="M4.99989 2H9.73306C11.2265 2 11.9732 2 12.5436 2.29065C13.0454 2.54631 13.4533 2.95426 13.7089 3.45603C13.9996 4.02646 13.9996 4.77319 13.9996 6.26667V11M4.13326 14H9.53307C10.2798 14 10.6531 14 10.9383 13.8547C11.1892 13.7268 11.3932 13.5229 11.521 13.272C11.6663 12.9868 11.6663 12.6134 11.6663 11.8667V6.46667C11.6663 5.71993 11.6663 5.34656 11.521 5.06135C11.3932 4.81046 11.1892 4.60649 10.9383 4.47866C10.6531 4.33333 10.2798 4.33333 9.53307 4.33333H4.13326C3.38655 4.33333 3.01319 4.33333 2.72799 4.47866C2.47711 4.60649 2.27315 4.81046 2.14532 5.06135C2 5.34656 2 5.71993 2 6.46667V11.8667C2 12.6134 2 12.9868 2.14532 13.272C2.27315 13.5229 2.47711 13.7268 2.72799 13.8547C3.01319 14 3.38655 14 4.13326 14Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg></span>
                                                <span title="Add to Summary" className="add-to-notebook-action-text add-to-notebook-action-text-gpt" onClick={() => { this.handleAddToNotebook(conversationIndex, conversation) }}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                        <g clip-path="url(#clip0_991_3570)">
                                                            <path d="M13.3328 7.00001V4.53334C13.3328 3.41324 13.3328 2.85319 13.1148 2.42536C12.9231 2.04904 12.6171 1.74308 12.2408 1.55133C11.813 1.33334 11.253 1.33334 10.1329 1.33334H5.86639C4.74633 1.33334 4.18629 1.33334 3.75848 1.55133C3.38217 1.74308 3.07622 2.04904 2.88448 2.42536C2.6665 2.85319 2.6665 3.41324 2.6665 4.53334V11.4667C2.6665 12.5868 2.6665 13.1468 2.88448 13.5747C3.07622 13.951 3.38217 14.2569 3.75848 14.4487C4.18629 14.6667 4.74633 14.6667 5.86639 14.6667H7.99965M9.33294 7.33334H5.33308M6.66636 10H5.33308M10.6662 4.66668H5.33308M11.9995 14V10M9.99958 12H13.9994" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_991_3570">
                                                                <rect width="15.9994" height="16" rx="4" fill="white" />
                                                            </clipPath>
                                                        </defs>
                                                    </svg></span>
                                            </>}
                                        </div>
                                        <br />
                                    </div>
                                )
                            }
                            //previewURL ? this.handleAddToNotebookPreview(conversation.message, conversation.commandType, conversation.orignalText, conversation.commandText) : 
                        } else {
                            if (conversation.from === userQuestion) {
                                return (<>
                                    <div style={{ float: "left", clear: "both", height: "100px" }}
                                        ref={(el) => { this.messagesEnd = el; }}>
                                    </div>
                                    <NoteBookUser key={`my-message-${conversationIndex}`}
                                        conversationIndex={conversationIndex}
                                        conversation={conversation}
                                        handleRefreshQuery={this.handleRefreshQuery}
                                        handleOnClickSourceTextExpand={this.handleOnClickSourceTextExpand} />
                                    {chatConversation.length - 1 === conversationIndex && <div className="note-book-loader-container"><img style={{ height: '44px', width: '44px' }} src={imsLoader}></img></div>}

                                </>
                                )

                            } else {
                                return (
                                    <div className="note-book-ans-outer" key={`summery-message-${conversationIndex}`}>
                                        {/* <img alt='avatar' className="img-circle medium-image" src="https://bootdey.com/img/Content/avatar/avatar1.png" /> */}
                                        <div className="note-book-ans-body" style={{ height: 'auto' }}>
                                            <span><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                <path d="M4.5 22V17M4.5 7V2M2 4.5H7M2 19.5H7M13 3L11.2658 7.50886C10.9838 8.24209 10.8428 8.60871 10.6235 8.91709C10.4292 9.1904 10.1904 9.42919 9.91709 9.62353C9.60871 9.8428 9.24209 9.98381 8.50886 10.2658L4 12L8.50886 13.7342C9.24209 14.0162 9.60871 14.1572 9.91709 14.3765C10.1904 14.5708 10.4292 14.8096 10.6235 15.0829C10.8428 15.3913 10.9838 15.7579 11.2658 16.4911L13 21L14.7342 16.4911C15.0162 15.7579 15.1572 15.3913 15.3765 15.0829C15.5708 14.8096 15.8096 14.5708 16.0829 14.3765C16.3913 14.1572 16.7579 14.0162 17.4911 13.7342L22 12L17.4911 10.2658C16.7579 9.98381 16.3913 9.8428 16.0829 9.62353C15.8096 9.42919 15.5708 9.1904 15.3765 8.91709C15.1572 8.60871 15.0162 8.24209 14.7342 7.50886L13 3Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg></span>
                                            <div className="note-bookmessage-text txt-black notebook-message-text-animation" id={`authoring-ai-ans-${conversationIndex}`} dangerouslySetInnerHTML={{ __html: sanitize(conversation.message) }} />
                                        </div>
                                        <div className="note-book-ans-addtoNote note-book-footer-conc">
                                            {(conversation.IsSucceed) && <>
                                                <span title="Copy to Clipboard" className="add-to-notebook-action-text add-to-notebook-action-text-gpt" onClick={() => { this.handleCopyToClipBoardForNonQna(conversationIndex) }}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                        <path d="M4.99989 2H9.73306C11.2265 2 11.9732 2 12.5436 2.29065C13.0454 2.54631 13.4533 2.95426 13.7089 3.45603C13.9996 4.02646 13.9996 4.77319 13.9996 6.26667V11M4.13326 14H9.53307C10.2798 14 10.6531 14 10.9383 13.8547C11.1892 13.7268 11.3932 13.5229 11.521 13.272C11.6663 12.9868 11.6663 12.6134 11.6663 11.8667V6.46667C11.6663 5.71993 11.6663 5.34656 11.521 5.06135C11.3932 4.81046 11.1892 4.60649 10.9383 4.47866C10.6531 4.33333 10.2798 4.33333 9.53307 4.33333H4.13326C3.38655 4.33333 3.01319 4.33333 2.72799 4.47866C2.47711 4.60649 2.27315 4.81046 2.14532 5.06135C2 5.34656 2 5.71993 2 6.46667V11.8667C2 12.6134 2 12.9868 2.14532 13.272C2.27315 13.5229 2.47711 13.7268 2.72799 13.8547C3.01319 14 3.38655 14 4.13326 14Z" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                    </svg></span>
                                                <span title="Add to Summary" className="add-to-notebook-action-text add-to-notebook-action-text-gpt" onClick={() => { this.handleAddToNotebook(conversationIndex, conversation) }}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                        <g clip-path="url(#clip0_991_3570)">
                                                            <path d="M13.3328 7.00001V4.53334C13.3328 3.41324 13.3328 2.85319 13.1148 2.42536C12.9231 2.04904 12.6171 1.74308 12.2408 1.55133C11.813 1.33334 11.253 1.33334 10.1329 1.33334H5.86639C4.74633 1.33334 4.18629 1.33334 3.75848 1.55133C3.38217 1.74308 3.07622 2.04904 2.88448 2.42536C2.6665 2.85319 2.6665 3.41324 2.6665 4.53334V11.4667C2.6665 12.5868 2.6665 13.1468 2.88448 13.5747C3.07622 13.951 3.38217 14.2569 3.75848 14.4487C4.18629 14.6667 4.74633 14.6667 5.86639 14.6667H7.99965M9.33294 7.33334H5.33308M6.66636 10H5.33308M10.6662 4.66668H5.33308M11.9995 14V10M9.99958 12H13.9994" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                        </g>
                                                        <defs>
                                                            <clipPath id="clip0_991_3570">
                                                                <rect width="15.9994" height="16" rx="4" fill="white" />
                                                            </clipPath>
                                                        </defs>
                                                    </svg></span>
                                            </>}
                                        </div>
                                        <br />
                                    </div>
                                )
                            }
                            //previewURL ? this.handleAddToNotebookPreview(conversation.message, conversation.commandType, conversation.orignalText, conversation.commandText) :
                        }
                    })
                    }
                    {(isMultiQuestionProcessing || (this.state.isFromCore && isProcessing)) && <div style={{ margin: "5px 10% 2% 10%" }}>
                        <div style={{ fontSize: "12px", textAlign: "center" }} className="gen-ai-search-multi-question-loader">
                            <img src={imsLoader} alt="" width={50} height={50} />
                            <div className="saveModal-heading" style={{ color: "#EB1700" }}>{(this.state.isFromCore && isProcessing) ? (this.state.spinnerMessage) ? `${this.state.spinnerMessage}` : `Please wait while finding answers.` : 'Please wait while we generate answers for other questions.'}</div>
                            <hr style={{ margin: "5px 20px" }}></hr>
                        </div>
                    </div>}


                </div>}
            </>
        )
    }
    processChatHistories = (index) => {
        let { attachedFiles, chatConversation, threadID, sessionID } = this.state;
        let _chatHistories = {};
        let _chatConversation = Object.assign([], chatConversation);
        _chatConversation = _chatConversation.filter((x, i) => i < index).filter(x => x.threadID === threadID);
        if (chatConversation.length !== 0 && _chatConversation.length === 0 && index !== 0) {
            _chatConversation = Object.assign([], chatConversation);
            _chatConversation = _chatConversation.filter(x => x.threadID === threadID);
        }
        try {
            if (attachedFiles.length > 0) {
                attachedFiles.map((fileItem, fileIndex) => {
                    _chatHistories[fileItem.guid] = [];
                    let responseFilters = _chatConversation.filter(y => y.from === summarizeResult && (y._commandType === 'QnA' || y._commandType === 'Multi-Doc Summary')).filter(x => x.SourcesMultiFiles.findIndex(y => y.document_guid === fileItem.guid) > -1);
                    responseFilters.map((resItem, resIndex) => {
                        let indexOfSource = resItem.SourcesMultiFiles.findIndex(y => y.document_guid === fileItem.guid)
                        let restDisplayStringMultifilter = resItem.DisplayStringMultiFiles.filter(d => d.source_no.includes(indexOfSource + 1));
                        let finalAns = restDisplayStringMultifilter.map(x => x.display_ans).join(' ')
                        _chatHistories[fileItem.guid].push({ "Question": resItem.Question, "Answer": finalAns })
                    })
                })
            } else {
                _chatHistories[sessionID] = [];
                _chatConversation = _chatConversation.filter(x => x.isMultiFiles === false);
                _chatConversation.map((resItem, resIndex) => {
                    let finalAns = resItem.DisplayString.map(x => x.display_ans).join(' ');
                    _chatHistories[sessionID].push({ "Question": resItem.Question, "Answer": finalAns })
                })
            }
        } catch (error) {
            console.log(error)
        }
        return _chatHistories;
    }
    processSourceSearchIds = (index) => {
        let { chatConversation } = this.state;
        let _sourceSearchIds = [];
        try {
            let _chatConversation = Object.assign([], chatConversation);
            if (index - 1 >= 0 && index - 1 < _chatConversation.length) {
                _sourceSearchIds = _chatConversation[index - 1].Sources?.map(x => x.searchID);
            }
            _sourceSearchIds = uniq(_sourceSearchIds);
        } catch (error) {
            console.log(error)
        }
        return _sourceSearchIds;
    }
    generateArrayString = (array) => {
        let arrStr = ''
        array.map((item, index) => {
            if (index === array.length - 1) {
                arrStr += item
            }
            else {
                arrStr += item + ";"
            }
            return null
        })
        return arrStr
    }
    QnAResult = (conversation) => {
        let { OutputAnswer, SourcesMultiFiles, DisplayStringMultiFiles, isMultiFiles, RelevantInformation, threadAttachedFiles } = conversation;
        let _textDisplayString = '';
        try {

            let _displayStringMultiFiles = clone(conversation.DisplayStringMultiFiles);
            if (_displayStringMultiFiles && _displayStringMultiFiles.length > 0) {
                SourcesMultiFiles.map((smitem, smindex) => {
                    let filterDisplayStringMultiFiles = _displayStringMultiFiles.filter(x => x.source_no.includes(smindex + 1));
                    let isImageUpload = threadAttachedFiles.some(x =>
                        x.name.toLowerCase().endsWith('.gif')
                        || x.name.toLowerCase().endsWith('.jpeg')
                        || x.name.toLowerCase().endsWith('.jpg')
                        || x.name.toLowerCase().endsWith('.png'))
                    if (isImageUpload) {
                        filterDisplayStringMultiFiles = DisplayStringMultiFiles;
                    }
                    _textDisplayString += `<b>File: ${smitem.document_title}<\/b><br\/>`;
                    filterDisplayStringMultiFiles.map((dsitem, dsindex) => {
                        let _dsItem = clone(dsitem)
                        if (isImageUpload) {
                            // _dsItem.display_ans = _dsItem.display_ans.replace(/<br\/>/g, '\n').replace(/<br>/g, '\n')
                        } else {
                            //_dsItem.display_ans = _dsItem.display_ans.replace(/<br\/>/g, '').replace(/<br>/g, '')
                        }
                        // _dsItem.display_ans = _dsItem.display_ans.replace(/<li>/g, '\n- <li>');
                        _dsItem.display_ans = _dsItem.display_ans.replace(/<li><br>/g, '<li>');
                        let regex = /<\/ul>/i;
                        // _dsItem.display_ans = _dsItem.display_ans.replace(regex, '</ul>');
                        //_textDisplayString += _dsItem.display_ans.replace(/(<([^>]+)>)/ig, '')
                        _textDisplayString += _dsItem.display_ans;
                        if (_dsItem.context_id && Array.isArray(_dsItem.context_id)) {
                            _dsItem.context_id.map((ctitem, ctindex) => {
                                let _sourceIndex = SourcesMultiFiles.filter(x => x.contexts).findIndex(x => x.contexts.findIndex(y => y.context_id === ctitem) !== -1);
                                if (_sourceIndex > -1) {
                                    _textDisplayString += `[${ctitem}]`

                                } else {
                                    _textDisplayString += `[${ctitem}]`
                                }
                            })
                            _textDisplayString += `<br\/>`;
                        }
                    })
                    _textDisplayString += "<br\/><br\/>"
                })
                _textDisplayString += "Sources<br\/>"
                SourcesMultiFiles.map((conversation, conversationIndex) => {
                    if ((conversation.contexts && conversation.contexts.length > 0)) {
                        conversation.contexts = conversation.contexts.sort((a, b) => a.context_id - b.context_id);
                    }
                    _textDisplayString += `${conversationIndex + 1}. Document Name: ${conversation.document_title}<br\/>`
                    conversation.contexts.map((conItem, consIndex) => {
                        let _displayStringFilter = DisplayStringMultiFiles.filter(x => x.context_id && x.context_id.includes(conItem.context_id));
                        if (_displayStringFilter.length > 0) {
                            let _displayStringSingle = _displayStringFilter[0];
                            let displayIndex = _displayStringSingle.context_id.findIndex(x => x === conItem.context_id);

                            _textDisplayString += `Citation: [${conItem.context_id}], Pages No: [${[_displayStringSingle.page_number[displayIndex]].join(',')}]<br\/>`

                        } else {
                            _textDisplayString += `Citation: [${conItem.context_id}]<br\/>`
                        }
                    })
                })
            } else {
                if (OutputAnswer === "We don't know the answer. Can you try new questions.") {
                    OutputAnswer = `No Answer found. Please try a new question.`;
                }
                _textDisplayString = OutputAnswer;
            }

        } catch (error) {
            console.log(error)
            return "Sorry, something went wrong.";
        }
        return _textDisplayString;
    }
    QnAResultChatConversation = (conversation) => {
        let { OutputAnswer, SourcesMultiFiles, DisplayStringMultiFiles, isMultiFiles, RelevantInformation, threadAttachedFiles } = conversation;
        let _textDisplayString = '';
        try {

            let _displayStringMultiFiles = clone(conversation.DisplayStringMultiFiles);
            if (_displayStringMultiFiles && _displayStringMultiFiles.length > 0) {
                SourcesMultiFiles.map((smitem, smindex) => {
                    let filterDisplayStringMultiFiles = _displayStringMultiFiles.filter(x => x.source_no.includes(smindex + 1));
                    let isImageUpload = threadAttachedFiles.some(x =>
                        x.name.toLowerCase().endsWith('.gif')
                        || x.name.toLowerCase().endsWith('.jpeg')
                        || x.name.toLowerCase().endsWith('.jpg')
                        || x.name.toLowerCase().endsWith('.png'))
                    if (isImageUpload) {
                        filterDisplayStringMultiFiles = DisplayStringMultiFiles;
                    }
                    filterDisplayStringMultiFiles.map((dsitem, dsindex) => {
                        let _dsItem = clone(dsitem)
                        _textDisplayString += _dsItem.display_ans;
                        _textDisplayString += `<br\/>`;
                    })
                })
            } else {
                if (OutputAnswer === "We don't know the answer. Can you try new questions.") {
                    OutputAnswer = `No Answer found. Please try a new question.`;
                }
                _textDisplayString = OutputAnswer;
            }

        } catch (error) {
            console.log(error)
            return "Sorry, something went wrong.";
        }
        return _textDisplayString;
    }

    QnAReference = (conversation) => {
        let { OutputAnswer, SourcesMultiFiles, DisplayStringMultiFiles, isMultiFiles, RelevantInformation, threadAttachedFiles } = conversation;
        let _textDisplayString = '';
        try {
            let _displayStringMultiFiles = clone(conversation.DisplayStringMultiFiles);
            if (_displayStringMultiFiles && _displayStringMultiFiles.length > 0) {
                SourcesMultiFiles.map((conversation, conversationIndex) => {
                    if ((conversation.contexts && conversation.contexts.length > 0)) {
                        conversation.contexts = conversation.contexts.sort((a, b) => a.context_id - b.context_id);
                    }
                    _textDisplayString += `${conversationIndex + 1}. Document Name: ${conversation.document_title}\r\n`

                })
            } else {
                if (OutputAnswer === "We don't know the answer. Can you try new questions.") {
                    OutputAnswer = `No Answer found. Please try a new question.`;
                }
                _textDisplayString = OutputAnswer;
            }

        } catch (error) {
            console.log(error)
            return "Sorry, something went wrong.";
        }
        return _textDisplayString;
    }
    processMultiQuestions = async () => {
        let { attachedFiles, commandText, commandType } = this.state;
        let _newQuestion = commandText.trim().replace(/\r\n/g, '\n').replace(/\n\n/g, '\n');
        let _splitQuery = _newQuestion.trim().split(/\n\*\|\*\n/g).filter(x => x).map(y => y.trim());
        let questionBatchSize = 3;
        if (commandType === 'Multi-Doc Summary' && _splitQuery.length == 0) {
            this.setState({ isChatConversationSpinner: true, spinnerMessage: "Please wait..." })
            await this.runGenAISearch("");
            this.setState({ isMultiQuestionProcessing: false, lastCommandType: 'Multi-Doc Summary' })
        }
        else {
            if (attachedFiles.length > 3) {
                questionBatchSize = 1;
            }
            else if (attachedFiles.length > 1) {
                questionBatchSize = 2;
            }
            let totalquestionBatchs = Math.ceil(_splitQuery.length / questionBatchSize);
            this.setState({ isChatConversationSpinner: true, spinnerMessage: "Please wait..." })
            for (let i = 0; i < totalquestionBatchs; i++) {
                let _batch = _splitQuery.slice(i * questionBatchSize, (i * questionBatchSize) + questionBatchSize);
                await this.runGenAISearch(_batch);
                this.setState({ isMultiQuestionProcessing: true, isChatConversationSpinner: false, spinnerMessage: "" }, () => {
                    if (i === 0) {
                        this.scrollToBottom();
                    }
                })
            }
            this.setState({ isMultiQuestionProcessing: false, lastCommandType: commandType })
        }
    }
    runGenAISearch = async (query) => {
        let { sessionID, chatHistory, isFirstQuestion, attachedFiles, threadID, selectedFilters, renderfilters,
            isMultiFileThread, commandType, configConversationa, configActiveTab, configResponseLength, commandText, selectedFileSource } = this.state;
        let _chatConversation = this.state.chatConversation;
        let combined_summary = this.state.combined_summary;
        let _lastCreatedDatehour = getCurrentDate();
        let url = '';
        let _chatHistory = [];
        let configTab = configActiveTab === 0 ? 'Default' : configActiveTab === 1 ? 'Learning Guide' : 'Custom';

        let _threadAttachedFiles = clone(attachedFiles.map(x => { return { name: x.name } }));
        url = `${_locationOrigin}${process.env.REACT_APP_IMS_API_MULTI_ANSWERS}multi_answers`
        if (window.location.origin === 'https://predev-ims.jnj.com') {
            url = `${window.location.origin}${process.env.REACT_APP_IMS_API_MULTI_ANSWERS}multi_answers`
        }
        let userAccessGroup = JSON.parse(localStorage.getItem('accessgroup'))
        // this.setState({ isProcessing: true, spinnerMessage: "Please wait..." })
        _chatHistory = this.processChatHistories(_chatConversation.length);
        let _sourceSearchId = this.processSourceSearchIds(_chatConversation.length);
        var config;
        let filterStr = "";
        let selectedFilter = [];
        var eventid = uuidv4();
        let _attachedFiles = attachedFiles.map(x => { return { name: x.name } })
        let _function = localStorage.getItem('function').replace(/"/g, '');
        if (userAccessGroup.includes("AllContent") && userAccessGroup.includes("MISEHCP") && !userAccessGroup.includes("VESE")) {
            _function = `MISE;${localStorage.getItem('function').replace(/"/g, '')}`;
        }
        else if (userAccessGroup.includes("AllContent") && userAccessGroup.includes("MISEHCP") && userAccessGroup.includes("VESE")) {
            _function = `MISE;V&ESE;${localStorage.getItem('function').replace(/"/g, '')}`;
        }
        else if (userAccessGroup.includes("MISEHCP")) {
            _function = `MISE`;
        }
        else if (userAccessGroup.includes("AllContent")) {
            _function = localStorage.getItem('function').replace(/"/g, '');
        }
        Object.keys(GenAI2DocTypes).map(key => {
            selectedFilter.push(GenAI2DocTypes[key]);
        })
        let _summarizeText = '';
        filterStr = this.generateArrayString(selectedFilter);
        if (commandType === 'QnA') {
            const _headers = {
                'Content-Type': 'application/json'
            }
            if (await Authentication.isAccessTokenAvailable()) {
                const token = await Authentication.getAccessToken();
                _headers.Authorization = `Bearer ${token}`;
            }
            let attachedFilesPayload = [];
            attachedFilesPayload = this.state.selectedFileSource.filter(x => !x.name.toLowerCase().endsWith('.txt')).map(x => x.guid);
            config = {
                method: 'POST',
                url: url,
                headers: _headers,
                data: {
                    "query": query,
                    "filters": filterStr,
                    "function": _function,
                    "doctypepref": localStorage.getItem('doctypepref').replace(/"/g, ''),
                    "userproducts": localStorage.getItem('userproducts'),
                    "region": localStorage.getItem('region'),
                    "username": localStorage.getItem('username').toLowerCase().replace(/"/g, ''),
                    "contentpreference": localStorage.getItem('contentpreference').replace(/"/g, ''),
                    "source": "docTitle,documentNumber,downloadUrl,docType,searchID,year,fileName",
                    "from": 0,
                    "size": 7,
                    "sortBy": "",
                    "sortField": "",
                    "defaultOperator": "or",
                    "sessionID": sessionID,
                    "threadID": threadID,
                    "chat_history": _chatHistory,
                    "sourceSearchId": _sourceSearchId,
                    "isFirstQuestion": _chatConversation.length === 0,
                    "IsComprehensive": false,
                    "isMoreInformation": false,
                    "selected_files": attachedFilesPayload,
                    "configConversatio": configConversationa,
                    "configResponseLength": configResponseLength,
                    "option_selected": configTab

                },
                timeout: _timeoutTime
            }
            await axios(config)
                .then(async (resp) => {
                    query.map((questionItem, questionIndex) => {
                        let response = resp.data[questionIndex];
                        let singleQuery = query[questionIndex];
                        let isImageUpload = _attachedFiles.some(x =>
                            x.name.toLowerCase().endsWith('.gif')
                            || x.name.toLowerCase().endsWith('.jpeg')
                            || x.name.toLowerCase().endsWith('.jpg')
                            || x.name.toLowerCase().endsWith('.png'))
                        if (response.display_string_multi && response.display_string_multi.length > 0 || isImageUpload) {
                            _chatConversation.push({ from: userQuestion, _commandType: "QnA", IsSucceed: true, message: questionItem, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, eventid: clone(eventid), isMultiFiles: attachedFiles.length > 0, threadID: threadID, lastCreatedDatehour: _lastCreatedDatehour, threadAttachedFiles: _threadAttachedFiles, isGetAnyAns: true, isSuccess: true, isFromOriginalText: false })
                            _chatConversation.push({ from: summarizeResult, _commandType: 'QnA', IsSucceed: true, Question: questionItem, OutputAnswer: response.output_answer, Sources: [], SourcesMultiFiles: response.sources_multi, DisplayString: [], RelevantInformation: {}, ShowRelevantInformation: false, DisplayStringMultiFiles: response.display_string_multi, RecommandationResults: [], messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, questionType: isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", eventid: clone(eventid), isMultiFiles: attachedFiles.length > 0, selectedFilters: selectedFilters, renderfilters: renderfilters, combinedSummaryMultiFiles: response.combined_summary, threadID: threadID, Reaction: ReactNone, Feedback: '', lastCreatedDatehour: _lastCreatedDatehour, threadAttachedFiles: _threadAttachedFiles, isGetAnyAns: true, isSuccess: true })
                            this.indextrackingData(clone(eventid), (isFirstQuestion && questionIndex === 0) ? "MainQuestion" : "FollowUpQuestion", questionItem, response.rephrased_question, response.output_answer, _attachedFiles, response.sources_multi, response.display_string_multi, response.combined_summary, _lastCreatedDatehour, query.length > 1, singleQuery, `150`, `5`, true, true, commandType, '', singleQuery);
                            _summarizeText = this.QnAResult({ from: summarizeResult, _commandType: 'QnA', IsSucceed: true, Question: questionItem, OutputAnswer: response.output_answer, Sources: [], SourcesMultiFiles: response.sources_multi, DisplayString: [], RelevantInformation: {}, ShowRelevantInformation: false, DisplayStringMultiFiles: response.display_string_multi, RecommandationResults: [], messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, questionType: isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", eventid: clone(eventid), isMultiFiles: attachedFiles.length > 0, selectedFilters: selectedFilters, renderfilters: renderfilters, combinedSummaryMultiFiles: response.combined_summary, threadID: threadID, Reaction: ReactNone, Feedback: '', lastCreatedDatehour: _lastCreatedDatehour, threadAttachedFiles: _threadAttachedFiles, isGetAnyAns: true, isSuccess: true });
                        } else {
                            _chatConversation.push({ from: userQuestion, _commandType: 'QnA', IsSucceed: false, message: questionItem, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, eventid: clone(eventid), isMultiFiles: attachedFiles.length > 0, threadID: threadID, lastCreatedDatehour: _lastCreatedDatehour, threadAttachedFiles: _threadAttachedFiles, isGetAnyAns: true, isSuccess: true, isFromOriginalText: false })
                            _chatConversation.push({ from: summarizeResult, _commandType: 'QnA', IsSucceed: false, Question: questionItem, OutputAnswer: "No Answer found. Please try a new question.", Sources: [], SourcesMultiFiles: [], DisplayString: [], RelevantInformation: {}, ShowRelevantInformation: false, DisplayStringMultiFiles: [], RecommandationResults: [], messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, questionType: isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", eventid: clone(eventid), isMultiFiles: attachedFiles.length > 0, combinedSummaryMultiFiles: '', threadID: threadID, Reaction: ReactNone, Feedback: '', lastCreatedDatehour: _lastCreatedDatehour, threadAttachedFiles: _threadAttachedFiles, isGetAnyAns: false, isSuccess: true })
                            _summarizeText = this.QnAResult({ from: summarizeResult, _commandType: 'QnA', IsSucceed: false, Question: questionItem, OutputAnswer: "No Answer found. Please try a new question.", Sources: [], SourcesMultiFiles: [], DisplayString: [], RelevantInformation: {}, ShowRelevantInformation: false, DisplayStringMultiFiles: [], RecommandationResults: [], messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, questionType: isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", eventid: clone(eventid), isMultiFiles: attachedFiles.length > 0, combinedSummaryMultiFiles: '', threadID: threadID, Reaction: ReactNone, Feedback: '', lastCreatedDatehour: _lastCreatedDatehour, threadAttachedFiles: _threadAttachedFiles, isGetAnyAns: false, isSuccess: true });
                            this.indextrackingData(clone(eventid), (isFirstQuestion && questionIndex === 0) ? "MainQuestion" : "FollowUpQuestion", questionItem, response.rephrased_question, response.output_answer, _attachedFiles, response.sources_multi, response.display_string_multi, response.combined_summary, _lastCreatedDatehour, query.length > 1, singleQuery, `150`, `5`, true, true, commandType, "", singleQuery);
                        }
                        eventid = uuidv4();
                    })
                })
                .catch(async (error) => {
                    query.map((questionItem, questionIndex) => {
                        let singleQuery = query[questionIndex];
                        _chatConversation.push({ from: userQuestion, _commandType: 'QnA', IsSucceed: false, message: questionItem, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, eventid: clone(eventid), isMultiFiles: attachedFiles.length > 0, threadID: threadID, lastCreatedDatehour: _lastCreatedDatehour, threadAttachedFiles: _threadAttachedFiles, isGetAnyAns: true, isSuccess: true, isFromOriginalText: false })
                        _chatConversation.push({ from: summarizeResult, _commandType: 'QnA', IsSucceed: false, Question: questionItem, OutputAnswer: "No Answer found. Please try a new question.", SourcesMultiFiles: [], DisplayString: [], RelevantInformation: {}, ShowRelevantInformation: false, DisplayStringMultiFiles: [], RecommandationResults: [], SourcesMultiFiles: [], DisplayStringMultiFiles: [], messageTimeInText: `${moment().format("MMM DD , hh:mm a")}`, messageTime: { moment }, questionType: isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", eventid: clone(eventid), isMultiFiles: attachedFiles.length > 0, selectedFilters: selectedFilters, renderfilters: renderfilters, combinedSummaryMultiFiles: '', threadID: threadID, Reaction: ReactNone, Feedback: '', lastCreatedDatehour: _lastCreatedDatehour, threadAttachedFiles: _threadAttachedFiles, isGetAnyAns: false, isSuccess: false, isFromOriginalText: false })
                        this.indextrackingData(clone(eventid), (isFirstQuestion && questionIndex === 0) ? "MainQuestion" : "FollowUpQuestion", questionItem, questionItem, "No Answer found. Please try a new question.", _attachedFiles, [], [], '', _lastCreatedDatehour, query.length > 1, singleQuery, `160`, `5`, false, false, commandType, '', singleQuery);
                        _summarizeText = this.QnAResult({ from: summarizeResult, _commandType: 'QnA', IsSucceed: false, Question: questionItem, OutputAnswer: "No Answer found. Please try a new question.", SourcesMultiFiles: [], DisplayString: [], RelevantInformation: {}, ShowRelevantInformation: false, DisplayStringMultiFiles: [], RecommandationResults: [], SourcesMultiFiles: [], DisplayStringMultiFiles: [], messageTimeInText: `${moment().format("MMM DD , hh:mm a")}`, messageTime: { moment }, questionType: isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", eventid: clone(eventid), isMultiFiles: attachedFiles.length > 0, selectedFilters: selectedFilters, renderfilters: renderfilters, combinedSummaryMultiFiles: '', threadID: threadID, Reaction: ReactNone, Feedback: '', lastCreatedDatehour: _lastCreatedDatehour, threadAttachedFiles: _threadAttachedFiles, isGetAnyAns: false, isSuccess: false, isFromOriginalText: false });
                        eventid = uuidv4();
                    })
                    console.log("error", error);
                })
                .finally(async () => {
                    this.setState({
                        chatConversation: _chatConversation,
                        //isProcessing: false,
                        //commandText: '',
                        chatHistory: chatHistory,
                        isFirstQuestion: false,
                        renderfilters: renderfilters,
                        selectedFilters: selectedFilters,
                        summarizeText: _summarizeText,
                        commandText: ""
                        //spinnerMessage: ""
                    }, async () => {
                        // this.scrollToBottom();
                    })
                });
        }
        else if (commandType === 'Multi-Doc Summary') {
            const _headers = {
                'Content-Type': 'application/json'
            }
            if (await Authentication.isAccessTokenAvailable()) {
                const token = await Authentication.getAccessToken();
                _headers.Authorization = `Bearer ${token}`;
            }
            let textFiles = this.state.selectedFileSource.filter(x => x.name.toLowerCase().endsWith('.txt'))
            let attachedFilesPayload = [];
            attachedFilesPayload = this.state.selectedFileSource.filter(x => !x.name.toLowerCase().endsWith('.txt')).map(x => x.guid);

            config = {
                method: 'POST',
                url: url,
                headers: _headers,
                data: {
                    "commandType": commandType,
                    "query": query,
                    "filters": filterStr,
                    "function": _function,
                    "doctypepref": localStorage.getItem('doctypepref').replace(/"/g, ''),
                    "userproducts": localStorage.getItem('userproducts'),
                    "region": localStorage.getItem('region'),
                    "username": localStorage.getItem('username').toLowerCase().replace(/"/g, ''),
                    "contentpreference": localStorage.getItem('contentpreference').replace(/"/g, ''),
                    "source": "docTitle,documentNumber,downloadUrl,docType,searchID,year,fileName",
                    "from": 0,
                    "size": 7,
                    "sortBy": "",
                    "sortField": "",
                    "defaultOperator": "or",
                    "sessionID": sessionID,
                    "threadID": threadID,
                    "chat_history": _chatHistory,
                    "sourceSearchId": _sourceSearchId,
                    "isFirstQuestion": _chatConversation.length === 0,
                    "IsComprehensive": false,
                    "isMoreInformation": false,
                    "selected_files": attachedFilesPayload,
                    "configConversatio": configConversationa,
                    "configResponseLength": configResponseLength,
                    "option_selected": configTab,
                    "selected_files_text": textFiles
                },
                timeout: _timeoutTime
            }
            await axios(config)
                .then(async (resp) => {

                    /*combined_summary = resp.data[0].multi_doc_summary*/
                    query.map((questionItem, questionIndex) => {
                        //let response = resp.data[questionIndex];
                        let singleQuery = query[questionIndex];
                        let response = resp.data;
                        let isImageUpload = _attachedFiles.some(x =>
                            x.name.toLowerCase().endsWith('.gif')
                            || x.name.toLowerCase().endsWith('.jpeg')
                            || x.name.toLowerCase().endsWith('.jpg')
                            || x.name.toLowerCase().endsWith('.png'))

                        if (response.display_string_multi && response.display_string_multi.length > 0 || isImageUpload) {
                            _chatConversation.push({ from: userQuestion, _commandType: "Multi-Doc Summary", IsSucceed: true, message: questionItem, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, eventid: clone(eventid), isMultiFiles: attachedFiles.length > 0, threadID: threadID, lastCreatedDatehour: _lastCreatedDatehour, threadAttachedFiles: _threadAttachedFiles, isGetAnyAns: true, isSuccess: true, isFromOriginalText: false })
                            _chatConversation.push({ from: summarizeResult, _commandType: 'Multi-Doc Summary', IsSucceed: true, Question: questionItem, OutputAnswer: response.output_answer, Sources: [], SourcesMultiFiles: response.sources_multi, DisplayString: [], RelevantInformation: {}, ShowRelevantInformation: false, DisplayStringMultiFiles: response.display_string_multi, RecommandationResults: [], messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, questionType: isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", eventid: clone(eventid), isMultiFiles: attachedFiles.length > 0, selectedFilters: selectedFilters, renderfilters: renderfilters, combinedSummaryMultiFiles: response.combined_summary, threadID: threadID, Reaction: ReactNone, Feedback: '', lastCreatedDatehour: _lastCreatedDatehour, threadAttachedFiles: _threadAttachedFiles, isGetAnyAns: true, isSuccess: true, multi_doc_summary: response.multi_doc_summary })
                            _summarizeText = this.MutiDocResult({ from: summarizeResult, _commandType: 'Multi-Doc Summary', IsSucceed: true, Question: questionItem, OutputAnswer: response.output_answer, Sources: [], SourcesMultiFiles: response.sources_multi, DisplayString: [], RelevantInformation: {}, ShowRelevantInformation: false, DisplayStringMultiFiles: response.display_string_multi, RecommandationResults: [], messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, questionType: isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", eventid: clone(eventid), isMultiFiles: attachedFiles.length > 0, selectedFilters: selectedFilters, renderfilters: renderfilters, combinedSummaryMultiFiles: response.combined_summary, threadID: threadID, Reaction: ReactNone, Feedback: '', lastCreatedDatehour: _lastCreatedDatehour, threadAttachedFiles: _threadAttachedFiles, isGetAnyAns: true, isSuccess: true, multi_doc_summary: response.multi_doc_summary });
                            this.indextrackingData(clone(eventid), (isFirstQuestion && questionIndex === 0) ? "MainQuestion" : "FollowUpQuestion", questionItem, response.rephrased_question, response.output_answer, _attachedFiles, response.sources_multi, response.display_string_multi, response.combined_summary, _lastCreatedDatehour, query.length > 1, singleQuery, `150`, `5`, true, true, commandType, '', singleQuery);
                        } else {
                            _chatConversation.push({ from: userQuestion, _commandType: 'Multi-Doc Summary', IsSucceed: false, message: questionItem, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, eventid: clone(eventid), isMultiFiles: attachedFiles.length > 0, threadID: threadID, lastCreatedDatehour: _lastCreatedDatehour, threadAttachedFiles: _threadAttachedFiles, isGetAnyAns: true, isSuccess: true, isFromOriginalText: false })
                            _chatConversation.push({ from: summarizeResult, _commandType: 'Multi-Doc Summary', IsSucceed: false, Question: questionItem, OutputAnswer: "No Answer found. Please try a new question.", Sources: [], SourcesMultiFiles: [], DisplayString: [], RelevantInformation: {}, ShowRelevantInformation: false, DisplayStringMultiFiles: [], RecommandationResults: [], messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, questionType: isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", eventid: clone(eventid), isMultiFiles: attachedFiles.length > 0, combinedSummaryMultiFiles: '', threadID: threadID, Reaction: ReactNone, Feedback: '', lastCreatedDatehour: _lastCreatedDatehour, threadAttachedFiles: _threadAttachedFiles, isGetAnyAns: false, isSuccess: true, multi_doc_summary: '' })
                            _summarizeText = this.MutiDocResult({ from: summarizeResult, _commandType: 'Multi-Doc Summary', IsSucceed: false, Question: questionItem, OutputAnswer: "No Answer found. Please try a new question.", Sources: [], SourcesMultiFiles: [], DisplayString: [], RelevantInformation: {}, ShowRelevantInformation: false, DisplayStringMultiFiles: [], RecommandationResults: [], messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, questionType: isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", eventid: clone(eventid), isMultiFiles: attachedFiles.length > 0, combinedSummaryMultiFiles: '', threadID: threadID, Reaction: ReactNone, Feedback: '', lastCreatedDatehour: _lastCreatedDatehour, threadAttachedFiles: _threadAttachedFiles, isGetAnyAns: false, isSuccess: true, multi_doc_summary: '' });
                            this.indextrackingData(clone(eventid), (isFirstQuestion && questionIndex === 0) ? "MainQuestion" : "FollowUpQuestion", questionItem, response.rephrased_question, response.output_answer, _attachedFiles, response.sources_multi, response.display_string_multi, response.combined_summary, _lastCreatedDatehour, query.length > 1, singleQuery, `150`, `5`, true, true, commandType, "", singleQuery);
                        }
                        eventid = uuidv4();
                    })
                })
                .catch(async (error) => {
                    query.map((questionItem, questionIndex) => {
                        let singleQuery = query[questionIndex];
                        _chatConversation.push({ from: userQuestion, _commandType: 'Multi-Doc Summary', IsSucceed: false, message: questionItem, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, eventid: clone(eventid), isMultiFiles: attachedFiles.length > 0, threadID: threadID, lastCreatedDatehour: _lastCreatedDatehour, threadAttachedFiles: _threadAttachedFiles, isGetAnyAns: true, isSuccess: true, isFromOriginalText: false })
                        _chatConversation.push({ from: summarizeResult, _commandType: 'Multi-Doc Summary', IsSucceed: false, Question: questionItem, OutputAnswer: "No Answer found. Please try a new question.", SourcesMultiFiles: [], DisplayString: [], RelevantInformation: {}, ShowRelevantInformation: false, DisplayStringMultiFiles: [], RecommandationResults: [], SourcesMultiFiles: [], DisplayStringMultiFiles: [], messageTimeInText: `${moment().format("MMM DD , hh:mm a")}`, messageTime: { moment }, questionType: isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", eventid: clone(eventid), isMultiFiles: attachedFiles.length > 0, selectedFilters: selectedFilters, renderfilters: renderfilters, combinedSummaryMultiFiles: '', threadID: threadID, Reaction: ReactNone, Feedback: '', lastCreatedDatehour: _lastCreatedDatehour, threadAttachedFiles: _threadAttachedFiles, isGetAnyAns: false, isSuccess: false, isFromOriginalText: false })
                        this.indextrackingData(clone(eventid), (isFirstQuestion && questionIndex === 0) ? "MainQuestion" : "FollowUpQuestion", questionItem, questionItem, "No Answer found. Please try a new question.", _attachedFiles, [], [], '', _lastCreatedDatehour, query.length > 1, singleQuery, `160`, `5`, false, false, commandType, '', singleQuery);
                        _summarizeText = this.MutiDocResult({ from: summarizeResult, _commandType: 'Multi-Doc Summary', IsSucceed: false, Question: questionItem, OutputAnswer: "No Answer found. Please try a new question.", SourcesMultiFiles: [], DisplayString: [], RelevantInformation: {}, ShowRelevantInformation: false, DisplayStringMultiFiles: [], RecommandationResults: [], SourcesMultiFiles: [], DisplayStringMultiFiles: [], messageTimeInText: `${moment().format("MMM DD , hh:mm a")}`, messageTime: { moment }, questionType: isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", eventid: clone(eventid), isMultiFiles: attachedFiles.length > 0, selectedFilters: selectedFilters, renderfilters: renderfilters, combinedSummaryMultiFiles: '', threadID: threadID, Reaction: ReactNone, Feedback: '', lastCreatedDatehour: _lastCreatedDatehour, threadAttachedFiles: _threadAttachedFiles, isGetAnyAns: false, isSuccess: false, isFromOriginalText: false });
                        eventid = uuidv4();
                    })
                    console.log("error", error);
                })
                .finally(async () => {
                    this.setState({
                        chatConversation: _chatConversation,
                        //isProcessing: false,
                        //commandText: '',
                        chatHistory: chatHistory,
                        isFirstQuestion: false,
                        renderfilters: renderfilters,
                        selectedFilters: selectedFilters,
                        summarizeText: _summarizeText,
                        combined_summary: combined_summary
                        //spinnerMessage: ""
                    }, async () => {
                        // this.scrollToBottom();
                    })
                });
        } else {
            this.errorAlertMessage('Please select either text or an pdf file.')
        }


    }
    scrollToBottom = () => {
        this.messagesEnd.scrollIntoView({ behavior: "smooth" });
        this.setState({ scrollToBottomRandom: Math.random() });
    }
    numberOfWords = (str) => {
        if (str) {
            const words = str.match(/\S+/g);
            if (words && words.length !== 0) {
                return words.length;
            }
            else {
                return 0;
            }
        } else {
            return 0;
        }
    }
    flattenArray = (arr, res) => {
        for (let ele of arr) {
            if (Array.isArray(ele)) {
                this.flattenArray(ele, res)
            } else {
                res.push(ele)
            }
        }
        return res
    }
    processUserInstructions = async (val) => {
        let { commandText, orignalText, commandType, allFileContent, selectedAttachedFileguid } = this.state;
        let _commandType = commandType;
        orignalText = (val && val.fullText) ? val.fullText : '';
        selectedAttachedFileguid = (val && val.guid) ? val.guid : '';
        let _newQuestion = commandText.trim().replace(/\r\n/g, '\n').replace(/\n\n/g, '\n');
        let _splitQuery = _newQuestion.trim().split(/\n\*\|\*\n/g).filter(x => x).map(y => y.trim())
        let _orignalText = clone(this.state.orignalText);
        if ((!_orignalText && _commandType === 'Summarize') || (!_orignalText && _commandType === 'UserInstructions')) {
            _orignalText = allFileContent[selectedAttachedFileguid];
        }
        let tokenLength = this.numberOfWords(_orignalText);
        let questionBatchSize = 3;
        if (tokenLength > 15000) {
            questionBatchSize = 1;
        }
        else if (tokenLength > 10000) {
            questionBatchSize = 2;
        }
        let totalquestionBatchs = Math.ceil(_splitQuery.length / questionBatchSize);
        this.setState({ isChatConversationSpinner: true, spinnerMessage: "Please wait..." })
        for (let i = 0; i < totalquestionBatchs; i++) {
            let _batch = _splitQuery.slice(i * questionBatchSize, (i * questionBatchSize) + questionBatchSize);
            await this.onUserInstructionsCall(_batch);
            this.setState({ isMultiQuestionProcessing: true, isChatConversationSpinner: false, spinnerMessage: "" }, () => {
                if (i === 0) {
                    this.scrollToBottom();
                }
            })
        }
        this.setState({ isMultiQuestionProcessing: false })
    }
    onUserInstructionsCall = async (commandTexts) => {
        let { orignalText, commandText, chatConversation, commandType, sessionID, attachedFiles, configActiveTab, configConversationa, configResponseLength,
            summarizeText, isConfirm, isClearAllFields, previousOrignalText, firstCall, selectedAttachedFileguid, allFileContent
        } = this.state;
        let sourceText = clone(this.state.orignalText);
        let _lastCreatedDatehour = getCurrentDate();
        let _attachedFiles = attachedFiles.map(x => { return { name: x.name } })
        var eventid = uuidv4();
        let _commandType = commandType;
        let _commandText = commandText;
        let _orignalText = orignalText;
        let isFullFileContent = false;
        if ((!_orignalText && _commandType === 'Summarize') || (!_orignalText && _commandType === 'UserInstructions')) {
            _orignalText = allFileContent[selectedAttachedFileguid];
            isFullFileContent = true;
        }

        _orignalText = _orignalText.replace(/[\r\n]/g, " ").trim();
        if (ShowWordCountForCommandType.includes(commandType)) {
            _orignalText = _orignalText.replace(/[\r\n]/g, " ").trim().split(' ').filter((x, i) => i < WordsMaxLength).join(' ')
        }
        let configTab = configActiveTab === 0 ? 'Default' : configActiveTab === 1 ? 'Learning Guide' : 'Custom';
        let config = {}
        var url = `${_locationOrigin}${process.env.REACT_APP_IMS_API_NLP_SUMMARIZE}summarize_api2`
        if (window.location.origin === 'https://predev-ims.jnj.com') {
            url = `${window.location.origin}${process.env.REACT_APP_IMS_API_NLP_SUMMARIZE}summarize_api2`
        }
        //url = `https://predev-ims.jnj.com${process.env.REACT_APP_IMS_API_NLP_SUMMARIZE}summarize_api2`
        const _headers = {
            'Content-Type': 'application/json'
        }
        if (await Authentication.isAccessTokenAvailable()) {
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }
        config = {
            method: 'POST',
            url: url,
            headers: _headers,
            data: {
                "orignalText": _orignalText.replace(/[\r\n]/g, " ").trim(),
                "commandType": commandType,
                "commandText": '',
                "username": localStorage.getItem('username').toLowerCase().replace(/"/g, ''),
                "sessionID": sessionID,
                "wwid": JSON.parse(localStorage.getItem('wwid')),
                "previousSummarizeText": '',
                "searchID": "",
                "isClearAllFields": isClearAllFields,
                "isNewOrignalText": (previousOrignalText !== orignalText.replace(/[\r\n]/g, " ").trim().trimEnd().trimStart()),
                "multiCommands": commandTexts,
                "fileGuid": selectedAttachedFileguid,
                "isFullFileContent": isFullFileContent,
                "configConversatio": configConversationa,
                "configResponseLength": configResponseLength,
                "option_selected": configTab
            },
            timeout: _timeoutTime
        }
        // this.scrollToBottom();
        await axios(config).then((response) => {
            let _summarizeText = "", requestTokenCount = 0, responseTokenCount = 0;
            if (response.data.answersList && response.data.answersList.length > 0) {
                if (response.data.requestTokenCount)
                    requestTokenCount = response.data.requestTokenCount;
                if (response.data.responseTokenCount)
                    responseTokenCount = response.data.responseTokenCount;

                this.setState({ lastCommandType: _commandType }, () => {

                    commandTexts.map((citem, cindex) => {
                        let _message = "";
                        _message = citem ? `${citem}\n${orignalText}` : `${orignalText}`;
                        _message = _message.trim().replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/\n/g, '<br/>')
                        chatConversation.push({ from: userQuestion, message: _message, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, IsSucceed: true })
                        _summarizeText = response.data.answersList[cindex] ? response.data.answersList[cindex].trim() : ""
                        if (_commandType !== 'UserInstructions') {
                            _summarizeText = _summarizeText.replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/\n/g, '<br/>')
                        }

                        if (_summarizeText === "Answer not found in the document" && sourceText) {
                            _summarizeText = "Answer not found in the source text";
                        }
                        let finalSummery = JSON.parse(JSON.stringify(_summarizeText))
                        chatConversation.push({ from: summarizeResult, message: finalSummery, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, commandText: citem, orignalText: orignalText, IsSucceed: true })
                        this.indextrackingData(clone(eventid), "MainQuestion", _message.replace(/[\r\n]/g, " ").trim(), "", '', _attachedFiles, [], [], _summarizeText, _lastCreatedDatehour, false, true, `150`, `5`, true, true, _commandType, _summarizeText);
                    })

                })
                //this.indexData(_orignalText.replace(/[\r\n]/g, " ").trim(), "", commandText, commandType, summarizeText, sessionID, requestTokenCount, responseTokenCount, commandTexts, response.data.answersList);
                //this.indexData(sourceItem, _orignalText.replace(/[\r\n]/g, " ").trim(), "", commandText, commandType, "", sessionID, requestTokenCount, responseTokenCount, commandTexts, response.data.answersList);
            } else {
                commandTexts.map((citem, cindex) => {
                    let _message = "";
                    _message = citem ? `${citem}\n${orignalText}` : `${orignalText}`;
                    _message = _message.trim().replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/\n/g, '<br/>')
                    chatConversation.push({ from: userQuestion, message: _message, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, IsSucceed: true })
                    chatConversation.push({ from: summarizeResult, message: `We don't know the answer.<br>Kindly try after some time.`, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, commandText: citem, orignalText: orignalText, IsSucceed: false })
                    this.indextrackingData(clone(eventid), "MainQuestion", _orignalText.replace(/[\r\n]/g, " ").trim(), "", '', _attachedFiles, [], [], _summarizeText, _lastCreatedDatehour, false, true, `150`, `5`, true, true, _commandType, _summarizeText);
                })

            }
            this.setState({
                chatConversation: chatConversation,
                summarizeText: _summarizeText
            });
        }).catch((error) => {
            commandTexts.map((citem, cindex) => {
                let _message = "";
                _message = citem ? `${citem}\n${orignalText}` : `${orignalText}`;
                _message = _message.trim().replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/\n/g, '<br/>')
                chatConversation.push({ from: userQuestion, message: _message, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, IsSucceed: true })
                chatConversation.push({ from: summarizeResult, message: `Service is unavailable at this time, Kindly try after some time.`, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, commandText: citem, orignalText: orignalText, IsSucceed: false })
            })
            this.setState({ chatConversation: chatConversation });
            console.log(error)
        }).finally(() => {
            this.setState({
                //isProcessing: false, 
                isConfirm: false, isClearAllFields: false,
                previousOrignalText: orignalText.replace(/[\r\n]/g, " ").trim().trimEnd().trimStart(),
                firstCall: false,
                commandText: ""
            }, () => {
                this.scrollToBottom();
            });
        });
    }
    handleDeleteExisting = async (session_id) => {
        let response = await aps.deleteNoteBookProjectBySessionId(UserData.sub, session_id)
        if (response.data.statusCode === 200) {
            this.successAlertMessage('Chat cleared successfully')
        } else {
            this.errorAlertMessage('Something went wrong. Please try later')
        }
    }
    handleRefresh = async () => {
        let { sessionID } = this.state;
        this.setState({ chatConversation: [], commandType: 'QnA', isProcessingNew: 'true', commandText: '' });
        await this.handleDeleteExisting(sessionID);
        this.setState({ isProcessingNew: false })
    }
    MutiDocResult = (conversation) => {
        let { OutputAnswer, SourcesMultiFiles, DisplayStringMultiFiles, isMultiFiles, RelevantInformation, threadAttachedFiles } = conversation;
        let { attachedFiles } = this.state
        let _textDisplayString = '';
        if (conversation.SourcesMultiFiles && conversation.SourcesMultiFiles.length > 0) {
            let sourceGuiid = conversation.SourcesMultiFiles.map(x => x.file_guid);
            sourceGuiid = sourceGuiid.filter((item, index, self) => { return self.indexOf(item) === index });
            let attachedFileNew = sourceGuiid.map((val) => {
                return attachedFiles.filter(x => x.guid === val)[0]
            })
            try {
                let _displayStringMultiFiles = clone(conversation.DisplayStringMultiFiles);
                if (_displayStringMultiFiles && _displayStringMultiFiles.length > 0) {

                    /*_textDisplayString += `<b>File: ${smitem.document_title}<\/b><br\/>`;*/
                    _displayStringMultiFiles.map((dsitem, dsindex) => {
                        let _dsItem = clone(dsitem)

                        _dsItem.display_ans = _dsItem.display_ans.replace(/<li><br>/g, '<li>');
                        let regex = /<\/ul>/i;
                        // _dsItem.display_ans = _dsItem.display_ans.replace(regex, '</ul>');
                        //_textDisplayString += _dsItem.display_ans.replace(/(<([^>]+)>)/ig, '')
                        _textDisplayString += _dsItem.display_ans;
                        if (_dsItem.context_id && Array.isArray(_dsItem.context_id)) {
                            _dsItem.context_id.map((ctitem, ctindex) => {

                                _textDisplayString += `[${ctitem}]`

                            })
                            _textDisplayString += `<br\/>`;
                        }
                    })
                    _textDisplayString += "<br\/><br\/>"

                    _textDisplayString += "Sources<br\/>"

                    attachedFileNew.map((val, index) => {
                        _textDisplayString += `${index + 1}. Document Name: ${val.newFileName}<br\/>`
                        let contextSource = conversation.SourcesMultiFiles.filter(x => x.file_guid === conversation.guid)
                        let contextFilter = conversation.DisplayStringMultiFiles.map(x => x.context_id)
                        let finalContext = contextSource.map((contextSource) => {
                            let isPresent = contextFilter.map(x => x.includes(contextSource.context_id))
                            if (isPresent) {
                                return (contextSource.context_id)
                            }
                        })
                        finalContext.map((conItem, consIndex) => {
                            let _displayStringFilter = DisplayStringMultiFiles.filter(x => x.context_id && x.context_id.includes(conItem.context_id));
                            _textDisplayString += `Citation: [${conItem}], Pages No: [${conversation.SourcesMultiFiles[conItem - 1].page_number}].join(',')}]<br\/>`
                        })
                    })
                } else {
                    if (OutputAnswer === "We don't know the answer. Can you try new questions.") {
                        OutputAnswer = `No Answer found. Please try a new question.`;
                    }
                    _textDisplayString = OutputAnswer;
                }

            } catch (error) {
                console.log(error)
                return "Sorry, something went wrong.";
            }
        }
        return _textDisplayString;
    }
    handleRefreshQuery = async (commandType, query, editChatIndex, updatedQuestionEventid) => {
        this.setState({ isProcessingNew: true })
        if (commandType === 'QnA') {
            let { sessionID, chatHistory, isFirstQuestion, attachedFiles, threadID, selectedFilters, renderfilters,
                isMultiFileThread, commandType, selectedAttachedFileguid, commandText, chatConversation, configActiveTab,
                configConversationa, configResponseLength } = this.state;
            let _chatConversation = this.state.chatConversation;
            let combined_summary = this.state.combined_summary;
            let _lastCreatedDatehour = getCurrentDate();
            let url = '';
            let _chatHistory = [];
            let selected_files = chatConversation[editChatIndex + 1].SourcesMultiFiles.map(x => x.document_guid)
            let configTab = configActiveTab === 0 ? 'Default' : configActiveTab === 1 ? 'Learning Guide' : 'Custom';

            let _threadAttachedFiles = clone(attachedFiles.map(x => { return { name: x.name } }));
            url = `${_locationOrigin}${process.env.REACT_APP_IMS_API_MULTI_ANSWERS}multi_answers`
            if (window.location.origin === 'https://predev-ims.jnj.com') {
                url = `${window.location.origin}${process.env.REACT_APP_IMS_API_MULTI_ANSWERS}multi_answers`
            }
            let userAccessGroup = JSON.parse(localStorage.getItem('accessgroup'))
            // this.setState({ isProcessing: true, spinnerMessage: "Please wait..." })
            _chatHistory = this.processChatHistories(_chatConversation.length);
            let _sourceSearchId = this.processSourceSearchIds(_chatConversation.length);
            var config;
            let filterStr = "";
            let selectedFilter = [];
            var eventid = uuidv4();
            let _attachedFiles = attachedFiles.map(x => { return { name: x.name } })
            let _function = localStorage.getItem('function').replace(/"/g, '');
            if (userAccessGroup.includes("AllContent") && userAccessGroup.includes("MISEHCP") && !userAccessGroup.includes("VESE")) {
                _function = `MISE;${localStorage.getItem('function').replace(/"/g, '')}`;
            }
            else if (userAccessGroup.includes("AllContent") && userAccessGroup.includes("MISEHCP") && userAccessGroup.includes("VESE")) {
                _function = `MISE;V&ESE;${localStorage.getItem('function').replace(/"/g, '')}`;
            }
            else if (userAccessGroup.includes("MISEHCP")) {
                _function = `MISE`;
            }
            else if (userAccessGroup.includes("AllContent")) {
                _function = localStorage.getItem('function').replace(/"/g, '');
            }
            Object.keys(GenAI2DocTypes).map(key => {
                selectedFilter.push(GenAI2DocTypes[key]);
            })
            let _summarizeText = '';
            filterStr = this.generateArrayString(selectedFilter);
            const _headers = {
                'Content-Type': 'application/json'
            }
            if (await Authentication.isAccessTokenAvailable()) {
                const token = await Authentication.getAccessToken();
                _headers.Authorization = `Bearer ${token}`;
            }
            config = {
                method: 'POST',
                url: url,
                headers: _headers,
                data: {
                    "query": query,
                    "filters": filterStr,
                    "function": _function,
                    "doctypepref": localStorage.getItem('doctypepref').replace(/"/g, ''),
                    "userproducts": localStorage.getItem('userproducts'),
                    "region": localStorage.getItem('region'),
                    "username": localStorage.getItem('username').toLowerCase().replace(/"/g, ''),
                    "contentpreference": localStorage.getItem('contentpreference').replace(/"/g, ''),
                    "source": "docTitle,documentNumber,downloadUrl,docType,searchID,year,fileName",
                    "from": 0,
                    "size": 7,
                    "sortBy": "",
                    "sortField": "",
                    "defaultOperator": "or",
                    "sessionID": sessionID,
                    "threadID": threadID,
                    "chat_history": _chatHistory,
                    "sourceSearchId": _sourceSearchId,
                    "isFirstQuestion": _chatConversation.length === 0,
                    "IsComprehensive": false,
                    "isMoreInformation": false,
                    "selected_files": selected_files,
                    "configConversatio": configConversationa,
                    "configResponseLength": configResponseLength,
                    "option_selected": configTab
                },
                timeout: _timeoutTime
            }
            await axios(config)
                .then(async (resp) => {
                    query.map((questionItem, questionIndex) => {
                        let response = resp.data[questionIndex];
                        let singleQuery = query[questionIndex];
                        let isImageUpload = _attachedFiles.some(x =>
                            x.name.toLowerCase().endsWith('.gif')
                            || x.name.toLowerCase().endsWith('.jpeg')
                            || x.name.toLowerCase().endsWith('.jpg')
                            || x.name.toLowerCase().endsWith('.png'))
                        if (response.display_string_multi && response.display_string_multi.length > 0 || isImageUpload) {
                            chatConversation[editChatIndex] = { from: userQuestion, _commandType: "QnA", IsSucceed: true, message: questionItem, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, eventid: clone(eventid), isMultiFiles: attachedFiles.length > 0, threadID: threadID, lastCreatedDatehour: _lastCreatedDatehour, threadAttachedFiles: _threadAttachedFiles, isGetAnyAns: true, isSuccess: true, isFromOriginalText: false }
                            chatConversation[editChatIndex + 1] = { from: summarizeResult, _commandType: 'QnA', IsSucceed: true, Question: questionItem, OutputAnswer: response.output_answer, Sources: [], SourcesMultiFiles: response.sources_multi, DisplayString: [], RelevantInformation: {}, ShowRelevantInformation: false, DisplayStringMultiFiles: response.display_string_multi, RecommandationResults: [], messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, questionType: isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", eventid: clone(eventid), isMultiFiles: attachedFiles.length > 0, selectedFilters: selectedFilters, renderfilters: renderfilters, combinedSummaryMultiFiles: response.combined_summary, threadID: threadID, Reaction: ReactNone, Feedback: '', lastCreatedDatehour: _lastCreatedDatehour, threadAttachedFiles: _threadAttachedFiles, isGetAnyAns: true, isSuccess: true }
                            //this.indextrackingData(clone(eventid), (isFirstQuestion && questionIndex === 0) ? "MainQuestion" : "FollowUpQuestion", questionItem, response.rephrased_question, response.output_answer, _attachedFiles, response.sources_multi, response.display_string_multi, response.combined_summary, _lastCreatedDatehour, query.length > 1, singleQuery, `150`, `5`, true, true, commandType, '');
                            this.updateNoteBookProjectData(eventid, updatedQuestionEventid, (isFirstQuestion && questionIndex === 0) ? "MainQuestion" : "FollowUpQuestion", questionItem, response.rephrased_question, response.output_answer, _attachedFiles, response.sources_multi, response.display_string_multi, response.combined_summary, _lastCreatedDatehour, query.length > 1, singleQuery, `150`, `5`, true, true, commandType, '');
                            _summarizeText = this.QnAResult({ from: summarizeResult, _commandType: 'QnA', IsSucceed: true, Question: questionItem, OutputAnswer: response.output_answer, Sources: [], SourcesMultiFiles: response.sources_multi, DisplayString: [], RelevantInformation: {}, ShowRelevantInformation: false, DisplayStringMultiFiles: response.display_string_multi, RecommandationResults: [], messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, questionType: isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", eventid: clone(eventid), isMultiFiles: attachedFiles.length > 0, selectedFilters: selectedFilters, renderfilters: renderfilters, combinedSummaryMultiFiles: response.combined_summary, threadID: threadID, Reaction: ReactNone, Feedback: '', lastCreatedDatehour: _lastCreatedDatehour, threadAttachedFiles: _threadAttachedFiles, isGetAnyAns: true, isSuccess: true });

                        } else {
                            chatConversation[editChatIndex] = { from: userQuestion, _commandType: 'QnA', IsSucceed: false, message: questionItem, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, eventid: clone(eventid), isMultiFiles: attachedFiles.length > 0, threadID: threadID, lastCreatedDatehour: _lastCreatedDatehour, threadAttachedFiles: _threadAttachedFiles, isGetAnyAns: true, isSuccess: true, isFromOriginalText: false }
                            chatConversation[editChatIndex + 1] = { from: summarizeResult, _commandType: 'QnA', IsSucceed: false, Question: questionItem, OutputAnswer: "No Answer found. Please try a new question.", Sources: [], SourcesMultiFiles: [], DisplayString: [], RelevantInformation: {}, ShowRelevantInformation: false, DisplayStringMultiFiles: [], RecommandationResults: [], messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, questionType: isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", eventid: clone(eventid), isMultiFiles: attachedFiles.length > 0, combinedSummaryMultiFiles: '', threadID: threadID, Reaction: ReactNone, Feedback: '', lastCreatedDatehour: _lastCreatedDatehour, threadAttachedFiles: _threadAttachedFiles, isGetAnyAns: false, isSuccess: true }
                            _summarizeText = this.QnAResult({ from: summarizeResult, _commandType: 'QnA', IsSucceed: false, Question: questionItem, OutputAnswer: "No Answer found. Please try a new question.", Sources: [], SourcesMultiFiles: [], DisplayString: [], RelevantInformation: {}, ShowRelevantInformation: false, DisplayStringMultiFiles: [], RecommandationResults: [], messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, questionType: isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", eventid: clone(eventid), isMultiFiles: attachedFiles.length > 0, combinedSummaryMultiFiles: '', threadID: threadID, Reaction: ReactNone, Feedback: '', lastCreatedDatehour: _lastCreatedDatehour, threadAttachedFiles: _threadAttachedFiles, isGetAnyAns: false, isSuccess: true });
                            this.updateNoteBookProjectData(clone(eventid), updatedQuestionEventid, (isFirstQuestion && questionIndex === 0) ? "MainQuestion" : "FollowUpQuestion", questionItem, response.rephrased_question, response.output_answer, _attachedFiles, response.sources_multi, response.display_string_multi, response.combined_summary, _lastCreatedDatehour, query.length > 1, singleQuery, `150`, `5`, true, true, commandType, "");
                            //this.updateNoteBookProjectData(eventid, updatedQuestionEventid, (isFirstQuestion && questionIndex === 0) ? "MainQuestion" : "FollowUpQuestion", questionItem, response.rephrased_question, response.output_answer, _attachedFiles, response.sources_multi, response.display_string_multi, response.combined_summary, _lastCreatedDatehour, query.length > 1, singleQuery, `150`, `5`, true, true, commandType, '');
                        }
                        eventid = uuidv4();
                    })
                })
                .catch(async (error) => {
                    query.map((questionItem, questionIndex) => {
                        let singleQuery = query[questionIndex];
                        chatConversation[editChatIndex] = { from: userQuestion, _commandType: 'QnA', IsSucceed: false, message: questionItem, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, eventid: clone(eventid), isMultiFiles: attachedFiles.length > 0, threadID: threadID, lastCreatedDatehour: _lastCreatedDatehour, threadAttachedFiles: _threadAttachedFiles, isGetAnyAns: true, isSuccess: true, isFromOriginalText: false }
                        chatConversation[editChatIndex + 1] = { from: summarizeResult, _commandType: 'QnA', IsSucceed: false, Question: questionItem, OutputAnswer: "No Answer found. Please try a new question.", SourcesMultiFiles: [], DisplayString: [], RelevantInformation: {}, ShowRelevantInformation: false, DisplayStringMultiFiles: [], RecommandationResults: [], SourcesMultiFiles: [], DisplayStringMultiFiles: [], messageTimeInText: `${moment().format("MMM DD , hh:mm a")}`, messageTime: { moment }, questionType: isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", eventid: clone(eventid), isMultiFiles: attachedFiles.length > 0, selectedFilters: selectedFilters, renderfilters: renderfilters, combinedSummaryMultiFiles: '', threadID: threadID, Reaction: ReactNone, Feedback: '', lastCreatedDatehour: _lastCreatedDatehour, threadAttachedFiles: _threadAttachedFiles, isGetAnyAns: false, isSuccess: false, isFromOriginalText: false }
                        this.updateNoteBookProjectData(clone(eventid), updatedQuestionEventid, (isFirstQuestion && questionIndex === 0) ? "MainQuestion" : "FollowUpQuestion", questionItem, questionItem, "No Answer found. Please try a new question.", _attachedFiles, [], [], '', _lastCreatedDatehour, query.length > 1, singleQuery, `160`, `5`, false, false, commandType, '');
                        //this.updateNoteBookProjectData(eventid, updatedQuestionEventid, (isFirstQuestion && questionIndex === 0) ? "MainQuestion" : "FollowUpQuestion", question, response.rephrased_question, response.output_answer, _attachedFiles, response.sources_multi, response.display_string_multi, response.combined_summary, _lastCreatedDatehour, _question, `${updatedWordLimit}`, `${updatedReadingLevel}`, true, true);

                        _summarizeText = this.QnAResult({ from: summarizeResult, _commandType: 'QnA', IsSucceed: false, Question: questionItem, OutputAnswer: "No Answer found. Please try a new question.", SourcesMultiFiles: [], DisplayString: [], RelevantInformation: {}, ShowRelevantInformation: false, DisplayStringMultiFiles: [], RecommandationResults: [], SourcesMultiFiles: [], DisplayStringMultiFiles: [], messageTimeInText: `${moment().format("MMM DD , hh:mm a")}`, messageTime: { moment }, questionType: isFirstQuestion ? "MainQuestion" : "FollowUpQuestion", eventid: clone(eventid), isMultiFiles: attachedFiles.length > 0, selectedFilters: selectedFilters, renderfilters: renderfilters, combinedSummaryMultiFiles: '', threadID: threadID, Reaction: ReactNone, Feedback: '', lastCreatedDatehour: _lastCreatedDatehour, threadAttachedFiles: _threadAttachedFiles, isGetAnyAns: false, isSuccess: false, isFromOriginalText: false });
                        eventid = uuidv4();
                    })
                    console.log("error", error);
                })
                .finally(async () => {
                    this.setState({
                        //chatConversation: _chatConversation,
                        //isProcessing: false,
                        //commandText: '',
                        chatHistory: chatHistory,
                        isFirstQuestion: false,
                        renderfilters: renderfilters,
                        selectedFilters: selectedFilters,
                        summarizeText: _summarizeText,
                        isProcessingNew: false
                        //spinnerMessage: ""
                    }, async () => {
                        // this.scrollToBottom();
                    })
                });
        } else if (commandType === 'UserInstructions' || commandType === 'CreateTable' || commandType === "Summarize" || commandType === "source_text_QnA") {
            let { chatConversation, sessionID,
                summarizeText, isConfirm, isClearAllFields, configActiveTab, configConversationa, configResponseLength, previousOrignalText, firstCall, selectedAttachedFileguid, allFileContent, attachedFiles,
                orignalText } = this.state;
            let commandText = chatConversation[editChatIndex + 1].commandText
            let _lastCreatedDatehour = getCurrentDate();
            let _attachedFiles = attachedFiles.map(x => { return { name: x.name } })
            var eventid = uuidv4();
            let isFullFileContent = false;
            let configTab = configActiveTab === 0 ? 'Default' : configActiveTab === 1 ? 'Learning Guide' : 'Custom';
            let sourceText = clone(this.state.orignalText);
            this.setState({ savingCommandText: commandText });
            if (orignalText || (allFileContent && Object.keys(allFileContent).find(x => x === selectedAttachedFileguid))) {
                let _commandType = commandType;
                let _commandText = query[0];
                let _orignalText = orignalText;

                if ((!_orignalText && _commandType === 'Summarize') || (!_orignalText && _commandType === 'UserInstructions')) {
                    _orignalText = allFileContent[selectedAttachedFileguid];
                    isFullFileContent = true;
                }

                let tokenLength = this.numberOfWords(_orignalText);
                if (_commandType === 'UserInstructions' && !commandText) {
                    this.errorAlertMessage("User Command Required, Please enter a command.");
                }
                else if (_commandType === 'CreateTable' && tokenLength === 0) {
                    this.errorAlertMessage("For Create Table Command, Please enter text in the source text box.");
                }
                else if (_commandType === 'CreateTable' && tokenLength === 0) {
                    this.errorAlertMessage("For Create Table Command, Please enter text in the source text box.");
                }
                else if (_commandType === 'Translate' && !commandText) {
                    this.errorAlertMessage("Please enter language to the command box.");
                } else if (!isConfirm && ShowWordCountForCommandType.includes(commandType) && tokenLength > WordsMaxLength) {
                    this.showConfirmMessage(`The input text is more than ${WordsMaxLength} words. Please use a shorter text by hitting cancel button and updating the text or the text can be ${_commandType} upto max limit by clicking on OK button`);
                } else if (_commandType === 'UserInstructions' && commandText && commandText.trim() && commandText.trim().split(/\n\n/g).length > 5) {
                    this.errorAlertMessage("Kindly select maximum five commands to proceed.");
                } else {
                    if (_commandType === 'UserInstructions') {
                        //let commandTexts = commandText.trim().split(/\n\n/g);
                        let commandTexts = query[0].trim().replace(/\r\n/g, '\n').replace(/\n\n/g, '\n');
                        commandTexts = commandTexts.trim().split(/\n\*\|\*\n/g).filter(x => x).map(y => y.trim());
                        if ((tokenLength > 7000 || commandTexts.length > 1) && false) {
                            this.processUserInstructions();
                        }
                        else {
                            this.setState({ chatConversation: chatConversation, isProcessing: true }, () => {
                                //this.scrollToBottom();
                            });

                            _orignalText = _orignalText.replace(/[\r\n]/g, " ").trim();
                            if (ShowWordCountForCommandType.includes(commandType)) {
                                _orignalText = _orignalText.replace(/[\r\n]/g, " ").trim().split(' ').filter((x, i) => i < WordsMaxLength).join(' ')
                            }
                            let config = {}
                            var url = `${_locationOrigin}${process.env.REACT_APP_IMS_API_NLP_SUMMARIZE}summarize_api2`
                            if (window.location.origin === 'https://predev-ims.jnj.com') {
                                url = `${window.location.origin}${process.env.REACT_APP_IMS_API_NLP_SUMMARIZE}summarize_api2`
                            }
                            //url = `https://predev-ims.jnj.com${process.env.REACT_APP_IMS_API_NLP_SUMMARIZE}summarize_api2`

                            const _headers = {
                                'Content-Type': 'application/json'
                            }
                            if (await Authentication.isAccessTokenAvailable()) {
                                const token = await Authentication.getAccessToken();
                                _headers.Authorization = `Bearer ${token}`;
                            }

                            config = {
                                method: 'POST',
                                url: url,
                                headers: _headers,
                                data: {
                                    "orignalText": _orignalText.replace(/[\r\n]/g, " ").trim(),
                                    "commandType": commandType,
                                    "commandText": '',
                                    "username": localStorage.getItem('username').toLowerCase().replace(/"/g, ''),
                                    "sessionID": sessionID,
                                    "wwid": JSON.parse(localStorage.getItem('wwid')),
                                    "previousSummarizeText": '',
                                    "searchID": "",
                                    "isClearAllFields": isClearAllFields,
                                    "isNewOrignalText": (previousOrignalText !== orignalText.replace(/[\r\n]/g, " ").trim().trimEnd().trimStart()),
                                    "multiCommands": commandTexts,
                                    "fileGuid": selectedAttachedFileguid,
                                    "isFullFileContent": isFullFileContent,
                                    "configConversatio": configConversationa,
                                    "configResponseLength": configResponseLength,
                                    "option_selected": configTab
                                },
                                timeout: _timeoutTime
                            }
                            // this.scrollToBottom();
                            await axios(config).then((response) => {
                                let _summarizeText = "", requestTokenCount = 0, responseTokenCount = 0;
                                if (response.data.answersList && response.data.answersList.length > 0) {
                                    if (response.data.requestTokenCount)
                                        requestTokenCount = response.data.requestTokenCount;
                                    if (response.data.responseTokenCount)
                                        responseTokenCount = response.data.responseTokenCount;

                                    this.setState({ lastCommandType: _commandType }, () => {

                                        query.map((citem, cindex) => {
                                            let _message = "";
                                            _message = citem ? `${citem}\n${orignalText}` : `${orignalText}`;
                                            _message = _message.trim().replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/\n/g, '<br/>')
                                            chatConversation[editChatIndex] = { from: userQuestion, message: _message, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, IsSucceed: true }
                                            _summarizeText = response.data.answersList[cindex] ? response.data.answersList[cindex].trim() : ""
                                            if (_commandType !== 'UserInstructions') {
                                                _summarizeText = _summarizeText.replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/\n/g, '<br/>')
                                            }

                                            if (_summarizeText === "Answer not found in the document" && sourceText) {
                                                _summarizeText = "Answer not found in the source text";
                                            }
                                            let finalSummery = JSON.parse(JSON.stringify(_summarizeText))
                                            chatConversation[editChatIndex + 1] = { from: summarizeResult, message: finalSummery, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, commandText: citem, orignalText: orignalText, IsSucceed: true }
                                            //this.updateNoteBookProjectData(eventid, updatedQuestionEventid, (isFirstQuestion && questionIndex === 0) ? "MainQuestion" : "FollowUpQuestion", questionItem, response.rephrased_question, response.output_answer, _attachedFiles, response.sources_multi, response.display_string_multi, response.combined_summary, _lastCreatedDatehour,  query.length > 1, singleQuery, `150`, `5`, true, true, commandType, '');

                                            this.updateNoteBookProjectData(clone(eventid), updatedQuestionEventid, "MainQuestion", _orignalText.replace(/[\r\n]/g, " ").trim(), "", '', _attachedFiles, [], [], _summarizeText, _lastCreatedDatehour, false, true, `150`, `5`, true, true, _commandType, _summarizeText);
                                        })

                                    })
                                    //this.indexData(_orignalText.replace(/[\r\n]/g, " ").trim(), "", commandText, commandType, summarizeText, sessionID, requestTokenCount, responseTokenCount, commandTexts, response.data.answersList);
                                    //this.indexData(sourceItem, _orignalText.replace(/[\r\n]/g, " ").trim(), "", commandText, commandType, "", sessionID, requestTokenCount, responseTokenCount, commandTexts, response.data.answersList);
                                } else {
                                    commandTexts.map((citem, cindex) => {
                                        let _message = "";
                                        _message = citem ? `${citem}\n${orignalText}` : `${orignalText}`;
                                        _message = _message.trim().replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/\n/g, '<br/>')
                                        chatConversation[editChatIndex] = { from: userQuestion, message: _message, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, IsSucceed: true }
                                        chatConversation[editChatIndex + 1] = { from: summarizeResult, message: `We don't know the answer.<br>Kindly try after some time.`, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, commandText: citem, orignalText: orignalText, IsSucceed: false }
                                    })

                                }
                                this.setState({
                                    chatConversation: chatConversation,
                                    summarizeText: _summarizeText
                                });
                            }).catch((error) => {
                                commandTexts.map((citem, cindex) => {
                                    let _message = "";
                                    _message = citem ? `${citem}\n${orignalText}` : `${orignalText}`;
                                    _message = _message.trim().replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/\n/g, '<br/>')
                                    chatConversation[editChatIndex] = { from: userQuestion, message: _message, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, IsSucceed: true }
                                    chatConversation[editChatIndex + 1] = { from: summarizeResult, message: `Service is unavailable at this time, Kindly try after some time.`, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, commandText: citem, orignalText: orignalText, IsSucceed: false }
                                })
                                //this.setState({ chatConversation: chatConversation });
                                console.log(error)
                            }).finally(() => {
                                this.setState({ isProcessingNew: false, isProcessing: false, isConfirm: false, isClearAllFields: false, previousOrignalText: orignalText.replace(/[\r\n]/g, " ").trim().trimEnd().trimStart(), firstCall: false }, () => {
                                    //this.scrollToBottom();
                                });
                            });
                        }
                    }
                    else {
                        let _message = "";
                        _message = commandText ? `${commandText}\n${_orignalText}` : `${_orignalText}`;
                        _message = _message.trim().replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/\n/g, '<br/>')
                        chatConversation[editChatIndex] = { from: userQuestion, message: _message, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, IsSucceed: true, isFromOriginalText: true }
                        this.setState({ chatConversation: chatConversation, isProcessing: true }, () => {
                            //this.scrollToBottom();
                        });

                        _orignalText = _orignalText.replace(/[\r\n]/g, " ").trim();
                        let commandTexts = (_commandType === 'UserInstructions') ? commandText.trim().split(/\n\n/g) : [];

                        if (ShowWordCountForCommandType.includes(commandType)) {
                            _orignalText = _orignalText.replace(/[\r\n]/g, " ").trim().split(' ').filter((x, i) => i < WordsMaxLength).join(' ')
                        }
                        let config = {}

                        var url = `${_locationOrigin}${process.env.REACT_APP_IMS_API_NLP_SUMMARIZE}summarize_api2`
                        if (window.location.origin === 'https://predev-ims.jnj.com') {
                            url = `${window.location.origin}${process.env.REACT_APP_IMS_API_NLP_SUMMARIZE}summarize_api2`
                        }

                        const _headers = {
                            'Content-Type': 'application/json'
                        }
                        if (await Authentication.isAccessTokenAvailable()) {
                            const token = await Authentication.getAccessToken();
                            _headers.Authorization = `Bearer ${token}`;
                        }

                        config = {
                            method: 'POST',
                            url: url,
                            headers: _headers,
                            data: {
                                "orignalText": _orignalText.replace(/[\r\n]/g, " ").trim(),
                                "commandType": commandType,
                                "commandText": "",
                                "username": localStorage.getItem('username').toLowerCase().replace(/"/g, ''),
                                "sessionID": sessionID,
                                "wwid": JSON.parse(localStorage.getItem('wwid')),
                                "previousSummarizeText": summarizeText.replace(/[\r\n]/g, " ").trim(),
                                "searchID": "",
                                "isClearAllFields": isClearAllFields,
                                "isNewOrignalText": (previousOrignalText !== _orignalText.replace(/[\r\n]/g, " ").trim().trimEnd().trimStart()),
                                "multiCommands": commandTexts,
                                "fileGuid": selectedAttachedFileguid,
                                "isFullFileContent": isFullFileContent,
                                "configConversatio": configConversationa,
                                "configResponseLength": configResponseLength,
                                "option_selected": configTab
                            },
                            timeout: _timeoutTime
                        }

                        // this.scrollToBottom();
                        await axios(config).then((response) => {
                            let _summarizeText = "", requestTokenCount = 0, responseTokenCount = 0;
                            if (_commandType === "CreateTable") {
                                if (response.data.summarizeTable && response.data.summarizeTable.length > 0) {
                                    this.setState({ lastCommandType: _commandType }, () => {
                                        let summarizeTables = response.data.summarizeTable;
                                        if (response.data.requestTokenCount)
                                            requestTokenCount = response.data.requestTokenCount;
                                        if (response.data.responseTokenCount)
                                            responseTokenCount = response.data.responseTokenCount;

                                        if (summarizeTables.length === 1) {
                                            _summarizeText = summarizeTables[0];
                                            chatConversation[editChatIndex + 1] = { _commandType: _commandType, from: summarizeResult, message: summarizeTables[0], messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, commandText: _commandText, orignalText: _orignalText, IsSucceed: true };
                                            //this.indexData(_orignalText.replace(/[\r\n]/g, " ").trim(), _summarizeText, commandText, commandType, summarizeText, sessionID, requestTokenCount, responseTokenCount, [], []);
                                        }
                                    })
                                } else {
                                    chatConversation[editChatIndex + 1] = { _commandType: _commandType, from: summarizeResult, message: `We don't know the answer.<br>Kindly try after some time.`, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, commandText: _commandText, orignalText: _orignalText, IsSucceed: false }
                                }
                            }
                            else if (_commandType === 'Summarize') {
                                if (response.data.summarizeText) {
                                    _summarizeText = response.data.summarizeText ? response.data.summarizeText.trim() : ""
                                    if (response.data.requestTokenCount)
                                        requestTokenCount = response.data.requestTokenCount;
                                    if (response.data.responseTokenCount)
                                        responseTokenCount = response.data.responseTokenCount;

                                    this.setState({ lastCommandType: _commandType }, () => {
                                        if (_commandType !== 'Summarize') {
                                            _summarizeText = _summarizeText.replace(/>/g, '&gt;').replace(/</g, '&lt;').replace(/\n/g, '<br/>')
                                        }

                                        chatConversation[editChatIndex + 1] = { _commandType: _commandType, from: summarizeResult, message: _summarizeText, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, commandText: _commandText, orignalText: _orignalText, IsSucceed: true, isFromOriginalText: true }
                                    })
                                    //this.indexData(_orignalText.replace(/[\r\n]/g, " ").trim(), _summarizeText, commandText, commandType, summarizeText, sessionID, requestTokenCount, responseTokenCount, [], []);
                                    //this.indextrackingData(clone(eventid), (isFirstQuestion && questionIndex === 0) ? "MainQuestion" : "FollowUpQuestion", questionItem, response.rephrased_question, response.output_answer, _attachedFiles, response.sources_multi, response.display_string_multi, response.combined_summary, _lastCreatedDatehour, query.length > 1, singleQuery, `150`, `5`, true, true, commandType, '');
                                    this.updateNoteBookProjectData(clone(eventid), updatedQuestionEventid, "MainQuestion", _orignalText.replace(/[\r\n]/g, " ").trim(), "", '', _attachedFiles, [], [], _summarizeText, _lastCreatedDatehour, false, true, `150`, `5`, true, true, _commandType, _summarizeText);
                                } else {
                                    chatConversation[editChatIndex + 1] = { _commandType: _commandType, from: summarizeResult, message: `We don't know the answer.<br>Kindly try after some time.`, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, commandText: _commandText, orignalText: _orignalText, IsSucceed: false, isFromOriginalText: true }
                                    this.updateNoteBookProjectData(clone(eventid), updatedQuestionEventid, "MainQuestion", _orignalText.replace(/[\r\n]/g, " ").trim(), "", '', _attachedFiles, [], [], _summarizeText, _lastCreatedDatehour, false, true, `150`, `5`, true, true, _commandType, `We don't know the answer.<br>Kindly try after some time.`);
                                }
                            }
                            this.setState({
                                //chatConversation: chatConversation,
                                summarizeText: (_commandType === "Summarize" || _commandType === "UserInstructions" || _commandType === "Translate" || _commandType === "QnA" || _commandType === "Multi-Doc Summary") ? (response.data.summarizeText ? response.data.summarizeText.trim() : "") : _summarizeText
                            });
                        }).catch((error) => {
                            chatConversation[editChatIndex + 1] = { _commandType: _commandType, from: summarizeResult, message: `Service is unavailable at this time, Kindly try after some time.`, messageTimeInText: `${moment().format("MMM DD, hh:mm a")}`, messageTime: { moment }, documentInfo: {}, commandType: _commandType, commandText: _commandText, orignalText: _orignalText, IsSucceed: false, isFromOriginalText: true }
                            this.setState({ chatConversation: chatConversation });
                            console.log(error)
                        }).finally(() => {
                            this.setState({ isProcessingNew: false, isConfirm: false, isClearAllFields: false, previousOrignalText: _orignalText.replace(/[\r\n]/g, " ").trim().trimEnd().trimStart(), firstCall: false }, () => {
                                //this.scrollToBottom();
                            });
                        });
                    }
                }
            }

        } else if (commandType === 'Multi-Doc Summary') {
            this.setState({ isProcessingNew: false }, () => {
                this.errorAlertMessage('Content cannot be refreshed right now. Please try again later.')
            })
        } else {
            this.setState({ isProcessingNew: false }, () => {
                this.errorAlertMessage('Please try again later.')
            })
        }
    }
    handleSaveContent = (textVal) => {
        let { editQuestion, chatConversation } = this.state
        if (editQuestion.conversation.message?.toLowerCase() !== textVal.toLowerCase()) {
            let conversationIndex = editQuestion.conversationIndex;
            let eventid = editQuestion.eventid;
            let newChat = chatConversation
            //chatConversation[conversationIndex].message = textVal;
            //this.setState({chatConversation: newChat})
            //this.setState({ isProcessing: true })
            if (chatConversation[conversationIndex]._commandType) {
                this.handleRefreshQuery(chatConversation[conversationIndex]._commandType, [textVal], conversationIndex, eventid)
            } else if (chatConversation[conversationIndex].commandType) {
                this.handleRefreshQuery(chatConversation[conversationIndex].commandType, [textVal], conversationIndex, eventid)
            }
            this.setState({ expandSourceText: false })
        }
        this.setState({ expandSourceText: false })
    }
    handleInputText = (e) => {
        e.target.style.height = 'fit-content';
        e.target.style.height = e.target.scrollHeight + 'px';
        if (e.target.value.length < 1) {
            e.target.style.height = `30px`
        }
    }
    handleBlurInput = (e) => {
        e.target.style.height = '30px'
    }
    handleAttachedFiles = (newattachedFiles) => {
        let { attachedFiles, isSorcePanelSelectAll } = this.state;
        let filterattachedFiles = newattachedFiles.filter(x => !x.name.toLowerCase().endsWith('.txt'))
        this.setState({ attachedFiles: filterattachedFiles }, async () => {
            await this.fetchSourceTextFromDb(this.state.sessionID);
        })
        if (isSorcePanelSelectAll) {
            this.setState({ selectedFileSource: this.state.attachedFiles })
        }
    }
    handleDeleteFileFromS3 = async (session_id) => {
        let _isDeleted = false;
        //let url = `https://localhost:44306/api/NotebookService/S3File/Delete/my-new-folder1`;
        let url = `${_locationOrigin}/api/NotebookService/S3File/Delete/${session_id}`
        if (window.location.origin === 'https://predev-ims.jnj.com') {
            url = `${window.location.origin}/api/NotebookService/S3File/Delete/${session_id}`
        }
        // url = `https://localhost:44306/api/NotebookService/S3File/Delete/${session_id}`;
        const _headers = {
            // 'content-type': 'multipart/form-data'
        }
        if (await Authentication.isAccessTokenAvailable()) {
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }
        let config = {
            method: 'DELETE',
            url: url,
            headers: _headers,
            // data: formData,
            timeout: _timeoutTime
        }
        await axios(config).then((resp) => {
            _isDeleted = true;
            // console.log("resp", resp)
        }).catch((error) => {
            _isDeleted = false;
            this.errorAlertMessage(`Remove document failed to some reason. Kindly try after some time.`)
            //console.log("error", error)
        }).finally(() => {
            // console.log("in finally")
        });
        return _isDeleted;

    }
    handleSaveInS3 = async (e) => {
        this.setState({ isProcessingNew: true, });
        let { attachedFiles, sessionID, updateAnyFile, newAttachedFiles, removedAttachedFileIndex, newThreadID } = this.state;
        var url = `${_locationOrigin}/api/NotebookService/S3File/Upload`
        if (window.location.origin === 'https://predev-ims.jnj.com') {
            url = `${window.location.origin}/api/NotebookService/S3File/Upload`
        }
        //var url = `https://localhost:44307/api/NotebookService/S3File/Upload`;
        const formData = new FormData();
        let filter_att = attachedFiles.filter(x => !x.name.toLowerCase().endsWith('.txt'))

        attachedFiles.concat(newAttachedFiles).filter((file, fileIndex) => fileIndex !== removedAttachedFileIndex).map((item, index) => {
            formData.append(`file${index + 1}`, item);
            formData.append(`fileGuid${index + 1}`, item.guid);
            formData.append(`newFileName${index + 1}`, item.newFileName);
        })
        formData.append(`fileCount`, attachedFiles.concat(newAttachedFiles).filter((file, fileIndex) => fileIndex !== removedAttachedFileIndex).length);
        formData.append(`sessionID`, sessionID);
        formData.append(`threadID`, newThreadID);
        formData.append(`username`, localStorage.getItem('username').toLowerCase().replace(/"/g, ''));
        formData.append(`updateAnyFile`, false);

        const _headers = {
            'content-type': 'multipart/form-data'
        }
        if (await Authentication.isAccessTokenAvailable()) {
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }

        let config = {
            method: 'POST',
            url: url,
            headers: _headers,
            data: formData,
            timeout: _timeoutTime
        }
        await axios(config).then((resp) => {
            let response = resp.data;
            if (response.FileUpload && attachedFiles.concat(newAttachedFiles).filter((file, fileIndex) => fileIndex !== removedAttachedFileIndex).filter(x => !x.name.toLowerCase().endsWith('.txt')).length > 0) {
                this.multipleFilesUpload(e)
            } else if (!response.FileUpload && response.Files && response.Files.length === 0) {
                this.errorAlertMessage(`Upload failed due to some reason. Kindly try after some time.<br /><br /><p class='alertmessage-file-label'>Documents name</p> - ${newAttachedFiles.map(x => x.name).join("<br /> - ")}`)
                this.setState({ updateAnyFile: true, newAttachedFiles: [], removedAttachedFileIndex: -1, selectedFilters: [], renderfilters: [], isComprehensive: false, isProcessing: false, spinnerMessage: '' }, () => {
                    //this.manageFilePlaceHolder();
                });
            }
            else if (!response.FileUpload && response.Files && response.Files.length > 0) {
                let failedGuid = response.Files.map(x => x.Guid)
                let finalFaileAttached = attachedFiles.concat(newAttachedFiles).filter((file, fileIndex) => fileIndex !== removedAttachedFileIndex).filter(x => failedGuid.includes(x.guid));
                this.errorAlertMessage(`Upload failed due to some reason. Kindly try after some time.<br /><br /><p class='alertmessage-file-label'>Documents name</p> - ${finalFaileAttached.map(x => x.name).join("<br /> - ")}`)
                this.setState({
                    updateAnyFile: true, attachedFiles: attachedFiles.concat(newAttachedFiles).filter((file, fileIndex) => fileIndex !== removedAttachedFileIndex).filter(x => !failedGuid.includes(x.guid)),
                    newAttachedFiles: [], removedAttachedFileIndex: -1, selectedFilters: [], renderfilters: [], isComprehensive: false, isProcessing: false, spinnerMessage: ''
                }, () => {
                    //this.manageFilePlaceHolder();
                });
            } else {
                this.setState({ isProcessingNew: false })
            }
        }).catch((error) => {
            let isRemoveFile = this.state.removedAttachedFileIndex !== -1;
            this.setState({ newAttachedFiles: [], removedAttachedFileIndex: -1, isProcessing: false, spinnerMessage: '' }, () => {
                if (isRemoveFile) {
                    this.errorAlertMessage(`Remove document failed to some reason. Kindly try after some time.`)
                } else {
                    this.errorAlertMessage(`Upload failed due to some reason. Kindly try after some time.<br /><br /><p class='alertmessage-file-label'>Documents name</p> - ${newAttachedFiles.map(x => x.name).join("<br /> - ")}`)
                }
            });

            console.log(error)
        }).finally(() => {

        });

    }
    multipleFilesUpload = async (e) => {
        this.setState({ isProcessingNew: true, focusDropDownCollapsed: false, attachedFilePopupCollapsed: false });
        let { attachedFiles, sessionID, updateAnyFile, newAttachedFiles, removedAttachedFileIndex, newThreadID } = this.state;
        //let LocationOrigin = 'https://predev-ims.jnj.com';
        var url = `${LocationOrigin}${process.env.REACT_APP_IMS_API_MULTI_ANSWERS}multi_upload`
        if (window.location.origin === 'https://predev-ims.jnj.com') {
            url = `${window.location.origin}${process.env.REACT_APP_IMS_API_MULTI_ANSWERS}multi_upload`
        }
        const formData = new FormData();
        attachedFiles.concat(newAttachedFiles).filter((file, fileIndex) => fileIndex !== removedAttachedFileIndex && !file.name.toLowerCase().endsWith('.txt')).map((item, index) => {
            formData.append(`file${index + 1}`, item);
            formData.append(`fileGuid${index + 1}`, item.guid);
            formData.append(`newFileName${index + 1}`, item.newFileName);
        })
        formData.append(`fileCount`, attachedFiles.concat(newAttachedFiles).filter((file, fileIndex) => fileIndex !== removedAttachedFileIndex).length);
        formData.append(`sessionID`, sessionID);
        formData.append(`threadID`, newThreadID);
        formData.append(`username`, localStorage.getItem('username').toLowerCase().replace(/"/g, ''));
        formData.append(`updateAnyFile`, false);
        const _headers = {
            'content-type': 'multipart/form-data'
        }
        if (await Authentication.isAccessTokenAvailable()) {
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }
        let config = {
            method: 'POST',
            url: url,
            headers: _headers,
            data: formData,
            timeout: _timeoutTime
        }
        await axios(config).then((resp) => {
            let response = resp.data;
            if (response.FileUpload) {
                let isRemoveFile = this.state.removedAttachedFileIndex !== -1;
                let isSingleFile = newAttachedFiles.length === 1;
                let fil_selected_source = this.state.isSorcePanelSelectAll ? attachedFiles.concat(newAttachedFiles).filter((file, fileIndex) => fileIndex !== removedAttachedFileIndex) : this.state.selectedFileSource
                //console.log(attachedFiles.concat(newAttachedFiles).filter((file, fileIndex) => fileIndex !== removedAttachedFileIndex))
                this.setState({
                    updateAnyFile: true, attachedFiles: attachedFiles.concat(newAttachedFiles).filter((file, fileIndex) => fileIndex !== removedAttachedFileIndex), newAttachedFiles: [], removedAttachedFileIndex: -1, threadID: newThreadID, selectedFilters: [], renderfilters: [], isComprehensive: false,
                    isFromSideBar: false, orignalText: '', commandText: '', selectedFileSource: fil_selected_source
                }, async () => {
                    //this.manageFilePlaceHolder();
                    if (isRemoveFile) {
                        this.successAlertMessage("Document removed successfully.");
                    } else {
                        this.successAlertMessage(isSingleFile ? `Document uploaded successfully.` : `Documents uploaded successfully.`);
                    }
                });
            } else if (!response.FileUpload && response.Files && response.Files.length === 0) {
                this.errorAlertMessage(`Upload failed due to some reason. Kindly try after some time.<br /><br /><p class='alertmessage-file-label'>Documents name</p> - ${newAttachedFiles.map(x => x.name).join("<br /> - ")}`)
                this.setState({ updateAnyFile: true, newAttachedFiles: [], removedAttachedFileIndex: -1, selectedFilters: [], renderfilters: [], isComprehensive: false, }, async () => {
                    //this.manageFilePlaceHolder();
                    //await this.context.updateSessionId(sessionID);
                });
            }
            else if (!response.FileUpload && response.Files && response.Files.length > 0) {
                let failedGuid = response.Files.map(x => x.Guid)
                let finalFaileAttached = attachedFiles.concat(newAttachedFiles).filter((file, fileIndex) => fileIndex !== removedAttachedFileIndex).filter(x => failedGuid.includes(x.guid));
                this.errorAlertMessage(`Upload failed due to some reason. Kindly try after some time.<br /><br /><p class='alertmessage-file-label'>Documents name</p> - ${finalFaileAttached.map(x => x.name).join("<br /> - ")}`)
                this.setState({
                    updateAnyFile: true, attachedFiles: attachedFiles.concat(newAttachedFiles).filter((file, fileIndex) => fileIndex !== removedAttachedFileIndex).filter(x => !failedGuid.includes(x.guid)),
                    newAttachedFiles: [], removedAttachedFileIndex: -1, selectedFilters: [], renderfilters: [], isComprehensive: false,
                }, async () => {
                    //this.manageFilePlaceHolder();
                    //await this.context.updateSessionId(sessionID);
                });
            }
            // this.setState({ updateAnyFile: true, attachedFiles: attachedFiles.concat(newAttachedFiles).filter((file, fileIndex) => fileIndex !== removedAttachedFileIndex), newAttachedFiles: [], removedAttachedFileIndex: -1, threadID: newThreadID, chatHistory: [] }, async () => {
            //     this.manageFilePlaceHolder();
            //     await this.context.updateSessionId(sessionID);
            // });

        }).catch((error) => {
            let isRemoveFile = this.state.removedAttachedFileIndex !== -1;
            this.setState({ newAttachedFiles: [], removedAttachedFileIndex: -1 }, () => {
                if (isRemoveFile) {
                    this.errorAlertMessage(`Remove document failed to some reason. Kindly try after some time.`)
                } else {
                    this.errorAlertMessage(`Upload failed due to some reason. Kindly try after some time.<br /><br /><p class='alertmessage-file-label'>Documents name</p> - ${newAttachedFiles.map(x => x.name).join("<br /> - ")}`)
                }
            });

            console.log(error)
        }).finally(() => {
            this.setState({ isProcessingNew: false, spinnerMessage: '', commandType: 'QnA' });
        });
    }
    handleDeleteTxtSoureces = (removeIndex, removeFiles) => {
        let { attachedFiles, selectedFileSource } = this.state
        let new_attachedFiles = attachedFiles.filter((file, fileIndex) => fileIndex !== removeIndex);
        this.setState({ isProcessingNew: true, spinnerMessage: "Please wait..." }, () => {
            this.setState({
                attachedFiles: new_attachedFiles,
                newAttachedFiles: [],
                selectedFileSource: [],
                isAttachedFile: false,
                attachedFilePopupCollapsed: false,
                removedAttachedFileIndex: -1,
                updateAnyFile: false,
            }, async () => {
                try {
                    let { id } = removeFiles
                    let res = await services.deleteGenAINootBookSourceText(id)
                    this.setState({ isProcessingNew: false, spinnerMessage: "" })
                    this.successAlertMessage("Document removed successfully.");
                } catch (error) {
                    this.errorAlertMessage(error)
                }

            })
        })

    }
    handleDeleteFilesSoureces = (removeIndex, removeFiles) => {
        let { attachedFiles, selectedFileSource, sessionID } = this.state
        let new_attachedFiles = attachedFiles.filter((file, fileIndex) => fileIndex !== removeIndex && !file.name.toLowerCase().endsWith('.txt'));
        if (new_attachedFiles && new_attachedFiles.length === 0) {
            this.setState({ isProcessingNew: true, spinnerMessage: "Please wait..." }, async () => {
                let _isDeleted = await this.handleDeleteFileFromS3(sessionID)
                if (_isDeleted) {
                    let fil_selected = this.state.isSorcePanelSelectAll ? attachedFiles.filter(x => x.name.toLowerCase().endsWith('.txt')) : this.state.selectedFileSource
                    this.setState({
                        attachedFiles: attachedFiles.filter(x => x.name.toLowerCase().endsWith('.txt')),
                        newAttachedFiles: [],
                        selectedFileSource: (this.state.isSorcePanelSelectAll) && attachedFiles.filter(x => x.name.toLowerCase().endsWith('.txt')),
                        isAttachedFile: false,
                        attachedFilePopupCollapsed: false,
                        removedAttachedFileIndex: -1,
                        updateAnyFile: false
                    }, async () => {
                        let { sessionID } = this.state;
                        let response = await aps.deleteIndexBySessionId(sessionID);
                        this.successAlertMessage("Document removed successfully.");
                        this.setState({ isProcessingNew: false, spinnerMessage: "" });
                    })
                } else {
                    this.setState({ isProcessingNew: false, spinnerMessage: "" })
                }
            })
        } else {
            this.setState({ removedAttachedFileIndex: removeIndex, spinnerMessage: "Please wait..." }, () => {
                this.handleSaveInS3(removeFiles)
            })
        }
        // let selected_new = selectedFileSource.filter( file => !file.name.toLowerCase().endsWith('.txt') && file.guid !== removeFiles.guid)
        // 
        // if (new_attachedFiles.length > 0) {

        // }
        // else {
        //     let fil_selected = this.state.isSorcePanelSelectAll ? attachedFiles.filter(x => x.name.toLowerCase().endsWith('.txt')) : this.state.selectedFileSource
        //     this.setState({
        //         attachedFiles: attachedFiles.filter(x => x.name.toLowerCase().endsWith('.txt')),
        //         newAttachedFiles: [],
        //         selectedFileSource: (this.state.isSorcePanelSelectAll) && attachedFiles.filter(x => x.name.toLowerCase().endsWith('.txt')),
        //         isAttachedFile: false,
        //         attachedFilePopupCollapsed: false,
        //         removedAttachedFileIndex: -1,
        //         updateAnyFile: false,
        //     }, async () => {
        //         let { sessionID } = this.state;
        //         let response = await aps.deleteIndexBySessionId(sessionID);
        //         this.successAlertMessage("Document removed successfully.");
        //     })
        // }
    }
    handleBackButton = () => {
        this.props.history.push({
            pathname: '/Authoring-AI'
        })
    }
    setLeftProcessing = (val) => {
        this.setState({ leftIsProcessing: val })
    }
    setRightProcessing = (val) => {
        this.setState({ rightIsProcessing: val })
    }
    setMiddleProcessing = (val) => {
        this.setState({ middleIsProcessing: val })
    }
    render() {
        let { commandType, attachedFiles, spinnerMessage } = this.state
        return (
            <div className='notebook-genai-pages' style={{ background: '#F9F8F7' }}>
                <header className='notebook-genai-header' role="banner">
                    <div className='notebook-genai-headerInner'>
                        <div className="Note-Book-header-close" title="Back" onClick={this.handleBackButton}>
                            <svg fill="#EB1007" width="20px" height="20px" viewBox="0 0 52 52" data-name="Layer 1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M50,24H6.83L27.41,3.41a2,2,0,0,0,0-2.82,2,2,0,0,0-2.82,0l-24,24a1.79,1.79,0,0,0-.25.31A1.19,1.19,0,0,0,.25,25c0,.07-.07.13-.1.2l-.06.2a.84.84,0,0,0,0,.17,2,2,0,0,0,0,.78.84.84,0,0,0,0,.17l.06.2c0,.07.07.13.1.2a1.19,1.19,0,0,0,.09.15,1.79,1.79,0,0,0,.25.31l24,24a2,2,0,1,0,2.82-2.82L6.83,28H50a2,2,0,0,0,0-4Z"></path></g></svg>
                        </div>
                        <div className="pubmed-main-ask-question-headerWithBanner-left">
                            <Link to="/">
                                <img
                                    className="bm-agent-image"
                                    src={JJ_IMedical_icon}
                                    alt="iMS profile image"
                                    style={{ padding: '2.5px', margin: '0.75%', height: "34px" }}
                                />
                            </Link>
                        </div>
                        <div class='notebook-authoring-conc'>
                            <div className='notebook-genai-brandBlock'>

                                <div className='notebook-genai-brandLine'>
                                    {/*<span className='notebook-genai-brandSmall'>Content Center-AI</span>*/}
                                    <span className='notebook-genai-brandSmall'>Authoring.AI</span>
                                </div>
                            </div>

                            <div className='notebook-genai-userArea'>
                                <button
                                    className='notebook-genai-profile'
                                    aria-label="Open profile menu"
                                    title="User menu"
                                >
                                    <span className='notebook-genai-profileInitials'>{UserData.jnjMSUsername.slice(0, 2)}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </header>
                <div style={{ display: 'flex', flexDirection: 'row', height: `calc( 100vh - 150px)`, gap: '20px' }}>
                    <SourcesPanel
                        attachedFiles={attachedFiles}
                        selectedFileSource={this.state.selectedFileSource}
                        handleAttachedFile={this.handleSetSelectedAttachedFiles}
                        isExistingProject={this.state.isExistingProject}
                        commandType={this.state.commandType}
                        handleAttachedFiles={this.handleAttachedFiles}
                        updateSourceTextOfDb={this.updateSourceTextOfDb}
                        notebookTitle={this.state.selectedNotebookName}
                        currentSessionID={this.state.sessionID}
                        handleClickOnCitationNumber={this.handleClickOnCitationNumber}
                        handleDeleteFilesSoureces={this.handleDeleteFilesSoureces}
                        handleDeleteTxtSoureces={this.handleDeleteTxtSoureces}
                        leftIsProcessing={this.state.leftIsProcessing}
                        setLeftProcessing={this.setLeftProcessing}
                        citationTextId={this.state.citationTextId}
                        handleCitationTextId={() => this.setState({ citationTextId: '' })}
                        updateSelectAll={this.updateSelectAll} />
                    <div className="notebook-chat-container">
                        <header className="sources-header" style={{ width: '100%' }}>
                            <div className="header-left" style={{ justifyContent: 'space-between', width: '100%' }}>
                                <div style={{ display: 'flex', gap: '4px' }}>
                                    <div className="header-icon" aria-hidden="true">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                            <g clip-path="url(#clip0_309_9197)">
                                                <path d="M9.16658 13.75L6.3476 16.6042C5.95439 17.0024 5.75778 17.2014 5.58879 17.2155C5.44218 17.2276 5.29863 17.1687 5.20288 17.057C5.09251 16.9283 5.09251 16.6485 5.09251 16.0889V14.659C5.09251 14.157 4.6814 13.7937 4.18469 13.721C2.98252 13.5449 2.03838 12.6007 1.86229 11.3986C1.83325 11.2003 1.83325 10.9638 1.83325 10.4907V6.23334C1.83325 4.69319 1.83325 3.92312 2.13298 3.33486C2.39664 2.81742 2.81733 2.39672 3.33478 2.13307C3.92304 1.83334 4.69311 1.83334 6.23325 1.83334H13.0166C14.5567 1.83334 15.3268 1.83334 15.9151 2.13307C16.4325 2.39672 16.8532 2.81742 17.1169 3.33486C17.4166 3.92312 17.4166 4.69319 17.4166 6.23334V10.0833M17.4166 20.1667L15.4215 18.7796C15.1411 18.5847 15.0009 18.4872 14.8483 18.4181C14.7128 18.3567 14.5704 18.3121 14.4242 18.2851C14.2594 18.2548 14.0887 18.2548 13.7471 18.2548H12.0999C11.0732 18.2548 10.5598 18.2548 10.1676 18.0549C9.82264 17.8792 9.54217 17.5987 9.36641 17.2537C9.16659 16.8616 9.16658 16.3482 9.16658 15.3214V13.0167C9.16658 11.9899 9.16659 11.4765 9.36641 11.0844C9.54217 10.7394 9.82264 10.4589 10.1676 10.2832C10.5598 10.0833 11.0732 10.0833 12.0999 10.0833H17.2333C18.26 10.0833 18.7734 10.0833 19.1656 10.2832C19.5105 10.4589 19.791 10.7394 19.9668 11.0844C20.1666 11.4765 20.1666 11.9899 20.1666 13.0167V15.5048C20.1666 16.359 20.1666 16.7861 20.027 17.123C19.841 17.5722 19.4841 17.9291 19.0348 18.1152C18.6979 18.2548 18.2708 18.2548 17.4166 18.2548V20.1667Z" stroke="#212121" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_309_9197">
                                                    <rect width="22" height="22" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                    <h2 id="sources-title" className="title">Chat</h2>
                                </div>
                                <div className="header-actions" style={{ width: 'auto' }}>
                                    <button className="source-btn wd-100px" type="button" aria-label="Refresh" onClick={this.handleRefresh}
                                        disabled={this.state.isChatConversationSpinner}>
                                        <span className="btn-icon" aria-hidden="true">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <g clip-path="url(#clip0_595_381)">
                                                    <path d="M14.6662 6.66667C14.6662 6.66667 13.3296 4.84548 12.2437 3.75883C11.1579 2.67218 9.65733 2 7.99979 2C4.6862 2 2 4.68629 2 8C2 11.3137 4.6862 14 7.99979 14C10.7351 14 13.0429 12.1695 13.7651 9.66667M14.6662 6.66667V2.66667M14.6662 6.66667H10.6664" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_595_381">
                                                        <rect width="15.9994" height="16" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </span>
                                        <span className="btn-text">Clear Chat</span>
                                    </button>
                                    <button className='source-btn wd-0' title="Configure" aria-label="Configure" onClick={() => this.setState({ isConfigure: true })}>
                                        <svg fill="#000000" width="22px" height="22px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
                                            <g>
                                                <path d="M24,19.171c-1.165,0.412 -2,1.524 -2,2.829c-0,1.305 0.835,2.417 2,2.829l-0,2.171c0,0.552 0.448,1 1,1c0.552,-0 1,-0.448 1,-1l-0,-2.171c1.165,-0.412 2,-1.524 2,-2.829c-0,-1.305 -0.835,-2.417 -2,-2.829l-0,-14.183c0,-0.552 -0.448,-1 -1,-1c-0.552,-0 -1,0.448 -1,1l-0,14.183Zm1,1.829c0.552,0 1,0.448 1,1c-0,0.552 -0.448,1 -1,1c-0.552,0 -1,-0.448 -1,-1c-0,-0.552 0.448,-1 1,-1Z" />
                                                <path d="M15.006,7.159c-1.164,0.412 -2,1.523 -2,2.829c0,1.305 0.836,2.417 2,2.829l0,14.183c0,0.552 0.448,1 1,1c0.552,0 1,-0.448 1,-1l0,-14.183c1.165,-0.412 2,-1.524 2,-2.829c0,-1.306 -0.835,-2.417 -2,-2.829l0,-2.171c0,-0.552 -0.448,-1 -1,-1c-0.552,-0 -1,0.448 -1,1l0,2.171Zm1,3.829c-0.552,-0 -1,-0.448 -1,-1c0,-0.552 0.448,-1 1,-1c0.552,-0 1,0.448 1,1c0,0.552 -0.448,1 -1,1Z" />
                                                <path d="M6,19.176c-1.157,0.416 -1.986,1.524 -1.986,2.824c-0,1.3 0.829,2.408 1.986,2.824l0,2.176c-0,0.552 0.448,1 1,1c0.552,0 1,-0.448 1,-1l0,-2.166c1.172,-0.408 2.014,-1.524 2.014,-2.834c-0,-1.31 -0.842,-2.426 -2.014,-2.834l0,-14.178c-0,-0.552 -0.448,-1 -1,-1c-0.552,-0 -1,0.448 -1,1l0,14.188Zm1.014,3.824c-0.552,0 -1,-0.448 -1,-1c-0,-0.552 0.448,-1 1,-1c0.552,0 1,0.448 1,1c-0,0.552 -0.448,1 -1,1Z" />
                                            </g>
                                        </svg>

                                    </button>
                                </div>
                            </div>
                            <div className='source-header-divider'>
                                <div className="source-divider"></div>
                            </div>
                        </header>
                        <div className="noteBook-Source">
                            <><span>
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                                    <g clip-path="url(#clip0_309_9262)">
                                        <path d="M12.8334 10.0833H7.33341M9.16675 13.75H7.33341M14.6667 6.41666H7.33341M18.3334 6.23333V15.7667C18.3334 17.3068 18.3334 18.0769 18.0337 18.6651C17.77 19.1826 17.3493 19.6033 16.8319 19.8669C16.2436 20.1667 15.4736 20.1667 13.9334 20.1667H8.06675C6.5266 20.1667 5.75653 20.1667 5.16827 19.8669C4.65083 19.6033 4.23013 19.1826 3.96648 18.6651C3.66675 18.0769 3.66675 17.3068 3.66675 15.7667V6.23333C3.66675 4.69318 3.66675 3.92311 3.96648 3.33485C4.23013 2.81741 4.65083 2.39671 5.16827 2.13306C5.75653 1.83333 6.5266 1.83333 8.06675 1.83333H13.9334C15.4736 1.83333 16.2436 1.83333 16.8319 2.13306C17.3493 2.39671 17.77 2.81741 18.0337 3.33485C18.3334 3.92311 18.3334 4.69318 18.3334 6.23333Z" stroke="#212121" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_309_9262">
                                            <rect width="22" height="22" fill="white" />
                                        </clipPath>
                                    </defs>
                                </svg>
                            </span>
                                <div className="title pd-12 notebook-title">{this.state.selectedNotebookName}</div>
                            </>
                        </div>
                        <div class='noteBook-chat'>
                            <div className="notebook-chat-display">
                                {this.renderChatConversation()}
                            </div>
                            <div className={"notebook-section-height-before"} style={{ position: 'relative' }}>
                                <div className="notebook-question-section notebook-section-height-inc">
                                    <div className="notebook-section-maxH">
                                        <textarea placeholder="Start Typing...." className="notebook-quest-placeholder" value={this.state.commandText} onChange={(e) => this.handleCommandText(e)} onBlur={this.handleBlurInput} onInput={this.handleInputText} onClick={this.handleInputText} />
                                        {/* <button className='note-book-chat-icon' style={{ border: (this.state.commandText?.length > 0 || this.state.commandType === 'UserInstructions' || this.state.commandType === 'Summarize' || this.state.commandType === 'CreateTable') && '1px solid #EB1007', borderRadius: (this.state.commandText?.length > 0 || this.state.commandType === 'UserInstructions' || this.state.commandType === 'Summarize' || this.state.commandType === 'CreateTable') && '50%' }} type="button" onClick={this.onSubmitClick}> */}
                                        <button className='note-book-chat-icon' type="button" onClick={this.onSubmitClick}>
                                            <svg width="22px" height="22px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                                <g id="SVGRepo_iconCarrier">
                                                    <path d="M10.3009 13.6949L20.102 3.89742M10.5795 14.1355L12.8019 18.5804C13.339 19.6545 13.6075 20.1916 13.9458 20.3356C14.2394 20.4606 14.575 20.4379 14.8492 20.2747C15.1651 20.0866 15.3591 19.5183 15.7472 18.3818L19.9463 6.08434C20.2845 5.09409 20.4535 4.59896 20.3378 4.27142C20.2371 3.98648 20.013 3.76234 19.7281 3.66167C19.4005 3.54595 18.9054 3.71502 17.9151 4.05315L5.61763 8.2523C4.48114 8.64037 3.91289 8.83441 3.72478 9.15032C3.56153 9.42447 3.53891 9.76007 3.66389 10.0536C3.80791 10.3919 4.34498 10.6605 5.41912 11.1975L9.86397 13.42C10.041 13.5085 10.1295 13.5527 10.2061 13.6118C10.2742 13.6643 10.3352 13.7253 10.3876 13.7933C10.4468 13.87 10.491 13.9585 10.5795 14.1355Z" stroke="#EB1700" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                                                </g>
                                            </svg>
                                            {/* <svg xmlns="http://www.w3.org/2000/svg" style={{ transform: (this.state.commandText?.length > 0 || this.state.commandType === 'UserInstructions' || this.state.commandType === 'Summarize' || this.state.commandType === 'CreateTable') && 'rotate(45deg)' }} width="23" height="23" viewBox="0 0 23 23" fill={(this.state.commandText?.length > 0 || this.state.commandType === 'UserInstructions' || this.state.commandType === 'Summarize' || this.state.commandType === 'CreateTable') ? "#EB1007" : "none"}>
                                                <g clip-path="url(#clip0_595_829)">
                                                    <path d="M11.3133 12.7279L11.3131 2.82861M11.5281 12.8224L15.9527 14.7693C16.3425 14.9408 16.5374 15.0266 16.657 14.9889C16.7606 14.9563 16.8419 14.8751 16.8747 14.7715C16.9125 14.652 16.8269 14.457 16.6559 14.067L11.8015 2.9994C11.6471 2.64736 11.5699 2.47133 11.462 2.41745C11.3682 2.37066 11.258 2.37066 11.1642 2.41745C11.0563 2.47132 10.9791 2.64734 10.8247 2.99939L5.97074 14.0668C5.7997 14.4568 5.71418 14.6518 5.75199 14.7713C5.78476 14.8749 5.86601 14.9561 5.96968 14.9888C6.08928 15.0264 6.28417 14.9407 6.67395 14.7692L11.0985 12.8224C11.1776 12.7876 11.2172 12.7702 11.2583 12.7633C11.2947 12.7572 11.3319 12.7572 11.3683 12.7633C11.4094 12.7702 11.449 12.7876 11.5281 12.8224Z" stroke="#5A5A5A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_595_829">
                                                        <rect width="15.9994" height="16" fill="white" transform="translate(0 11.3133) rotate(-45)" />
                                                    </clipPath>
                                                </defs>
                                            </svg> */}
                                        </button>
                                    </div>
                                </div>
                            </div>
                            {/*<div className="notebook-question-section">
                                <div className="note-book-question-conc" style={{ width: '100%',position:'relative' }}>
                                    <textarea style={{ width: '100%', height: '30px',position:'absolute',bottom:'0',zIndex:'10' }} placeholder="Start Typing...." className="notebook-quest-placeholder" value={this.state.commandText} onChange={(e) => this.handleCommandText(e)} onInput={this.handleInputText}/>
                                </div>
                                <button type="button" onClick={this.onSubmitClick}><svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
                                    <g clip-path="url(#clip0_595_829)">
                                        <path d="M11.3133 12.7279L11.3131 2.82861M11.5281 12.8224L15.9527 14.7693C16.3425 14.9408 16.5374 15.0266 16.657 14.9889C16.7606 14.9563 16.8419 14.8751 16.8747 14.7715C16.9125 14.652 16.8269 14.457 16.6559 14.067L11.8015 2.9994C11.6471 2.64736 11.5699 2.47133 11.462 2.41745C11.3682 2.37066 11.258 2.37066 11.1642 2.41745C11.0563 2.47132 10.9791 2.64734 10.8247 2.99939L5.97074 14.0668C5.7997 14.4568 5.71418 14.6518 5.75199 14.7713C5.78476 14.8749 5.86601 14.9561 5.96968 14.9888C6.08928 15.0264 6.28417 14.9407 6.67395 14.7692L11.0985 12.8224C11.1776 12.7876 11.2172 12.7702 11.2583 12.7633C11.2947 12.7572 11.3319 12.7572 11.3683 12.7633C11.4094 12.7702 11.449 12.7876 11.5281 12.8224Z" stroke="#5A5A5A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </g>
                                    <defs>
                                        <clipPath id="clip0_595_829">
                                            <rect width="15.9994" height="16" fill="white" transform="translate(0 11.3133) rotate(-45)" />
                                        </clipPath>
                                    </defs>
                                </svg></button>
                            </div>*/}
                            {<NoteBookSlider
                                prompt={this.state.prompts}
                                handleAddTemplatePrompts={this.handleAddTemplatePrompts} />}
                            {/*<div className="mx-12" style={{ width: "100%", position: 'relative', display: 'flex', }}>
                                <div className="notebook-prompt-section">
                                    {(this.state.prompts.length > 0) ? this.state.prompts.map(x => <div className="notebook-prompts" onClick={()=>{this.setState({commandText:x.prompt})}}>
                                        <span className="noteBook-prop-text">{x.prompt}</span>
                                    </div>) : <div style={{ height: '60px', marginLeft: "12px" }}><span className="noteBook-prop-text">{'*No prompt selected'}</span></div>}
                                </div>
                                <div className="notebook-view-more">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M2.6665 8H13.3328M13.3328 8L9.33294 4M13.3328 8L9.33294 12" stroke="#212121" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </div>*/}
                            <div className='source-header-divider mx-12'>
                                <div className="source-divider"></div>
                            </div>
                            <div className="" style={{ display: 'flex', justifyContent: 'space-between', width: '100%', paddingTop: '6px' }}>
                                <div className="source-command-section">
                                    <span>Summary Type:</span>
                                    <div className="answering-authoring-command-dropdown-panel-gpt">
                                        <select
                                            className="answering-authoring-command-dropdown-gpt mx-0"
                                            style={{ color: '#EB1700' }}
                                            onChange={this.handleChangeCommandType}
                                            value={commandType}>
                                            <option value="QnA">QnA</option>
                                            <option value="UserInstructions">User Instructions​</option>
                                            <option value="CreateTable">Create Table​</option>
                                            <option value="Summarize">Summarize</option>
                                            <option value="Multi-Doc Summary">Multi-Doc Summary</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="source-command" onClick={() => { this.setState({ isShowPrompt: true }) }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <g clip-path="url(#clip0_595_457)">
                                            <path d="M6.6664 9.99998L4.6163 12.0758C4.33034 12.3653 4.18736 12.5101 4.06446 12.5203C3.95783 12.5292 3.85344 12.4863 3.7838 12.4051C3.70354 12.3114 3.70354 12.108 3.70354 11.701V10.661C3.70354 10.2959 3.40456 10.0318 3.04333 9.97886C2.16905 9.8508 1.48243 9.16415 1.35437 8.28984C1.33325 8.14568 1.33325 7.97366 1.33325 7.62961V4.53331C1.33325 3.41321 1.33325 2.85316 1.55123 2.42533C1.74297 2.04901 2.04892 1.74305 2.42523 1.5513C2.85304 1.33331 3.41307 1.33331 4.53314 1.33331H9.4663C10.5864 1.33331 11.1464 1.33331 11.5742 1.5513C11.9505 1.74305 12.2565 2.04901 12.4482 2.42533C12.6662 2.85316 12.6662 3.41321 12.6662 4.53331V7.33331M12.6662 14.6666L11.2153 13.6579C11.0113 13.5161 10.9094 13.4452 10.7984 13.3949C10.6999 13.3503 10.5963 13.3179 10.49 13.2983C10.3702 13.2762 10.246 13.2762 9.99756 13.2762H8.79966C8.05295 13.2762 7.67959 13.2762 7.39438 13.1308C7.14351 13.003 6.93954 12.799 6.81172 12.5482C6.6664 12.2629 6.6664 11.8896 6.6664 11.1428V9.46665C6.6664 8.71991 6.6664 8.34654 6.81172 8.06133C6.93954 7.81044 7.14351 7.60647 7.39438 7.47864C7.67959 7.33331 8.05295 7.33331 8.79966 7.33331H12.5329C13.2796 7.33331 13.6529 7.33331 13.9381 7.47864C14.189 7.60647 14.393 7.81044 14.5208 8.06133C14.6661 8.34654 14.6661 8.71991 14.6661 9.46665V11.2762C14.6661 11.8974 14.6661 12.2081 14.5646 12.4531C14.4293 12.7798 14.1697 13.0394 13.8431 13.1747C13.598 13.2762 13.2874 13.2762 12.6662 13.2762V14.6666Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                        </g>
                                        <defs>
                                            <clipPath id="clip0_595_457">
                                                <rect width="15.9994" height="16" fill="white" />
                                            </clipPath>
                                        </defs>
                                    </svg>
                                    <span style={{ color: '#FFFF' }}>Prompts</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <SummaryPanel
                        sessionID={this.state.sessionID}
                        savedSummary={this.state.savedSummary}
                        savedNotes={this.state.savedNotes}
                        selectedNotebookName={this.state.selectedNotebookName}
                        updateSummary={this.updateSummary}
                        deleteSummary={this.deleteSummary}
                        handleAddToSource={this.insertSourceTextToDb}
                        handeAddToNotes={this.handeAddToNotes}
                        handleAddToSummary={this.handleAddToSummary}
                        handleUpdateNotes={this.handleUpdateNotes}
                        handleDeleteNotes={this.handleDeleteNotes}
                        chatConversation={this.state.chatConversation}
                        rightIsProcessing={this.state.rightIsProcessing} />
                    {this.state.isProcessingNew &&
                        <Modal
                            show={this.state.isProcessingNew}
                            size="lg md sm xs"
                            centered
                            aria-labelledby="contained-modal-title-vcenter"
                            dialogClassName="savePopUp"
                            className="document-processing-newthread"
                            backdropClassName="document-processing-newthread-backdrop"
                            scrollable={true}>
                            <div style={{ padding: "0 5%" }}>
                                <div style={{ fontSize: "14px", textAlign: "center" }}>
                                    <Modal.Body>
                                        <img src={imsLoader} alt="" width={100} height={100} />
                                        <div className="saveModal-heading" style={{ color: "#EB1700" }}>{spinnerMessage ? spinnerMessage : `Please wait...`}</div>
                                    </Modal.Body>
                                </div>
                            </div>
                        </Modal>}
                    {this.state.isShowPrompt && <NoteBookPromptTemplates
                        showModal={this.state.isShowPrompt}
                        handleClose={this.handleCloseCommandList}
                        width={this.props.customWidth}
                        commandText={this.state.commandText}
                        handleAddToPromptTemplateText={this.handleAddToPromptTemplateText}
                        isUserPromptTemplate={this.state.isUserPromptTemplate}
                        isSystemPromptTemplate={this.state.isSystemPromptTemplate}
                        isFromGlobalFeaturesMenu={this.state.isFromGlobalFeaturesMenu}
                    />}
                    {this.state.expandSourceText && <ExpandContentModalNoteBook placeholder='Enter the source text here.' content={this.getCleanText(this.state.editText)} showModal={this.state.expandSourceText} handleSaveContent={this.handleSaveContent} />}
                    {this.state.alertMessageShowModal && <AlertMessagePopUpModal color={this.state.alertMessageModelColor} content={this.state.alertMessageContent} showModal={this.state.alertMessageShowModal} handleClose={() => this.closeAlertMessage()} />}
                    {this.state.isConfigure && <NoteBookConfigurePopUp
                        showModal={this.state.isConfigure}
                        handleClose={(val) => { this.setState({ isConfigure: val }) }}
                        configActiveTab={this.state.configActiveTab}
                        configResponseLength={this.state.configResponseLength}
                        configConversationa={this.state.configConversationa}
                        handleConfigSave={this.handleConfigSave} />}
                </div>
            </div>
        )
    }
}
export default withRouter(NoteBookAuthoringIndex);